var _____WB$wombat$assign$function_____ = function(name) {
    return (globalThis._wb_wombat && globalThis._wb_wombat.local_init && globalThis._wb_wombat.local_init(name)) || globalThis[name];
};
if (!globalThis.__WB_pmw) {
    globalThis.__WB_pmw = function(obj) {
        this.__WB_source = obj;
        return this;
    }
}
var window = _____WB$wombat$assign$function_____("window");
var self = _____WB$wombat$assign$function_____("self");
var document = _____WB$wombat$assign$function_____("document");
var location = _____WB$wombat$assign$function_____("location");
var top = _____WB$wombat$assign$function_____("top");
var parent = _____WB$wombat$assign$function_____("parent");
var frames = _____WB$wombat$assign$function_____("frames");
var opener = _____WB$wombat$assign$function_____("opener");
var _CopyButton_instances, copyToClipboard_fn, __typeError = e => {
    throw TypeError(e)
}
, __accessCheck = (e, t, i) => t.has(e) || __typeError("Cannot " + i), __privateGet = (e, t, i) => (__accessCheck(e, t, "read from private field"),
i ? i.call(e) : t.get(e)), __privateAdd = (e, t, i) => t.has(e) ? __typeError("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, i), __privateSet = (e, t, i, n) => (__accessCheck(e, t, "write to private field"),
n ? n.call(e, i) : t.set(e, i),
i), __privateMethod = (e, t, i) => (__accessCheck(e, t, "access private method"),
i), ConfirmButton = class extends HTMLElement {
    constructor() {
        super(),
        this.addEventListener("click", e => {
            window.confirm(this.getAttribute("data-message") ?? "Once confirmed, this action cannot be undone.") || e.preventDefault()
        }
        )
    }
}
;
window.customElements.get("confirm-button") || window.customElements.define("confirm-button", ConfirmButton);
var _ShareButton_instances, showSystemShare_fn, CopyButton = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _CopyButton_instances),
        this.addEventListener("click", __privateMethod(this, _CopyButton_instances, copyToClipboard_fn))
    }
    get buttonElement() {
        return this.querySelector("button")
    }
}
;
_CopyButton_instances = new WeakSet,
copyToClipboard_fn = async function() {
    if (navigator.clipboard && (await navigator.clipboard.writeText(this.getAttribute("data-text") ?? ""),
    this.hasAttribute("data-success-message"))) {
        const e = this.buttonElement.textContent;
        this.buttonElement.textContent = this.getAttribute("data-success-message"),
        setTimeout( () => {
            this.buttonElement.textContent = e
        }
        , 1500)
    }
}
,
window.customElements.get("copy-button") || window.customElements.define("copy-button", CopyButton);
var _currentAnimation, _MarqueeText_instances, direction_get, scroller_get, initialize_fn, ShareButton = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _ShareButton_instances),
        navigator.share && (this.querySelector(".share-buttons--native").hidden = !1,
        this.addEventListener("click", __privateMethod(this, _ShareButton_instances, showSystemShare_fn)))
    }
}
;
_ShareButton_instances = new WeakSet,
showSystemShare_fn = async function() {
    try {
        await navigator.share({
            title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
            url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
        })
    } catch {}
}
,
window.customElements.get("share-button") || window.customElements.define("share-button", ShareButton);
import {inView, animate} from "vendor";
var _domElement, _thresholdDistance, _thresholdTime, _signal, _firstClientX, _tracking, _start, _GestureArea_instances, touchStart_fn, preventTouch_fn, gestureStart_fn, gestureMove_fn, gestureEnd_fn, MarqueeText = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _MarqueeText_instances),
        __privateAdd(this, _currentAnimation),
        inView(this, __privateMethod(this, _MarqueeText_instances, initialize_fn).bind(this), {
            margin: "400px"
        }),
        this.hasAttribute("pause-on-hover") && (this.addEventListener("pointerenter", () => __privateGet(this, _currentAnimation)?.pause()),
        this.addEventListener("pointerleave", () => __privateGet(this, _currentAnimation)?.play()))
    }
}
;
_currentAnimation = new WeakMap,
_MarqueeText_instances = new WeakSet,
direction_get = function() {
    return this.getAttribute("direction") === "right" ? 1 : -1
}
,
scroller_get = function() {
    return this.shadowRoot.querySelector('[part="scroller"]')
}
,
initialize_fn = function() {
    if (this.children[0]?.childElementCount === 0)
        return;
    this.attachShadow({
        mode: "open"
    }).appendChild(document.createRange().createContextualFragment(`
      <slot part="scroller"></slot>
    `));
    const e = document.createDocumentFragment()
      , t = Math.ceil(this.clientWidth / this.firstElementChild.clientWidth);
    for (let i = 1; i <= t; ++i)
        for (let t2 = 0; t2 < 2; ++t2) {
            const n = this.firstElementChild.cloneNode(!0)
              , a = 100 * i * (t2 % 2 == 0 ? -1 : 1);
            n.setAttribute("aria-hidden", "true"),
            n.style.cssText = `position: absolute; inset-inline-start: calc(${a}%);`,
            e.appendChild(n)
        }
    this.append(e),
    __privateSet(this, _currentAnimation, animate(__privateGet(this, _MarqueeText_instances, scroller_get), {
        transform: ["translateX(0)", `translateX(calc(var(--transform-logical-flip) * ${100 * __privateGet(this, _MarqueeText_instances, direction_get)}%))`]
    }, {
        duration: 1 / parseFloat(this.getAttribute("speed")) * (__privateGet(this, _MarqueeText_instances, scroller_get).clientWidth / 300),
        easing: "linear",
        repeat: 1 / 0
    }))
}
,
window.customElements.get("marquee-text") || window.customElements.define("marquee-text", MarqueeText);
var _onCountryChangedListener, _CountrySelector_instances, onCountryChanged_fn, GestureArea = class {
    constructor(e, {thresholdDistance: t=80, thresholdTime: i=500, signal: n=null}={}) {
        __privateAdd(this, _GestureArea_instances),
        __privateAdd(this, _domElement),
        __privateAdd(this, _thresholdDistance),
        __privateAdd(this, _thresholdTime),
        __privateAdd(this, _signal),
        __privateAdd(this, _firstClientX),
        __privateAdd(this, _tracking, !1),
        __privateAdd(this, _start, {}),
        __privateSet(this, _domElement, e),
        __privateSet(this, _thresholdDistance, t),
        __privateSet(this, _thresholdTime, i),
        __privateSet(this, _signal, n ?? new AbortController().signal),
        __privateGet(this, _domElement).addEventListener("touchstart", __privateMethod(this, _GestureArea_instances, touchStart_fn).bind(this), {
            passive: !0,
            signal: __privateGet(this, _signal)
        }),
        __privateGet(this, _domElement).addEventListener("touchmove", __privateMethod(this, _GestureArea_instances, preventTouch_fn).bind(this), {
            passive: !1,
            signal: __privateGet(this, _signal)
        }),
        __privateGet(this, _domElement).addEventListener("pointerdown", __privateMethod(this, _GestureArea_instances, gestureStart_fn).bind(this), {
            signal: __privateGet(this, _signal)
        }),
        __privateGet(this, _domElement).addEventListener("pointermove", __privateMethod(this, _GestureArea_instances, gestureMove_fn).bind(this), {
            passive: !1,
            signal: __privateGet(this, _signal)
        }),
        __privateGet(this, _domElement).addEventListener("pointerup", __privateMethod(this, _GestureArea_instances, gestureEnd_fn).bind(this), {
            signal: __privateGet(this, _signal)
        }),
        __privateGet(this, _domElement).addEventListener("pointerleave", __privateMethod(this, _GestureArea_instances, gestureEnd_fn).bind(this), {
            signal: __privateGet(this, _signal)
        }),
        __privateGet(this, _domElement).addEventListener("pointercancel", __privateMethod(this, _GestureArea_instances, gestureEnd_fn).bind(this), {
            signal: __privateGet(this, _signal)
        })
    }
}
;
_domElement = new WeakMap,
_thresholdDistance = new WeakMap,
_thresholdTime = new WeakMap,
_signal = new WeakMap,
_firstClientX = new WeakMap,
_tracking = new WeakMap,
_start = new WeakMap,
_GestureArea_instances = new WeakSet,
touchStart_fn = function(e) {
    __privateSet(this, _firstClientX, e.touches[0].clientX)
}
,
preventTouch_fn = function(e) {
    Math.abs(e.touches[0].clientX - __privateGet(this, _firstClientX)) > 10 && e.preventDefault()
}
,
gestureStart_fn = function(e) {
    __privateSet(this, _tracking, !0),
    __privateSet(this, _start, {
        time: new Date().getTime(),
        x: e.clientX,
        y: e.clientY
    })
}
,
gestureMove_fn = function(e) {
    __privateGet(this, _tracking) && e.preventDefault()
}
,
gestureEnd_fn = function(e) {
    if (!__privateGet(this, _tracking))
        return;
    __privateSet(this, _tracking, !1);
    const t = new Date().getTime() - __privateGet(this, _start).time
      , i = e.clientX - __privateGet(this, _start).x
      , n = e.clientY - __privateGet(this, _start).y;
    if (t > __privateGet(this, _thresholdTime))
        return;
    let a;
    i === 0 && n === 0 ? a = "tap" : i > __privateGet(this, _thresholdDistance) && Math.abs(n) < __privateGet(this, _thresholdDistance) ? a = "swiperight" : -i > __privateGet(this, _thresholdDistance) && Math.abs(n) < __privateGet(this, _thresholdDistance) ? a = "swipeleft" : n > __privateGet(this, _thresholdDistance) && Math.abs(i) < __privateGet(this, _thresholdDistance) ? a = "swipedown" : -n > __privateGet(this, _thresholdDistance) && Math.abs(i) < __privateGet(this, _thresholdDistance) && (a = "swipeup"),
    a && __privateGet(this, _domElement).dispatchEvent(new CustomEvent(a,{
        bubbles: !0,
        composed: !0,
        detail: {
            originalEvent: e
        }
    }))
}
;
var CountrySelector = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _CountrySelector_instances),
        __privateAdd(this, _onCountryChangedListener, __privateMethod(this, _CountrySelector_instances, onCountryChanged_fn).bind(this))
    }
    connectedCallback() {
        this.countryElement = this.querySelector('[name="address[country]"]'),
        this.provinceElement = this.querySelector('[name="address[province]"]'),
        this.countryElement.addEventListener("change", __privateGet(this, _onCountryChangedListener)),
        this.hasAttribute("country") && this.getAttribute("country") !== "" && (this.countryElement.selectedIndex = Math.max(0, Array.from(this.countryElement.options).findIndex(e => e.textContent === this.getAttribute("country")))),
        this.countryElement.dispatchEvent(new Event("change"))
    }
    disconnectedCallback() {
        this.countryElement.removeEventListener("change", __privateGet(this, _onCountryChangedListener))
    }
}
;
_onCountryChangedListener = new WeakMap,
_CountrySelector_instances = new WeakSet,
onCountryChanged_fn = function() {
    const e = this.countryElement.options[this.countryElement.selectedIndex]
      , t = JSON.parse(e.getAttribute("data-provinces"));
    this.provinceElement.parentElement.hidden = t.length === 0,
    t.length !== 0 && (this.provinceElement.innerHTML = "",
    t.forEach(e2 => {
        const t2 = e2[1] === this.getAttribute("province") || e2[0] === this.getAttribute("province");
        this.provinceElement.options.add(new Option(e2[1],e2[0],t2,t2))
    }
    ))
}
,
window.customElements.get("country-selector") || window.customElements.define("country-selector", CountrySelector);
var _callback, _duration, _remainingTime, _startTime, _timer, _state, _onVisibilityChangeListener, _mustResumeOnVisibility, _Player_instances, onVisibilityChange_fn, cachedMap = new Map;
function cachedFetch(e, t) {
    const i = e;
    return cachedMap.has(i) ? Promise.resolve(new Response(new Blob([cachedMap.get(i)]))) : fetch(e, t).then(e2 => {
        if (e2.status === 200) {
            const t2 = e2.headers.get("Content-Type");
            t2 && (t2.match(/application\/json/i) || t2.match(/text\//i)) && e2.clone().text().then(e3 => {
                cachedMap.set(i, e3)
            }
            )
        }
        return e2
    }
    )
}
function extractSectionId(e) {
    return (e = e.classList.contains("shopify-section") ? e : e.closest(".shopify-section")).id.replace("shopify-section-", "")
}
function deepQuerySelector(e, t) {
    let i = e.querySelector(t);
    if (i)
        return i;
    for (const n of e.querySelectorAll("template"))
        if (i = deepQuerySelector(n.content, t),
        i)
            return i;
    return null
}
function throttle(e) {
    let t, i = null;
    const n = (...n2) => {
        var a;
        t = n2,
        i === null && (i = requestAnimationFrame((a = this,
        () => {
            i = null,
            e.apply(a, t)
        }
        )))
    }
    ;
    return n.cancel = () => {
        cancelAnimationFrame(i),
        i = null
    }
    ,
    n
}
function debounce(e, t) {
    let i = null;
    return (...n) => {
        clearTimeout(i),
        i = setTimeout( () => {
            e.apply(this, n)
        }
        , t)
    }
}
function waitForEvent(e, t) {
    return new Promise(i => {
        const n = a => {
            a.target === e && (e.removeEventListener(t, n),
            i(a))
        }
        ;
        e.addEventListener(t, n)
    }
    )
}
function videoLoaded(e) {
    return e ? (e = e instanceof Element ? [e] : Array.from(e),
    Promise.all(e.map(e2 => new Promise(t => {
        e2.tagName === "VIDEO" && e2.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA || !e2.offsetParent || e2.parentNode.hasAttribute("suspended") ? t() : e2.oncanplay = () => t()
    }
    )))) : Promise.resolve()
}
function imageLoaded(e) {
    return e ? (e = e instanceof Element ? [e] : Array.from(e),
    Promise.all(e.map(e2 => new Promise(t => {
        e2.tagName === "IMG" && e2.complete || !e2.offsetParent ? t() : e2.onload = () => t()
    }
    )))) : Promise.resolve()
}
function generateSrcset(e, t=[]) {
    let i, n;
    return typeof e == "string" ? (i = new URL(e.startsWith("//") ? `https:${e}` : e),
    n = parseInt(i.searchParams.get("width"))) : (i = new URL(e.src.startsWith("//") ? `https:${e.src}` : e.src),
    n = e.width),
    t.filter(e2 => e2 <= n).map(e2 => (i.searchParams.set("width", e2.toString()),
    `${i.href} ${e2}w`)).join(", ")
}
function createMediaImg(e, t=[], i={}) {
    const n = new Image(e.preview_image.width,e.preview_image.height)
      , a = e.preview_image.src
      , s = new URL(a.startsWith("//") ? `https:${a}` : a);
    for (const e2 in i)
        n.setAttribute(e2, i[e2]);
    return n.alt = e.alt || "",
    n.src = s.href,
    n.srcset = generateSrcset(e.preview_image, t),
    n
}
function matchesMediaQuery(e) {
    if (!window.themeVariables.mediaQueries.hasOwnProperty(e))
        throw `Media query ${e} does not exist`;
    return window.matchMedia(window.themeVariables.mediaQueries[e]).matches
}
function mediaQueryListener(e, t) {
    if (!window.themeVariables.mediaQueries.hasOwnProperty(e))
        throw `Media query ${e} does not exist`;
    return window.matchMedia(window.themeVariables.mediaQueries[e]).addEventListener("change", t)
}
var Player = class extends EventTarget {
    constructor(e, t=!0) {
        super(),
        __privateAdd(this, _Player_instances),
        __privateAdd(this, _callback),
        __privateAdd(this, _duration),
        __privateAdd(this, _remainingTime),
        __privateAdd(this, _startTime),
        __privateAdd(this, _timer),
        __privateAdd(this, _state, "paused"),
        __privateAdd(this, _onVisibilityChangeListener, __privateMethod(this, _Player_instances, onVisibilityChange_fn).bind(this)),
        __privateAdd(this, _mustResumeOnVisibility, !0),
        __privateSet(this, _callback, () => this.dispatchEvent(new CustomEvent("player:end"))),
        __privateSet(this, _duration, __privateSet(this, _remainingTime, 1e3 * e)),
        t && document.addEventListener("visibilitychange", __privateGet(this, _onVisibilityChangeListener))
    }
    pause() {
        __privateGet(this, _state) === "started" && (clearTimeout(__privateGet(this, _timer)),
        __privateSet(this, _state, "paused"),
        __privateSet(this, _remainingTime, __privateGet(this, _remainingTime) - (new Date().getTime() - __privateGet(this, _startTime))),
        this.dispatchEvent(new CustomEvent("player:pause")))
    }
    resume(e=!1) {
        __privateGet(this, _state) !== "stopped" && (e ? this.start() : (clearTimeout(__privateGet(this, _timer)),
        __privateSet(this, _startTime, new Date().getTime()),
        __privateSet(this, _state, "started"),
        __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime))),
        this.dispatchEvent(new CustomEvent("player:resume"))))
    }
    start() {
        clearTimeout(__privateGet(this, _timer)),
        __privateSet(this, _startTime, new Date().getTime()),
        __privateSet(this, _state, "started"),
        __privateSet(this, _remainingTime, __privateGet(this, _duration)),
        __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime))),
        this.dispatchEvent(new CustomEvent("player:start"))
    }
    stop() {
        clearTimeout(__privateGet(this, _timer)),
        __privateSet(this, _state, "stopped"),
        this.dispatchEvent(new CustomEvent("player:stop"))
    }
}
;
_callback = new WeakMap,
_duration = new WeakMap,
_remainingTime = new WeakMap,
_startTime = new WeakMap,
_timer = new WeakMap,
_state = new WeakMap,
_onVisibilityChangeListener = new WeakMap,
_mustResumeOnVisibility = new WeakMap,
_Player_instances = new WeakSet,
onVisibilityChange_fn = function() {
    document.visibilityState === "hidden" ? (__privateSet(this, _mustResumeOnVisibility, __privateGet(this, _state) === "started"),
    this.pause(),
    this.dispatchEvent(new CustomEvent("player:visibility-pause"))) : document.visibilityState === "visible" && __privateGet(this, _mustResumeOnVisibility) && (this.resume(),
    this.dispatchEvent(new CustomEvent("player:visibility-resume")))
}
;
var _resizeObserver, _HeightObserver_instances, updateCustomProperties_fn, QrCode = class extends HTMLElement {
    connectedCallback() {
        new window.QRCode(this,{
            text: this.getAttribute("identifier"),
            width: this.hasAttribute("width") ? parseInt(this.getAttribute("width")) : 200,
            height: this.hasAttribute("height") ? parseInt(this.getAttribute("height")) : 200
        })
    }
}
;
window.customElements.get("qr-code") || window.customElements.define("qr-code", QrCode);
var _LoadingBar_instances, onLoadingStart_fn, onLoadingEnd_fn, HeightObserver = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _HeightObserver_instances),
        __privateAdd(this, _resizeObserver, new ResizeObserver(throttle(__privateMethod(this, _HeightObserver_instances, updateCustomProperties_fn).bind(this))))
    }
    connectedCallback() {
        __privateGet(this, _resizeObserver).observe(this),
        window.ResizeObserver || document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${this.clientHeight.toFixed(2)}px`)
    }
    disconnectedCallback() {
        __privateGet(this, _resizeObserver).unobserve(this)
    }
}
;
_resizeObserver = new WeakMap,
_HeightObserver_instances = new WeakSet,
updateCustomProperties_fn = function(e) {
    e.forEach(e2 => {
        if (e2.target === this) {
            const t = e2.borderBoxSize ? e2.borderBoxSize.length > 0 ? e2.borderBoxSize[0].blockSize : e2.borderBoxSize.blockSize : e2.target.clientHeight;
            document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${t.toFixed(2)}px`)
        }
    }
    )
}
,
window.customElements.get("height-observer") || window.customElements.define("height-observer", HeightObserver);
import {animate as animate2} from "vendor";
var _resizeObserver2, _checkPositionListener, _initialTop, _lastKnownY, _currentTop, _position, _SafeSticky_instances, recalculateStyles_fn, checkPosition_fn, LoadingBar = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _LoadingBar_instances),
        document.addEventListener("theme:loading:start", __privateMethod(this, _LoadingBar_instances, onLoadingStart_fn).bind(this)),
        document.addEventListener("theme:loading:end", __privateMethod(this, _LoadingBar_instances, onLoadingEnd_fn).bind(this))
    }
}
;
_LoadingBar_instances = new WeakSet,
onLoadingStart_fn = function() {
    animate2(this, {
        opacity: [0, 1],
        transform: ["scaleX(0)", "scaleX(0.4)"]
    }, {
        duration: .25
    })
}
,
onLoadingEnd_fn = async function() {
    await animate2(this, {
        transform: [null, "scaleX(1)"]
    }, {
        duration: .25
    }).finished,
    animate2(this, {
        opacity: 0
    }, {
        duration: .25
    })
}
,
window.customElements.get("loading-bar") || window.customElements.define("loading-bar", LoadingBar);
import {inView as inView2} from "vendor";
var _abortController, _allItems, _CarouselNavigation_instances, onCarouselFilter_fn, SafeSticky = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _SafeSticky_instances),
        __privateAdd(this, _resizeObserver2, new ResizeObserver(__privateMethod(this, _SafeSticky_instances, recalculateStyles_fn).bind(this))),
        __privateAdd(this, _checkPositionListener, throttle(__privateMethod(this, _SafeSticky_instances, checkPosition_fn).bind(this))),
        __privateAdd(this, _initialTop, 0),
        __privateAdd(this, _lastKnownY, 0),
        __privateAdd(this, _currentTop, 0),
        __privateAdd(this, _position, "relative")
    }
    connectedCallback() {
        inView2(this, () => (window.addEventListener("scroll", __privateGet(this, _checkPositionListener)),
        __privateGet(this, _resizeObserver2).observe(this),
        () => {
            window.removeEventListener("scroll", __privateGet(this, _checkPositionListener)),
            __privateGet(this, _resizeObserver2).unobserve(this)
        }
        ), {
            margin: "500px"
        })
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", __privateGet(this, _checkPositionListener)),
        __privateGet(this, _resizeObserver2).unobserve(this)
    }
}
;
_resizeObserver2 = new WeakMap,
_checkPositionListener = new WeakMap,
_initialTop = new WeakMap,
_lastKnownY = new WeakMap,
_currentTop = new WeakMap,
_position = new WeakMap,
_SafeSticky_instances = new WeakSet,
recalculateStyles_fn = function() {
    this.style.removeProperty("top");
    const e = getComputedStyle(this);
    __privateSet(this, _initialTop, parseInt(e.top)),
    __privateSet(this, _position, e.position),
    __privateMethod(this, _SafeSticky_instances, checkPosition_fn).call(this)
}
,
checkPosition_fn = function() {
    if (__privateGet(this, _position) !== "sticky")
        return this.style.removeProperty("top");
    let e = this.getBoundingClientRect().top + window.scrollY - this.offsetTop + __privateGet(this, _initialTop)
      , t = this.clientHeight - window.innerHeight + 20;
    window.scrollY < __privateGet(this, _lastKnownY) ? __privateSet(this, _currentTop, __privateGet(this, _currentTop) - (window.scrollY - __privateGet(this, _lastKnownY))) : __privateSet(this, _currentTop, __privateGet(this, _currentTop) + (__privateGet(this, _lastKnownY) - window.scrollY)),
    __privateSet(this, _currentTop, Math.min(Math.max(__privateGet(this, _currentTop), -t), e, __privateGet(this, _initialTop))),
    __privateSet(this, _lastKnownY, window.scrollY),
    this.style.top = `${Math.round(__privateGet(this, _currentTop))}px`
}
,
window.customElements.get("safe-sticky") || window.customElements.define("safe-sticky", SafeSticky);
var CarouselNavigation = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _CarouselNavigation_instances),
        __privateAdd(this, _abortController),
        __privateAdd(this, _allItems, [])
    }
    connectedCallback() {
        if (!this.carousel)
            throw "Carousel navigation component requires an aria-controls attribute that refers to the controlled carousel.";
        __privateSet(this, _abortController, new AbortController),
        __privateSet(this, _allItems, Array.from(this.querySelectorAll("button"))),
        __privateGet(this, _allItems).forEach(e => e.addEventListener("click", () => this.onButtonClicked(this.items.indexOf(e)), {
            signal: __privateGet(this, _abortController).signal
        })),
        this.carousel.addEventListener("carousel:change", e => this.onNavigationChange(e.detail.index), {
            signal: __privateGet(this, _abortController).signal
        }),
        this.carousel.addEventListener("carousel:filter", __privateMethod(this, _CarouselNavigation_instances, onCarouselFilter_fn).bind(this), {
            signal: __privateGet(this, _abortController).signal
        })
    }
    disconnectedCallback() {
        __privateGet(this, _abortController).abort()
    }
    get items() {
        return __privateGet(this, _allItems).filter(e => !e.hasAttribute("hidden"))
    }
    get carousel() {
        return document.getElementById(this.getAttribute("aria-controls"))
    }
    get selectedIndex() {
        return this.items.findIndex(e => e.getAttribute("aria-current") === "true")
    }
    onButtonClicked(e) {
        this.carousel.select(e),
        this.onNavigationChange(e)
    }
    onNavigationChange(e) {
        this.items.forEach( (t, i) => t.setAttribute("aria-current", e === i ? "true" : "false")),
        !this.hasAttribute("align-selected") || this.scrollWidth === this.clientWidth && this.scrollHeight === this.clientHeight || this.scrollTo({
            left: this.items[e].offsetLeft - this.clientWidth / 2 + this.items[e].clientWidth / 2,
            top: this.items[e].offsetTop - this.clientHeight / 2 + this.items[e].clientHeight / 2,
            behavior: matchesMediaQuery("motion-safe") ? "smooth" : "auto"
        })
    }
}
;
_abortController = new WeakMap,
_allItems = new WeakMap,
_CarouselNavigation_instances = new WeakSet,
onCarouselFilter_fn = function(e) {
    __privateGet(this, _allItems).forEach( (t, i) => {
        t.toggleAttribute("hidden", (e.detail.filteredIndexes || []).includes(i))
    }
    )
}
;
var _listenersAbortController, _gestureArea, _player, _targetIndex, _preventInitialTransition, _EffectCarousel_instances, setupListeners_fn, onKeyboardNavigation_fn, preloadImages_fn, CarouselPrevButton = class extends HTMLElement {
    #e;
    connectedCallback() {
        if (!this.carousel)
            throw "Carousel prev button component requires an aria-controls attribute that refers to the controlled carousel.";
        this.#e = new AbortController,
        this.addEventListener("click", () => this.carousel.previous(), {
            signal: this.#e.signal
        }),
        this.carousel.addEventListener("scroll:edge-nearing", e => this.firstElementChild.disabled = e.detail.position === "start", {
            signal: this.#e.signal
        }),
        this.carousel.addEventListener("scroll:edge-leaving", e => this.firstElementChild.disabled = e.detail.position !== "start" && this.firstElementChild.disabled, {
            signal: this.#e.signal
        })
    }
    disconnectedCallback() {
        this.#e.abort()
    }
    get carousel() {
        return document.getElementById(this.getAttribute("aria-controls"))
    }
}
, CarouselNextButton = class extends HTMLElement {
    #e;
    connectedCallback() {
        if (!this.carousel)
            throw "Carousel next button component requires an aria-controls attribute that refers to the controlled carousel.";
        this.#e = new AbortController,
        this.addEventListener("click", () => this.carousel.next(), {
            signal: this.#e.signal
        }),
        this.carousel.addEventListener("scroll:edge-nearing", e => this.firstElementChild.disabled = e.detail.position === "end", {
            signal: this.#e.signal
        }),
        this.carousel.addEventListener("scroll:edge-leaving", e => this.firstElementChild.disabled = e.detail.position !== "end" && this.firstElementChild.disabled, {
            signal: this.#e.signal
        })
    }
    disconnectedCallback() {
        this.#e.abort()
    }
    get carousel() {
        return document.getElementById(this.getAttribute("aria-controls"))
    }
}
;
window.customElements.get("carousel-prev-button") || window.customElements.define("carousel-prev-button", CarouselPrevButton),
window.customElements.get("carousel-next-button") || window.customElements.define("carousel-next-button", CarouselNextButton),
window.customElements.get("carousel-navigation") || window.customElements.define("carousel-navigation", CarouselNavigation);
import {animate as animate3, timeline, inView as inView3} from "vendor";
var _hasPendingProgrammaticScroll, _onMouseDownListener, _onMouseMoveListener, _onMouseClickListener, _onMouseUpListener, _targetIndex2, _forceChangeEvent, _dragPosition, _isDragging, _dispatchableScrollEvents, _scrollTimeout, _ScrollCarousel_instances, setupListeners_fn2, updateTargetIndex_fn, onScroll_fn, onScrollEnd_fn, calculateLeftScroll_fn, calculateClosestIndexToAlignment_fn, onMouseDown_fn, onMouseMove_fn, onMouseClick_fn, onMouseUp_fn, onResize_fn, onMutate_fn, adaptHeight_fn, preloadImages_fn2, EffectCarousel = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _EffectCarousel_instances),
        __privateAdd(this, _listenersAbortController),
        __privateAdd(this, _gestureArea),
        __privateAdd(this, _player),
        __privateAdd(this, _targetIndex, 0),
        __privateAdd(this, _preventInitialTransition, !1),
        __privateMethod(this, _EffectCarousel_instances, setupListeners_fn).call(this),
        inView3(this, () => this.onBecameVisible()),
        this.addEventListener("carousel:settle", e => {
            this.allCells.forEach(t => t.classList.toggle("is-selected", t === e.detail.cell))
        }
        )
    }
    connectedCallback() {
        __privateSet(this, _targetIndex, Math.max(0, this.cells.findIndex(e => e.classList.contains("is-selected")))),
        inView3(this, () => __privateMethod(this, _EffectCarousel_instances, preloadImages_fn).call(this))
    }
    get allowSwipe() {
        return this.hasAttribute("allow-swipe")
    }
    get cellSelector() {
        return this.hasAttribute("cell-selector") ? this.getAttribute("cell-selector") : null
    }
    get allCells() {
        return this.cellSelector ? Array.from(this.querySelectorAll(this.cellSelector)) : Array.from(this.children)
    }
    get cells() {
        return this.allCells.filter(e => !e.hasAttribute("hidden"))
    }
    get selectedCell() {
        return this.cells[this.selectedIndex]
    }
    get selectedIndex() {
        return __privateGet(this, _targetIndex)
    }
    get player() {
        return __privateGet(this, _player)
    }
    previous({instant: e=!1}={}) {
        return this.select((this.selectedIndex - 1 + this.cells.length) % this.cells.length, {
            instant: e,
            direction: "previous"
        })
    }
    next({instant: e=!1}={}) {
        return this.select((this.selectedIndex + 1 + this.cells.length) % this.cells.length, {
            instant: e,
            direction: "next"
        })
    }
    async select(e, {instant: t=!1, direction: i=null}={}) {
        if (!(e in this.cells) || (this.dispatchEvent(new CustomEvent("carousel:select",{
            detail: {
                index: e,
                cell: this.cells[e]
            }
        })),
        e === this.selectedIndex))
            return Promise.resolve();
        __privateGet(this, _player)?.pause();
        const [n,a] = [this.selectedCell, this.cells[e]];
        i ??= e > this.selectedIndex ? "next" : "previous",
        __privateSet(this, _targetIndex, e),
        this.dispatchEvent(new CustomEvent("carousel:change",{
            detail: {
                index: e,
                cell: this.cells[e]
            }
        }));
        const s = this.createOnChangeAnimationControls(n, a, {
            direction: i
        });
        if ("leaveControls" in s && "enterControls" in s) {
            const e2 = s.leaveControls();
            t && e2.finish(),
            await e2.finished,
            __privateGet(this, _player)?.resume(!0),
            n.classList.remove("is-selected"),
            a.classList.add("is-selected");
            const i2 = s.enterControls();
            t && i2.finish(),
            await i2.finished
        } else
            t && s.finish(),
            __privateGet(this, _player)?.resume(!0),
            a.classList.add("is-selected"),
            await s.finished,
            n.classList.remove("is-selected");
        this.dispatchEvent(new CustomEvent("carousel:settle",{
            detail: {
                index: e,
                cell: this.cells[e]
            }
        }))
    }
    filter(e=[]) {
        this.allCells.forEach( (t, i) => {
            t.toggleAttribute("hidden", e.includes(i))
        }
        ),
        this.dispatchEvent(new CustomEvent("carousel:filter",{
            detail: {
                filteredIndexes: e
            }
        }))
    }
    async onBecameVisible() {
        const e = await this.createOnBecameVisibleAnimationControls(this.selectedCell);
        return [this.selectedCell, ...this.selectedCell.querySelectorAll("[reveal-on-scroll]")].forEach(e2 => {
            e2.removeAttribute("reveal-on-scroll")
        }
        ),
        __privateGet(this, _preventInitialTransition) && typeof e.finish == "function" && e.finish(),
        e.finished.then( () => {
            __privateGet(this, _player)?.resume(!0),
            this.dispatchEvent(new CustomEvent("carousel:settle",{
                detail: {
                    index: this.selectedIndex,
                    cell: this.selectedCell
                }
            }))
        }
        )
    }
    createOnBecameVisibleAnimationControls(e) {
        return animate3(e, {}, {
            duration: 0
        })
    }
    createOnChangeAnimationControls(e, t, {direction: i}={}) {
        return timeline([[e, {
            opacity: [1, 0]
        }, {
            duration: .3
        }], [t, {
            opacity: [0, 1]
        }, {
            duration: .3,
            at: "<"
        }]])
    }
    cleanUpAnimations() {
        this.allCells.forEach(e => {
            e.style.removeProperty("opacity"),
            e.style.removeProperty("visibility")
        }
        )
    }
}
;
_listenersAbortController = new WeakMap,
_gestureArea = new WeakMap,
_player = new WeakMap,
_targetIndex = new WeakMap,
_preventInitialTransition = new WeakMap,
_EffectCarousel_instances = new WeakSet,
setupListeners_fn = function() {
    if (this.hasAttribute("disabled-on") && (mediaQueryListener(this.getAttribute("disabled-on"), e2 => {
        e2.matches ? (__privateGet(this, _listenersAbortController)?.abort(),
        this.cleanUpAnimations()) : __privateMethod(this, _EffectCarousel_instances, setupListeners_fn).call(this)
    }
    ),
    matchesMediaQuery(this.getAttribute("disabled-on"))))
        return;
    __privateSet(this, _listenersAbortController, new AbortController);
    const e = {
        signal: __privateGet(this, _listenersAbortController).signal
    };
    Shopify.designMode && this.closest(".shopify-section").addEventListener("shopify:section:select", e2 => __privateSet(this, _preventInitialTransition, e2.detail.load), e),
    this.allCells.length > 1 && (this.addEventListener("carousel:change", __privateMethod(this, _EffectCarousel_instances, preloadImages_fn)),
    this.allowSwipe && (__privateSet(this, _gestureArea, new GestureArea(this,{
        signal: __privateGet(this, _listenersAbortController).signal
    })),
    this.addEventListener("swipeleft", this.next, e),
    this.addEventListener("swiperight", this.previous, e)),
    this.hasAttribute("disable-keyboard-navigation") || (this.tabIndex = 0,
    this.addEventListener("keydown", __privateMethod(this, _EffectCarousel_instances, onKeyboardNavigation_fn), e)),
    Shopify.designMode && this.addEventListener("shopify:block:select", e2 => this.select(this.cells.indexOf(e2.target), {
        instant: e2.detail.load
    }), e),
    this.hasAttribute("autoplay") && (__privateGet(this, _player) ?? __privateSet(this, _player, new Player(this.getAttribute("autoplay") ?? 5)),
    __privateGet(this, _player).addEventListener("player:end", this.next.bind(this), e),
    Shopify.designMode && (this.addEventListener("shopify:block:select", () => __privateGet(this, _player).stop(), e),
    this.addEventListener("shopify:block:deselect", () => __privateGet(this, _player).start(), e))))
}
,
onKeyboardNavigation_fn = function(e) {
    e.target === this && (e.code === "ArrowLeft" ? this.previous() : e.code === "ArrowRight" && this.next())
}
,
preloadImages_fn = function() {
    const e = this.cells[(this.selectedIndex - 1 + this.cells.length) % this.cells.length]
      , t = this.cells[(this.selectedIndex + 1 + this.cells.length) % this.cells.length];
    [e, this.selectedCell, t].forEach(e2 => {
        Array.from(e2.querySelectorAll('img[loading="lazy"]')).forEach(e3 => e3.removeAttribute("loading")),
        Array.from(e2.querySelectorAll('video[preload="none"]')).forEach(e3 => e3.setAttribute("preload", "metadata"))
    }
    )
}
,
window.customElements.get("effect-carousel") || window.customElements.define("effect-carousel", EffectCarousel);
import {inView as inView4} from "vendor";
var ScrollCarousel = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _ScrollCarousel_instances),
        __privateAdd(this, _hasPendingProgrammaticScroll, !1),
        __privateAdd(this, _onMouseDownListener, __privateMethod(this, _ScrollCarousel_instances, onMouseDown_fn).bind(this)),
        __privateAdd(this, _onMouseMoveListener, __privateMethod(this, _ScrollCarousel_instances, onMouseMove_fn).bind(this)),
        __privateAdd(this, _onMouseClickListener, __privateMethod(this, _ScrollCarousel_instances, onMouseClick_fn).bind(this)),
        __privateAdd(this, _onMouseUpListener, __privateMethod(this, _ScrollCarousel_instances, onMouseUp_fn).bind(this)),
        __privateAdd(this, _targetIndex2, 0),
        __privateAdd(this, _forceChangeEvent, !1),
        __privateAdd(this, _dragPosition, {}),
        __privateAdd(this, _isDragging, !1),
        __privateAdd(this, _dispatchableScrollEvents, {
            nearingStart: !0,
            nearingEnd: !0,
            leavingStart: !0,
            leavingEnd: !0
        }),
        __privateAdd(this, _scrollTimeout),
        __privateMethod(this, _ScrollCarousel_instances, setupListeners_fn2).call(this),
        new ResizeObserver(__privateMethod(this, _ScrollCarousel_instances, onResize_fn).bind(this)).observe(this),
        new MutationObserver(__privateMethod(this, _ScrollCarousel_instances, onMutate_fn).bind(this)).observe(this, {
            subtree: !0,
            attributes: !0,
            attributeFilter: ["hidden"]
        })
    }
    connectedCallback() {
        __privateSet(this, _targetIndex2, Math.max(0, this.cells.findIndex(e => e.classList.contains("is-initial")))),
        __privateGet(this, _targetIndex2) > 0 && this.select(__privateGet(this, _targetIndex2), {
            instant: !0
        }),
        this.adaptiveHeight && __privateMethod(this, _ScrollCarousel_instances, adaptHeight_fn).call(this),
        inView4(this, () => __privateMethod(this, _ScrollCarousel_instances, preloadImages_fn2).call(this))
    }
    disconnectedCallback() {
        this.removeEventListener("mousemove", __privateGet(this, _onMouseMoveListener)),
        document.removeEventListener("mouseup", __privateGet(this, _onMouseUpListener))
    }
    get cellSelector() {
        return this.hasAttribute("cell-selector") ? this.getAttribute("cell-selector") : null
    }
    get allCells() {
        return this.cellSelector ? Array.from(this.querySelectorAll(this.cellSelector)) : Array.from(this.children)
    }
    get cells() {
        return this.allCells.filter(e => !e.hasAttribute("hidden"))
    }
    get selectedCell() {
        return this.cells[this.selectedIndex]
    }
    get selectedIndex() {
        return __privateGet(this, _targetIndex2)
    }
    get cellAlign() {
        const e = getComputedStyle(this.cells[0]).scrollSnapAlign;
        return e === "none" ? "center" : e
    }
    get groupCells() {
        if (this.hasAttribute("group-cells")) {
            const e = parseInt(this.getAttribute("group-cells"));
            return isNaN(e) ? Math.floor(this.clientWidth / this.cells[0].clientWidth) : e
        }
        return 1
    }
    get adaptiveHeight() {
        return this.hasAttribute("adaptive-height")
    }
    get isScrollable() {
        const e = this.scrollWidth - this.clientWidth
          , t = this.scrollHeight - this.clientHeight;
        return e > 1 || t > 1
    }
    previous({instant: e=!1}={}) {
        this.select(Math.max(__privateGet(this, _targetIndex2) - this.groupCells, 0), {
            instant: e
        })
    }
    next({instant: e=!1}={}) {
        this.select(Math.min(__privateGet(this, _targetIndex2) + this.groupCells, this.cells.length - 1), {
            instant: e
        })
    }
    select(e, {instant: t=!1}={}) {
        if (e in this.cells)
            if (this.dispatchEvent(new CustomEvent("carousel:select",{
                detail: {
                    index: e,
                    cell: this.cells[e]
                }
            })),
            "checkVisibility" in this && this.checkVisibility() || this.offsetWidth > 0 && this.offsetHeight > 0) {
                const i = __privateMethod(this, _ScrollCarousel_instances, calculateLeftScroll_fn).call(this, this.cells[e]);
                this.scrollLeft !== i ? (__privateMethod(this, _ScrollCarousel_instances, updateTargetIndex_fn).call(this, e),
                __privateSet(this, _hasPendingProgrammaticScroll, !0),
                this.scrollTo({
                    left: i,
                    behavior: t ? "auto" : "smooth"
                })) : __privateMethod(this, _ScrollCarousel_instances, updateTargetIndex_fn).call(this, __privateMethod(this, _ScrollCarousel_instances, calculateClosestIndexToAlignment_fn).call(this))
            } else
                __privateSet(this, _targetIndex2, e),
                __privateSet(this, _forceChangeEvent, !0)
    }
    filter(e=[]) {
        this.allCells.forEach( (t, i) => {
            t.toggleAttribute("hidden", e.includes(i))
        }
        ),
        __privateSet(this, _forceChangeEvent, !0),
        this.dispatchEvent(new CustomEvent("carousel:filter",{
            detail: {
                filteredIndexes: e
            }
        }))
    }
}
;
_hasPendingProgrammaticScroll = new WeakMap,
_onMouseDownListener = new WeakMap,
_onMouseMoveListener = new WeakMap,
_onMouseClickListener = new WeakMap,
_onMouseUpListener = new WeakMap,
_targetIndex2 = new WeakMap,
_forceChangeEvent = new WeakMap,
_dragPosition = new WeakMap,
_isDragging = new WeakMap,
_dispatchableScrollEvents = new WeakMap,
_scrollTimeout = new WeakMap,
_ScrollCarousel_instances = new WeakSet,
setupListeners_fn2 = function() {
    if (this.allCells.length > 1) {
        if (this.addEventListener("carousel:change", __privateMethod(this, _ScrollCarousel_instances, preloadImages_fn2)),
        this.addEventListener("scroll", throttle(__privateMethod(this, _ScrollCarousel_instances, onScroll_fn).bind(this))),
        this.addEventListener("scrollend", __privateMethod(this, _ScrollCarousel_instances, onScrollEnd_fn)),
        this.hasAttribute("allow-drag")) {
            const e = window.matchMedia("screen and (pointer: fine)");
            e.addEventListener("change", e2 => {
                e2.matches ? this.addEventListener("mousedown", __privateGet(this, _onMouseDownListener)) : this.removeEventListener("mousedown", __privateGet(this, _onMouseDownListener))
            }
            ),
            e.matches && this.addEventListener("mousedown", __privateGet(this, _onMouseDownListener))
        }
        this.adaptiveHeight && this.addEventListener("carousel:settle", __privateMethod(this, _ScrollCarousel_instances, adaptHeight_fn)),
        Shopify.designMode && this.addEventListener("shopify:block:select", e => this.select(this.cells.indexOf(e.target), {
            instant: e.detail.load
        }))
    }
}
,
updateTargetIndex_fn = function(e) {
    (e !== __privateGet(this, _targetIndex2) || __privateGet(this, _forceChangeEvent)) && (__privateSet(this, _targetIndex2, e),
    __privateSet(this, _forceChangeEvent, !1),
    this.dispatchEvent(new CustomEvent("carousel:change",{
        detail: {
            index: e,
            cell: this.cells[e]
        }
    })))
}
,
onScroll_fn = function() {
    const t = Math.round(Math.abs(this.scrollLeft));
    t < 100 && __privateGet(this, _dispatchableScrollEvents).nearingStart && (this.dispatchEvent(new CustomEvent("scroll:edge-nearing",{
        detail: {
            position: "start"
        }
    })),
    __privateGet(this, _dispatchableScrollEvents).nearingStart = !1,
    __privateGet(this, _dispatchableScrollEvents).leavingStart = !0),
    t >= 100 && __privateGet(this, _dispatchableScrollEvents).leavingStart && (this.dispatchEvent(new CustomEvent("scroll:edge-leaving",{
        detail: {
            position: "start"
        }
    })),
    __privateGet(this, _dispatchableScrollEvents).leavingStart = !1,
    __privateGet(this, _dispatchableScrollEvents).nearingStart = !0),
    this.scrollWidth - this.clientWidth < t + 100 && __privateGet(this, _dispatchableScrollEvents).nearingEnd && (this.dispatchEvent(new CustomEvent("scroll:edge-nearing",{
        detail: {
            position: "end"
        }
    })),
    __privateGet(this, _dispatchableScrollEvents).nearingEnd = !1,
    __privateGet(this, _dispatchableScrollEvents).leavingEnd = !0),
    this.scrollWidth - this.clientWidth >= t + 100 && __privateGet(this, _dispatchableScrollEvents).leavingEnd && (this.dispatchEvent(new CustomEvent("scroll:edge-leaving",{
        detail: {
            position: "end"
        }
    })),
    __privateGet(this, _dispatchableScrollEvents).leavingEnd = !1,
    __privateGet(this, _dispatchableScrollEvents).nearingEnd = !0),
    "onscrollend" in window || (clearTimeout(__privateGet(this, _scrollTimeout)),
    __privateSet(this, _scrollTimeout, setTimeout( () => {
        this.dispatchEvent(new CustomEvent("scrollend",{
            bubbles: !0
        }))
    }
    , 75))),
    __privateGet(this, _hasPendingProgrammaticScroll) || __privateMethod(this, _ScrollCarousel_instances, updateTargetIndex_fn).call(this, __privateMethod(this, _ScrollCarousel_instances, calculateClosestIndexToAlignment_fn).call(this))
}
,
onScrollEnd_fn = function() {
    __privateSet(this, _hasPendingProgrammaticScroll, !1),
    __privateGet(this, _isDragging) || this.style.removeProperty("scroll-snap-type"),
    __privateMethod(this, _ScrollCarousel_instances, updateTargetIndex_fn).call(this, __privateMethod(this, _ScrollCarousel_instances, calculateClosestIndexToAlignment_fn).call(this)),
    this.dispatchEvent(new CustomEvent("carousel:settle",{
        detail: {
            index: this.selectedIndex,
            cell: this.selectedCell
        }
    }))
}
,
calculateLeftScroll_fn = function(e) {
    let t;
    switch (this.cellAlign) {
    case "start":
        t = document.dir === "ltr" ? e.offsetLeft - (parseInt(getComputedStyle(this).scrollPaddingInlineStart) || 0) : e.offsetLeft + e.offsetWidth - this.clientWidth + (parseInt(getComputedStyle(this).scrollPaddingInlineStart) || 0);
        break;
    case "center":
        t = Math.round(e.offsetLeft - this.clientWidth / 2 + e.clientWidth / 2);
        break;
    case "end":
        t = document.dir === "ltr" ? e.offsetLeft + e.offsetWidth - this.clientWidth + (parseInt(getComputedStyle(this).scrollPaddingInlineEnd) || 0) : e.offsetLeft - (parseInt(getComputedStyle(this).scrollPaddingInlineEnd) || 0)
    }
    return document.dir === "ltr" ? Math.min(Math.max(t, 0), this.scrollWidth - this.clientWidth) : Math.min(Math.max(t, this.clientWidth - this.scrollWidth), 0)
}
,
calculateClosestIndexToAlignment_fn = function() {
    let e, t, i = this.cellAlign;
    return i === "center" ? (e = this.cells.map(e2 => Math.round(e2.offsetLeft + e2.clientWidth / 2)),
    t = Math.round(this.scrollLeft + this.clientWidth / 2)) : i === "start" && document.dir === "ltr" || i === "end" && document.dir === "rtl" ? (e = this.cells.map(e2 => e2.offsetLeft),
    t = this.scrollLeft) : (e = this.cells.map(e2 => e2.offsetLeft + e2.clientWidth),
    t = this.scrollLeft + this.clientWidth),
    e.indexOf(e.reduce( (e2, i2) => Math.abs(i2 - t) < Math.abs(e2 - t) ? i2 : e2))
}
,
onMouseDown_fn = function(e) {
    __privateSet(this, _dragPosition, {
        left: this.scrollLeft,
        top: this.scrollTop,
        x: e.clientX,
        y: e.clientY
    }),
    __privateSet(this, _isDragging, !0),
    this.style.setProperty("scroll-snap-type", "none"),
    this.addEventListener("mousemove", __privateGet(this, _onMouseMoveListener)),
    this.addEventListener("click", __privateGet(this, _onMouseClickListener), {
        once: !0
    }),
    document.addEventListener("mouseup", __privateGet(this, _onMouseUpListener))
}
,
onMouseMove_fn = function(e) {
    e.preventDefault();
    const [t,i] = [e.clientX - __privateGet(this, _dragPosition).x, e.clientY - __privateGet(this, _dragPosition).y];
    this.scrollTop = __privateGet(this, _dragPosition).top - i,
    this.scrollLeft = __privateGet(this, _dragPosition).left - t
}
,
onMouseClick_fn = function(e) {
    e.clientX - __privateGet(this, _dragPosition).x != 0 && e.preventDefault()
}
,
onMouseUp_fn = function(e) {
    __privateSet(this, _isDragging, !1),
    e.clientX - __privateGet(this, _dragPosition).x == 0 ? this.style.removeProperty("scroll-snap-type") : __privateGet(this, _hasPendingProgrammaticScroll) || this.scrollTo({
        left: __privateMethod(this, _ScrollCarousel_instances, calculateLeftScroll_fn).call(this, this.selectedCell),
        behavior: "smooth"
    }),
    this.removeEventListener("mousemove", __privateGet(this, _onMouseMoveListener)),
    document.removeEventListener("mouseup", __privateGet(this, _onMouseUpListener))
}
,
onResize_fn = function() {
    this.selectedIndex !== __privateMethod(this, _ScrollCarousel_instances, calculateClosestIndexToAlignment_fn).call(this) && this.select(this.selectedIndex, {
        instant: !0
    }),
    this.adaptiveHeight && __privateMethod(this, _ScrollCarousel_instances, adaptHeight_fn).call(this),
    this.classList.toggle("is-scrollable", this.scrollWidth > this.clientWidth)
}
,
onMutate_fn = function() {
    __privateSet(this, _forceChangeEvent, !0)
}
,
adaptHeight_fn = function() {
    this.clientHeight !== this.selectedCell.clientHeight && (this.style.maxHeight = null,
    this.isScrollable && (this.style.maxHeight = `${this.selectedCell.clientHeight}px`))
}
,
preloadImages_fn2 = function() {
    requestAnimationFrame( () => {
        const e = this.cells[Math.max(this.selectedIndex - 1, 0)]
          , t = this.cells[Math.min(this.selectedIndex + 1, this.cells.length - 1)];
        [e, this.selectedCell, t].filter(e2 => e2 !== null).forEach(e2 => {
            Array.from(e2.querySelectorAll('img[loading="lazy"]')).forEach(e3 => e3.removeAttribute("loading")),
            Array.from(e2.querySelectorAll('video[preload="none"]')).forEach(e3 => e3.setAttribute("preload", "metadata"))
        }
        )
    }
    )
}
,
window.customElements.get("scroll-carousel") || window.customElements.define("scroll-carousel", ScrollCarousel);
var _abortController2, _CartCount_instances, updateFromServer_fn, createCartPromise = () => new Promise(async e => {
    e(await (await fetch(`${Shopify.routes.root}cart.js`)).json())
}
), fetchCart = createCartPromise();
document.addEventListener("cart:change", e => {
    fetchCart = e.detail.cart
}
),
window.addEventListener("pageshow", e => {
    e.persisted && (fetchCart = createCartPromise())
}
),
document.addEventListener("cart:refresh", () => {
    fetchCart = createCartPromise()
}
);
var _abortController3, _CartDot_instances, updateFromServer_fn2, CartCount = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _CartCount_instances),
        __privateAdd(this, _abortController2)
    }
    connectedCallback() {
        __privateSet(this, _abortController2, new AbortController),
        document.addEventListener("cart:change", e2 => {
            this.itemCount = e2.detail?.cart?.item_count ?? 0
        }
        , {
            signal: __privateGet(this, _abortController2).signal
        });
        const e = __privateMethod(this, _CartCount_instances, updateFromServer_fn).bind(this);
        document.addEventListener("cart:refresh", e, {
            signal: __privateGet(this, _abortController2).signal
        }),
        window.addEventListener("pageshow", e, {
            signal: __privateGet(this, _abortController2).signal
        })
    }
    disconnectedCallback() {
        __privateGet(this, _abortController2).abort()
    }
    set itemCount(e) {
        e > 0 ? (this.innerText = e,
        this.style.display = "",
        this.classList.remove("hide")) : (this.innerText = "",
        this.style.display = "none",
        this.classList.add("hide"))
    }
}
;
_abortController2 = new WeakMap,
_CartCount_instances = new WeakSet,
updateFromServer_fn = async function() {
    const e = await fetchCart;
    this.itemCount = e?.item_count ?? 0
}
,
window.customElements.get("cart-count") || window.customElements.define("cart-count", CartCount);
var _CartNote_instances, onNoteChanged_fn, CartDot = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _CartDot_instances),
        __privateAdd(this, _abortController3)
    }
    connectedCallback() {
        __privateSet(this, _abortController3, new AbortController),
        document.addEventListener("cart:change", e => this.classList.toggle("is-visible", e.detail.cart.item_count > 0), {
            signal: __privateGet(this, _abortController3).signal
        }),
        document.addEventListener("cart:refresh", __privateMethod(this, _CartDot_instances, updateFromServer_fn2).bind(this), {
            signal: __privateGet(this, _abortController3).signal
        }),
        window.addEventListener("pageshow", __privateMethod(this, _CartDot_instances, updateFromServer_fn2).bind(this), {
            signal: __privateGet(this, _abortController3).signal
        })
    }
    disconnectedCallback() {
        __privateGet(this, _abortController3).abort()
    }
}
;
_abortController3 = new WeakMap,
_CartDot_instances = new WeakSet,
updateFromServer_fn2 = async function() {
    this.classList.toggle("is-visible", (await fetchCart).item_count > 0)
}
,
window.customElements.get("cart-dot") || window.customElements.define("cart-dot", CartDot);
var _onCartChangedListener, _currencyFormatter, _threshold, _FreeShippingBar_instances, updateMessage_fn, onCartChanged_fn, CartNote = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _CartNote_instances),
        this.addEventListener("change", __privateMethod(this, _CartNote_instances, onNoteChanged_fn))
    }
}
;
_CartNote_instances = new WeakSet,
onNoteChanged_fn = function(e) {
    e.target.getAttribute("name") === "note" && fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            note: e.target.value
        }),
        keepalive: !0
    })
}
,
window.customElements.get("cart-note") || window.customElements.define("cart-note", CartNote);
var _delegate, _LineItemQuantity_instances, onQuantityChanged_fn, onChangeLinkClicked_fn, changeLineItemQuantity_fn, FreeShippingBar = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _FreeShippingBar_instances),
        __privateAdd(this, _onCartChangedListener, __privateMethod(this, _FreeShippingBar_instances, onCartChanged_fn).bind(this)),
        __privateAdd(this, _currencyFormatter, new Intl.NumberFormat(Shopify.locale,{
            style: "currency",
            currency: Shopify.currency.active
        })),
        __privateAdd(this, _threshold),
        this.setAttribute("threshold", __privateGet(this, _threshold))
    }
    static get observedAttributes() {
        return ["threshold", "total-price"]
    }
    connectedCallback() {
        document.addEventListener("cart:change", __privateGet(this, _onCartChangedListener))
    }
    disconnectedCallback() {
        document.removeEventListener("cart:change", __privateGet(this, _onCartChangedListener))
    }
    get totalPrice() {
        return parseFloat(this.getAttribute("total-price"))
    }
    set totalPrice(e) {
        this.setAttribute("total-price", e)
    }
    attributeChangedCallback() {
        __privateMethod(this, _FreeShippingBar_instances, updateMessage_fn).call(this)
    }
}
;
_onCartChangedListener = new WeakMap,
_currencyFormatter = new WeakMap,
_threshold = new WeakMap,
_FreeShippingBar_instances = new WeakSet,
updateMessage_fn = function() {
    const e = this.querySelector("span")
      , t = this.querySelector(".free-shipping-bar__progress-inner");
    if (!e)
        return;
    const i = window.Shopify && Shopify.locale || document.documentElement.lang || "en"
      , n = window.Shopify && Shopify.currency && Shopify.currency.active || "USD"
      , a = !new Set(["BIF", "CLP", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA", "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF"]).has(n);
    let s = 0;
    try {
        const e2 = this.getAttribute("data-thresholds");
        if (e2) {
            const t2 = JSON.parse(e2)
              , i2 = Object.keys(t2).find(e3 => e3.toUpperCase() === n.toUpperCase());
            i2 && typeof t2[i2] == "number" && (s = Math.max(0, Math.round(t2[i2])))
        }
    } catch (e2) {
        console.warn("[FreeShippingBar] Invalid data-thresholds JSON", e2)
    }
    if (!s) {
        const e2 = this.getAttribute("threshold") || "0"
          , t2 = String(e2).trim()
          , i2 = /[^0-9]/.test(t2)
          , n2 = t2.includes(".");
        if (i2 || n2) {
            const e3 = parseFloat(t2.replace(/[^\d.]/g, "")) || 0;
            s = Math.round(a ? 100 * e3 : e3)
        } else
            s = Number(t2) || 0
    }
    const r = new Intl.NumberFormat(i,{
        style: "currency",
        currency: n,
        minimumFractionDigits: a ? 2 : 0,
        maximumFractionDigits: a ? 2 : 0
    })
      , o = Number(this.getAttribute("total-price")) || 0;
    if (o >= s)
        e.innerHTML = this.getAttribute("reached-message") || "";
    else {
        const t2 = Math.max(s - o, 0)
          , i2 = a ? t2 / 100 : t2
          , n2 = r.format(i2)
          , l = this.getAttribute("unreached-message") || "Spend {{amount}} more for free shipping"
          , c = n2.replace(/\$/g, "$$$$");
        e.innerHTML = l.replace(/({{\s*(amount|remaining_amount|amount_remaining)\s*}})/gi, c)
    }
    if (t && s > 0) {
        const e2 = Math.min(o / s * 100, 100);
        t.style.width = e2 + "%",
        t.setAttribute("aria-valuenow", String(Math.round(e2)))
    }
}
,
onCartChanged_fn = function(e) {
    const t = e.detail.cart.items.filter(e2 => e2.requires_shipping).reduce( (e2, t2) => e2 + t2.final_line_price, 0)
      , i = e.detail.cart.cart_level_discount_applications.reduce( (e2, t2) => e2 + t2.total_allocated_amount, 0);
    this.totalPrice = t - i
}
,
window.customElements.get("free-shipping-bar") || window.customElements.define("free-shipping-bar", FreeShippingBar);
import {Delegate} from "vendor";
var _estimateShippingListener, _ShippingEstimator_instances, estimateShipping_fn, getAsyncShippingRates_fn, formatShippingRates_fn, formatError_fn, LineItemQuantity = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _LineItemQuantity_instances),
        __privateAdd(this, _delegate, new Delegate(this)),
        __privateGet(this, _delegate).on("change", "[data-line-key]", __privateMethod(this, _LineItemQuantity_instances, onQuantityChanged_fn).bind(this)),
        __privateGet(this, _delegate).on("click", '[href*="/cart/change"]', __privateMethod(this, _LineItemQuantity_instances, onChangeLinkClicked_fn).bind(this))
    }
}
;
_delegate = new WeakMap,
_LineItemQuantity_instances = new WeakSet,
onQuantityChanged_fn = function(e, t) {
    __privateMethod(this, _LineItemQuantity_instances, changeLineItemQuantity_fn).call(this, t.getAttribute("data-line-key"), parseInt(t.value))
}
,
onChangeLinkClicked_fn = function(e, t) {
    e.preventDefault();
    const i = new URL(t.href);
    __privateMethod(this, _LineItemQuantity_instances, changeLineItemQuantity_fn).call(this, i.searchParams.get("id"), parseInt(i.searchParams.get("quantity")))
}
,
changeLineItemQuantity_fn = async function(e, t) {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start",{
        bubbles: !0
    }));
    const i = this.closest("line-item");
    i?.dispatchEvent(new CustomEvent("line-item:will-change",{
        bubbles: !0,
        detail: {
            targetQuantity: t
        }
    }));
    let n = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections",{
        bubbles: !0,
        detail: {
            sections: n
        }
    }));
    const a = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            id: e,
            quantity: t,
            sections: n.join(",")
        })
    });
    if (document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end",{
        bubbles: !0
    })),
    a.ok) {
        const t2 = await a.json();
        if (window.themeVariables.settings.pageType === "cart")
            window.location.reload();
        else {
            const n2 = t2.items.filter(t3 => t3.key === e);
            i?.dispatchEvent(new CustomEvent("line-item:change",{
                bubbles: !0,
                detail: {
                    quantity: n2.length === 0 ? 0 : n2[0].quantity,
                    cart: t2
                }
            })),
            document.documentElement.dispatchEvent(new CustomEvent("cart:change",{
                bubbles: !0,
                detail: {
                    baseEvent: "line-item:change",
                    cart: t2
                }
            }))
        }
    } else {
        const e2 = await a.json();
        this.parentElement.querySelector('[role="alert"]')?.remove(),
        this.insertAdjacentHTML("afterend", `<p class="h-stack gap-2 justify-center text-xs" role="alert"><svg width="13" height="13" fill="none" viewBox="0 0 13 13">
        <circle cx="6.5" cy="6.5" r="6.5" fill="#BF1515"/>
        <path fill="#fff" d="M6.75 7.97a.387.387 0 0 1-.3-.12.606.606 0 0 1-.12-.34l-.3-3.82c-.02-.247.033-.443.16-.59.127-.153.313-.23.56-.23.24 0 .42.077.54.23.127.147.18.343.16.59l-.3 3.82a.522.522 0 0 1-.12.34.344.344 0 0 1-.28.12Zm0 2.08a.744.744 0 0 1-.55-.21.751.751 0 0 1-.2-.54c0-.213.067-.387.2-.52.14-.14.323-.21.55-.21.233 0 .413.07.54.21.133.133.2.307.2.52 0 .22-.067.4-.2.54-.127.14-.307.21-.54.21Z"/>
      </svg> ${e2.description}</p>`),
        this.querySelector("quantity-selector")?.restoreDefaultValue()
    }
}
,
window.customElements.get("line-item-quantity") || window.customElements.define("line-item-quantity", LineItemQuantity);
var _isDirty, _FacetsForm_instances, form_get, buildUrl_fn, onFormChanged_fn, onFormSubmitted_fn, ShippingEstimator = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ShippingEstimator_instances),
        __privateAdd(this, _estimateShippingListener, __privateMethod(this, _ShippingEstimator_instances, estimateShipping_fn).bind(this))
    }
    connectedCallback() {
        this.submitButton = this.querySelector('[type="button"]'),
        this.resultsElement = this.querySelector('[aria-live="polite"]'),
        this.submitButton.addEventListener("click", __privateGet(this, _estimateShippingListener))
    }
    disconnectedCallback() {
        this.submitButton.removeEventListener("click", __privateGet(this, _estimateShippingListener))
    }
}
;
_estimateShippingListener = new WeakMap,
_ShippingEstimator_instances = new WeakSet,
estimateShipping_fn = async function(e) {
    e.preventDefault();
    const t = this.querySelector('[name="address[zip]"]').value
      , i = this.querySelector('[name="address[country]"]').value
      , n = this.querySelector('[name="address[province]"]').value;
    this.submitButton.setAttribute("aria-busy", "true"),
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start",{
        bubbles: !0
    }));
    const a = await fetch(`${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${t}&shipping_address[country]=${i}&shipping_address[province]=${n}`, {
        method: "POST"
    });
    if (document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end",{
        bubbles: !0
    })),
    a.ok) {
        const e2 = await __privateMethod(this, _ShippingEstimator_instances, getAsyncShippingRates_fn).call(this, t, i, n);
        __privateMethod(this, _ShippingEstimator_instances, formatShippingRates_fn).call(this, e2)
    } else {
        const e2 = await a.json();
        __privateMethod(this, _ShippingEstimator_instances, formatError_fn).call(this, e2)
    }
    this.resultsElement.hidden = !1,
    this.submitButton.removeAttribute("aria-busy")
}
,
getAsyncShippingRates_fn = async function(e, t, i) {
    const n = await fetch(`${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=${i}`)
      , a = await n.text();
    return a === "null" ? __privateMethod(this, _ShippingEstimator_instances, getAsyncShippingRates_fn).call(this, e, t, i) : JSON.parse(a).shipping_rates
}
,
formatShippingRates_fn = function(e) {
    let t = e.map(e2 => `<li>${e2.presentment_name}: ${e2.currency} ${e2.price}</li>`);
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${e.length === 0 ? window.themeVariables.strings.shippingEstimatorNoResults : e.length === 1 ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults}</p>
        ${t === "" ? "" : `<ul class="list-disc" role="list">${t}</ul>`}
      </div>
    `
}
,
formatError_fn = function(e) {
    let t = Object.keys(e).map(t2 => `<li>${e[t2]}</li>`).join("");
    this.resultsElement.innerHTML = `
      <div class="v-stack gap-2">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="list-disc" role="list">${t}</ul>
      </div>
    `
}
,
window.customElements.get("shipping-estimator") || window.customElements.define("shipping-estimator", ShippingEstimator);
var FacetsForm = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _FacetsForm_instances),
        __privateAdd(this, _isDirty, !1),
        this.addEventListener("change", __privateMethod(this, _FacetsForm_instances, onFormChanged_fn)),
        this.addEventListener("submit", __privateMethod(this, _FacetsForm_instances, onFormSubmitted_fn))
    }
}
;
_isDirty = new WeakMap,
_FacetsForm_instances = new WeakSet,
form_get = function() {
    return this.querySelector("form")
}
,
buildUrl_fn = function() {
    const e = new URLSearchParams(new FormData(__privateGet(this, _FacetsForm_instances, form_get)))
      , t = new URL(__privateGet(this, _FacetsForm_instances, form_get).action);
    return t.search = "",
    e.forEach( (e2, i) => t.searchParams.append(i, e2)),
    ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach(e2 => {
        t.searchParams.get(e2) === "" && t.searchParams.delete(e2)
    }
    ),
    t.searchParams.set("section_id", this.getAttribute("section-id")),
    t
}
,
onFormChanged_fn = function() {
    __privateSet(this, _isDirty, !0),
    this.hasAttribute("update-on-change") ? HTMLFormElement.prototype.requestSubmit ? __privateGet(this, _FacetsForm_instances, form_get).requestSubmit() : __privateGet(this, _FacetsForm_instances, form_get).dispatchEvent(new Event("submit",{
        cancelable: !0
    })) : cachedFetch(__privateMethod(this, _FacetsForm_instances, buildUrl_fn).call(this).toString())
}
,
onFormSubmitted_fn = function(e) {
    e.preventDefault(),
    __privateGet(this, _isDirty) && (this.dispatchEvent(new CustomEvent("facet:update",{
        bubbles: !0,
        detail: {
            url: __privateMethod(this, _FacetsForm_instances, buildUrl_fn).call(this)
        }
    })),
    __privateSet(this, _isDirty, !1))
}
,
window.customElements.get("facets-form") || window.customElements.define("facets-form", FacetsForm);
import {animate as animate4, FocusTrap, Delegate as Delegate2} from "vendor";
var _isLocked, _delegate2, _abortController4, _focusTrap, _originalParentBeforeAppend, _DialogElement_instances, allowOutsideClick_fn, allowOutsideClickTouch_fn, allowOutsideClickMouse_fn, onToggleClicked_fn, updateSlotVisibility_fn, lockLayerCount = 0, DialogElement = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _DialogElement_instances),
        __privateAdd(this, _isLocked, !1),
        __privateAdd(this, _delegate2, new Delegate2(document.body)),
        __privateAdd(this, _abortController4),
        __privateAdd(this, _focusTrap),
        __privateAdd(this, _originalParentBeforeAppend),
        this.shadowDomTemplate && (this.attachShadow({
            mode: "open"
        }).appendChild(document.getElementById(this.shadowDomTemplate).content.cloneNode(!0)),
        this.shadowRoot.addEventListener("slotchange", e => __privateMethod(this, _DialogElement_instances, updateSlotVisibility_fn).call(this, e.target))),
        this.addEventListener("dialog:force-close", e => {
            this.hide(),
            e.stopPropagation()
        }
        )
    }
    static get observedAttributes() {
        return ["id", "open"]
    }
    connectedCallback() {
        this.id && __privateGet(this, _delegate2).off().on("click", `[aria-controls="${this.id}"]`, __privateMethod(this, _DialogElement_instances, onToggleClicked_fn).bind(this)),
        __privateSet(this, _abortController4, new AbortController),
        this.setAttribute("role", "dialog"),
        this.shadowDomTemplate && (this.getShadowPartByName("overlay")?.addEventListener("click", this.hide.bind(this), {
            signal: this.abortController.signal
        }),
        Array.from(this.shadowRoot.querySelectorAll("slot")).forEach(e => __privateMethod(this, _DialogElement_instances, updateSlotVisibility_fn).call(this, e))),
        Shopify.designMode && (this.addEventListener("shopify:block:select", e => this.show(!e.detail.load), {
            signal: this.abortController.signal
        }),
        this.addEventListener("shopify:block:deselect", this.hide, {
            signal: this.abortController.signal
        }),
        this._shopifySection = this._shopifySection || this.closest(".shopify-section"),
        this._shopifySection && (this.hasAttribute("handle-editor-events") && (this._shopifySection.addEventListener("shopify:section:select", e => this.show(!e.detail.load), {
            signal: this.abortController.signal
        }),
        this._shopifySection.addEventListener("shopify:section:deselect", this.hide.bind(this), {
            signal: this.abortController.signal
        })),
        this._shopifySection.addEventListener("shopify:section:unload", () => this.remove(), {
            signal: this.abortController.signal
        })))
    }
    disconnectedCallback() {
        __privateGet(this, _delegate2).off(),
        this.abortController.abort(),
        this.focusTrap?.deactivate({
            onDeactivate: () => {}
        }),
        __privateGet(this, _isLocked) && (__privateSet(this, _isLocked, !1),
        document.documentElement.classList.toggle("lock", --lockLayerCount > 0))
    }
    show(e=!0) {
        return this.open ? Promise.resolve() : (this.setAttribute("open", e ? "" : "immediate"),
        waitForEvent(this, "dialog:after-show"))
    }
    hide() {
        return this.open ? (this.removeAttribute("open"),
        waitForEvent(this, "dialog:after-hide")) : Promise.resolve()
    }
    get abortController() {
        return __privateGet(this, _abortController4)
    }
    get controls() {
        return Array.from(this.getRootNode().querySelectorAll(`[aria-controls="${this.id}"]`))
    }
    get open() {
        return this.hasAttribute("open")
    }
    get shouldTrapFocus() {
        return !0
    }
    get shouldLock() {
        return !1
    }
    get clickOutsideDeactivates() {
        return !0
    }
    get shouldAppendToBody() {
        return !1
    }
    get initialFocus() {
        return this.hasAttribute("initial-focus") ? this.getAttribute("initial-focus") !== "false" && this.querySelector(this.getAttribute("initial-focus")) : this.hasAttribute("tabindex") ? this : this.querySelector('input:not([type="hidden"])') || !1
    }
    get preventScrollWhenTrapped() {
        return !0
    }
    get focusTrap() {
        return __privateSet(this, _focusTrap, __privateGet(this, _focusTrap) || new FocusTrap.createFocusTrap(this,{
            onDeactivate: this.hide.bind(this),
            allowOutsideClick: !!this.clickOutsideDeactivates && __privateMethod(this, _DialogElement_instances, allowOutsideClick_fn).bind(this),
            initialFocus: !!matchesMediaQuery("supports-hover") && this.initialFocus,
            fallbackFocus: this,
            tabbableOptions: {
                getShadowRoot: !0
            },
            preventScroll: this.preventScrollWhenTrapped
        }))
    }
    get shadowDomTemplate() {
        return this.getAttribute("template")
    }
    getShadowPartByName(e) {
        return this.shadowRoot?.querySelector(`[part="${e}"]`)
    }
    attributeChangedCallback(e, t, i) {
        if (e === "open") {
            if (this.controls.forEach(e2 => e2.setAttribute("aria-expanded", i === null ? "false" : "true")),
            t !== null || i !== "" && i !== "immediate") {
                if (t !== null && i === null) {
                    this.dispatchEvent(new CustomEvent("dialog:before-hide"));
                    const e2 = this.createLeaveAnimationControls().finished;
                    e2.then( () => {
                        this.style.setProperty("display", "none"),
                        this.parentElement === document.body && __privateGet(this, _originalParentBeforeAppend) && (__privateGet(this, _originalParentBeforeAppend).appendChild(this),
                        __privateSet(this, _originalParentBeforeAppend, null)),
                        this.dispatchEvent(new CustomEvent("dialog:after-hide"))
                    }
                    ),
                    this.focusTrap?.deactivate({
                        checkCanReturnFocus: () => e2
                    }),
                    this.shouldLock && (__privateSet(this, _isLocked, !1),
                    document.documentElement.classList.toggle("lock", --lockLayerCount > 0))
                }
            } else {
                __privateSet(this, _originalParentBeforeAppend, null),
                this.style.setProperty("display", "block"),
                this.dispatchEvent(new CustomEvent("dialog:before-show")),
                this.shouldAppendToBody && this.parentElement !== document.body && (__privateSet(this, _originalParentBeforeAppend, this.parentElement),
                document.body.append(this));
                const e2 = this.createEnterAnimationControls();
                i === "immediate" && e2.finish(),
                e2.finished.then( () => {
                    this.dispatchEvent(new CustomEvent("dialog:after-show"))
                }
                ),
                this.shouldTrapFocus && this.focusTrap.activate({
                    checkCanFocusTrap: () => e2.finished
                }),
                this.shouldLock && (lockLayerCount += 1,
                __privateSet(this, _isLocked, !0),
                document.documentElement.classList.add("lock"))
            }
            this.dispatchEvent(new CustomEvent("toggle",{
                bubbles: !0
            }))
        }
    }
    createEnterAnimationControls() {
        return animate4(this, {}, {
            duration: 0
        })
    }
    createLeaveAnimationControls() {
        return animate4(this, {}, {
            duration: 0
        })
    }
    hideForOutsideClickTarget(e) {
        return !this.contains(e)
    }
    allowOutsideClickForTarget(e) {
        return !1
    }
}
;
_isLocked = new WeakMap,
_delegate2 = new WeakMap,
_abortController4 = new WeakMap,
_focusTrap = new WeakMap,
_originalParentBeforeAppend = new WeakMap,
_DialogElement_instances = new WeakSet,
allowOutsideClick_fn = function(e) {
    return "TouchEvent" in window && e instanceof TouchEvent ? __privateMethod(this, _DialogElement_instances, allowOutsideClickTouch_fn).call(this, e) : __privateMethod(this, _DialogElement_instances, allowOutsideClickMouse_fn).call(this, e)
}
,
allowOutsideClickTouch_fn = function(e) {
    return e.target.addEventListener("touchend", e2 => {
        const t = document.elementFromPoint(e2.changedTouches.item(0).clientX, e2.changedTouches.item(0).clientY);
        this.hideForOutsideClickTarget(t) && this.hide()
    }
    , {
        once: !0,
        signal: this.abortController.signal
    }),
    this.allowOutsideClickForTarget(e.target)
}
,
allowOutsideClickMouse_fn = function(e) {
    if (e.type !== "click")
        return !1;
    if (this.hideForOutsideClickTarget(e.target) && this.hide(),
    this.allowOutsideClickForTarget(e.target))
        return !0;
    let t = e.target
      , i = e.target.closest("[aria-controls]");
    return i && i.getAttribute("aria-controls") === this.id && (t = i),
    this.id !== t.getAttribute("aria-controls")
}
,
onToggleClicked_fn = function(e) {
    e?.preventDefault(),
    this.open ? this.hide() : this.show()
}
,
updateSlotVisibility_fn = function(e) {
    ["header", "footer"].includes(e.name) && (e.parentElement.hidden = e.assignedElements({
        flatten: !0
    }).length === 0)
}
;
var DialogCloseButton = class extends HTMLElement {
    constructor() {
        super(),
        this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("dialog:force-close",{
            bubbles: !0,
            cancelable: !0,
            composed: !0
        })))
    }
}
;
window.customElements.get("dialog-element") || window.customElements.define("dialog-element", DialogElement),
window.customElements.get("dialog-close-button") || window.customElements.define("dialog-close-button", DialogCloseButton);
import {timeline as timeline3} from "vendor";
import {animate as animate5, timeline as timeline2} from "vendor";
var Modal = class extends DialogElement {
    connectedCallback() {
        super.connectedCallback(),
        this.setAttribute("aria-modal", "true")
    }
    get shadowDomTemplate() {
        return this.getAttribute("template") || "modal-default-template"
    }
    get shouldLock() {
        return !0
    }
    get shouldAppendToBody() {
        return !0
    }
    createEnterAnimationControls() {
        return matchesMediaQuery("sm") ? animate5(this, {
            opacity: [0, 1]
        }, {
            duration: .2
        }) : timeline2([[this.getShadowPartByName("overlay"), {
            opacity: [0, 1]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1]
        }], [this.getShadowPartByName("content"), {
            transform: ["translateY(100%)", "translateY(0)"]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1],
            at: "<"
        }]])
    }
    createLeaveAnimationControls() {
        return matchesMediaQuery("sm") ? animate5(this, {
            opacity: [1, 0]
        }, {
            duration: .2
        }) : timeline2([[this.getShadowPartByName("overlay"), {
            opacity: [1, 0]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1]
        }], [this.getShadowPartByName("content"), {
            transform: ["translateY(0)", "translateY(100%)"]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1],
            at: "<"
        }]])
    }
}
;
window.customElements.get("x-modal") || window.customElements.define("x-modal", Modal);
var Drawer = class extends Modal {
    get shadowDomTemplate() {
        return this.getAttribute("template") || "drawer-default-template"
    }
    get openFrom() {
        return this.getAttribute("open-from") || "right"
    }
    createEnterAnimationControls() {
        return this.getShadowPartByName("content").style.marginInlineStart = this.openFrom === "right" ? "auto" : 0,
        timeline3([[this.getShadowPartByName("overlay"), {
            opacity: [0, 1]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1]
        }], [this.getShadowPartByName("content"), {
            transform: [`translateX(calc(var(--transform-logical-flip) * ${this.openFrom === "right" ? "100%" : "-100%"}))`, "translateX(0)"]
        }, {
            duration: .3,
            at: "<",
            easing: [.645, .045, .355, 1]
        }]])
    }
    createLeaveAnimationControls() {
        return timeline3([[this.getShadowPartByName("overlay"), {
            opacity: [1, 0]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1]
        }], [this.getShadowPartByName("content"), {
            transform: ["translateX(0)", `translateX(calc(var(--transform-logical-flip) * ${this.openFrom === "right" ? "100%" : "-100%"}))`]
        }, {
            duration: .3,
            at: "<",
            easing: [.645, .045, .355, 1]
        }]])
    }
}
;
window.customElements.get("x-drawer") || window.customElements.define("x-drawer", Drawer);
import {animate as animate6} from "vendor";
var PopIn = class extends DialogElement {
    get shouldTrapFocus() {
        return !1
    }
    createEnterAnimationControls() {
        return animate6(this, {
            opacity: [0, 1],
            transform: ["translateY(25px)", "translateY(0)"]
        }, {
            duration: .4,
            easing: [.645, .045, .355, 1]
        })
    }
    createLeaveAnimationControls() {
        return animate6(this, {
            opacity: [1, 0],
            transform: ["translateY(0)", "translateY(25px)"]
        }, {
            duration: .4,
            easing: [.645, .045, .355, 1]
        })
    }
}
;
window.customElements.get("pop-in") || window.customElements.define("pop-in", PopIn);
import {animate as animate7, timeline as timeline4} from "vendor";
var _FacetsDrawer_instances, updateFacets_fn, Popover = class extends DialogElement {
    connectedCallback() {
        super.connectedCallback(),
        this.controls.forEach(e => e.setAttribute("aria-haspopup", "dialog")),
        this.hasAttribute("close-on-listbox-select") && this.addEventListener("listbox:select", this.hide, {
            signal: this.abortController.signal
        }),
        this.hasAttribute("close-on-listbox-change") && this.addEventListener("change", this.hide, {
            signal: this.abortController.signal
        })
    }
    get shadowDomTemplate() {
        return this.getAttribute("template") || "popover-default-template"
    }
    get shouldLock() {
        return matchesMediaQuery("md-max")
    }
    get shouldAppendToBody() {
        return matchesMediaQuery("md-max")
    }
    get preventScrollWhenTrapped() {
        return !0
    }
    createEnterAnimationControls() {
        return matchesMediaQuery("md") ? animate7(this, {
            opacity: [0, 1]
        }, {
            duration: .2
        }) : timeline4([[this.getShadowPartByName("overlay"), {
            opacity: [0, 1]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1]
        }], [this.getShadowPartByName("content"), {
            transform: ["translateY(100%)", "translateY(0)"]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1],
            at: "<"
        }]])
    }
    createLeaveAnimationControls() {
        return matchesMediaQuery("md") ? animate7(this, {
            opacity: [1, 0]
        }, {
            duration: .2
        }) : timeline4([[this.getShadowPartByName("overlay"), {
            opacity: [1, 0]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1]
        }], [this.getShadowPartByName("content"), {
            transform: ["translateY(0)", "translateY(100%)"]
        }, {
            duration: .3,
            easing: [.645, .045, .355, 1],
            at: "<"
        }]])
    }
}
;
window.customElements.get("x-popover") || window.customElements.define("x-popover", Popover);
var _FacetLink_instances, onFacetUpdate_fn, FacetsDrawer = class extends Drawer {
    constructor() {
        super(),
        __privateAdd(this, _FacetsDrawer_instances),
        this.addEventListener("dialog:after-hide", __privateMethod(this, _FacetsDrawer_instances, updateFacets_fn))
    }
}
;
_FacetsDrawer_instances = new WeakSet,
updateFacets_fn = function() {
    const e = this.querySelector("facets-form form");
    HTMLFormElement.prototype.requestSubmit ? e?.requestSubmit() : e?.dispatchEvent(new Event("submit",{
        bubbles: !0,
        cancelable: !0
    }))
}
,
window.customElements.get("facets-drawer") || window.customElements.define("facets-drawer", FacetsDrawer);
var _FacetsSortPopover_instances, onSortChange_fn, FacetLink = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _FacetLink_instances),
        this.addEventListener("click", __privateMethod(this, _FacetLink_instances, onFacetUpdate_fn).bind(this))
    }
}
;
_FacetLink_instances = new WeakSet,
onFacetUpdate_fn = function(e) {
    e.preventDefault();
    const t = extractSectionId(e.target)
      , i = new URL(this.firstElementChild.href);
    i.searchParams.set("section_id", t),
    this.dispatchEvent(new CustomEvent("facet:update",{
        bubbles: !0,
        detail: {
            url: i
        }
    }))
}
,
window.customElements.get("facet-link") || window.customElements.define("facet-link", FacetLink);
var FacetsSortPopover = class extends Popover {
    constructor() {
        super(),
        __privateAdd(this, _FacetsSortPopover_instances),
        this.addEventListener("listbox:change", __privateMethod(this, _FacetsSortPopover_instances, onSortChange_fn))
    }
}
;
_FacetsSortPopover_instances = new WeakSet,
onSortChange_fn = function(e) {
    const t = new URL(window.location.href);
    t.searchParams.set("sort_by", e.detail.value),
    t.searchParams.delete("page"),
    t.searchParams.set("section_id", this.getAttribute("section-id")),
    this.dispatchEvent(new CustomEvent("facet:update",{
        bubbles: !0,
        detail: {
            url: t
        }
    }))
}
,
window.customElements.get("facets-sort-popover") || window.customElements.define("facets-sort-popover", FacetsSortPopover);
import {Delegate as Delegate3} from "vendor";
var _allowUpdatingProgress, _ProgressBar_instances, calculateProgressBar_fn, abortController = null, delegate = new Delegate3(document.body), openDetailsValues = new Set(Array.from(document.querySelectorAll('facets-form details[open] input[name*="filter."]'), e => e.name));
delegate.on("toggle", "facets-form details", (e, t) => {
    [...new Set(Array.from(t.querySelectorAll('input[name*="filter."]'), e2 => e2.name))].forEach(e2 => {
        t.open ? openDetailsValues.add(e2) : openDetailsValues.delete(e2)
    }
    )
}
, !0),
document.addEventListener("facet:update", async e => {
    abortController && abortController.abort(),
    abortController = new AbortController;
    const t = e.detail.url
      , i = document.getElementById(`shopify-section-${t.searchParams.get("section_id")}`)
      , n = new URL(t);
    n.searchParams.delete("section_id"),
    history.replaceState({}, "", n.toString());
    try {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start",{
            bubbles: !0
        }));
        const e2 = new DOMParser().parseFromString(await (await cachedFetch(t.toString(), {
            signal: abortController.signal
        })).text(), "text/html");
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end",{
            bubbles: !0
        })),
        e2.querySelector(".shopify-section").querySelectorAll("facets-form details").forEach(e3 => {
            [...new Set(Array.from(e3.querySelectorAll('input[name*="filter."]'), e4 => e4.name))].forEach(t2 => {
                e3.open = openDetailsValues.has(t2)
            }
            )
        }
        );
        const n2 = document.activeElement;
        i.replaceChildren(...document.importNode(e2.querySelector(".shopify-section"), !0).childNodes),
        n2?.id && document.getElementById(n2.id) && document.getElementById(n2.id).focus();
        const a = () => i.querySelector(".collection").scrollIntoView({
            block: "start",
            behavior: "smooth"
        });
        "requestIdleCallback" in window ? requestIdleCallback(a, {
            timeout: 500
        }) : requestAnimationFrame(a)
    } catch {}
}
);
import {inView as inView5} from "vendor";
var ProgressBar = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ProgressBar_instances),
        __privateAdd(this, _allowUpdatingProgress, !this.hasAttribute("animate-on-scroll"))
    }
    static get observedAttributes() {
        return ["aria-valuenow", "aria-valuemax"]
    }
    connectedCallback() {
        this.hasAttribute("animate-on-scroll") && inView5(this, () => {
            __privateSet(this, _allowUpdatingProgress, !0),
            __privateMethod(this, _ProgressBar_instances, calculateProgressBar_fn).call(this)
        }
        )
    }
    get progress() {
        return Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"))
    }
    set valueMax(e) {
        this.setAttribute("aria-valuemax", e)
    }
    set valueNow(e) {
        this.setAttribute("aria-valuenow", e)
    }
    attributeChangedCallback() {
        __privateGet(this, _allowUpdatingProgress) && __privateMethod(this, _ProgressBar_instances, calculateProgressBar_fn).call(this)
    }
}
;
_allowUpdatingProgress = new WeakMap,
_ProgressBar_instances = new WeakSet,
calculateProgressBar_fn = function() {
    this.style.setProperty("--progress", `${this.progress}`)
}
,
window.customElements.get("progress-bar") || window.customElements.define("progress-bar", ProgressBar);
var _abortController5, _decreaseButton, _increaseButton, _inputElement, _QuantitySelector_instances, onDecreaseQuantity_fn, onIncreaseQuantity_fn, updateUI_fn, PriceRange = class extends HTMLElement {
    #e;
    connectedCallback() {
        this.#e = this.#e ?? new AbortController;
        const e = this.#e.signal
          , t = this.querySelector("[data-lower-bound]") || this.querySelector('input[name*="price"][type="number"]:first-of-type') || this.querySelector('input[type="number"]')
          , i = this.querySelector("[data-upper-bound]") || this.querySelectorAll('input[name*="price"][type="number"]')[1] || this.querySelectorAll('input[type="number"]')[1];
        t?.addEventListener("focus", () => t.select(), {
            signal: e
        }),
        i?.addEventListener("focus", () => i.select(), {
            signal: e
        })
    }
    disconnectedCallback() {
        this.#e.abort()
    }
}
;
window.customElements.get("price-range") || window.customElements.define("price-range", PriceRange);
var _QuantityInput_instances, inputElement_get, onValueInput_fn, onValueChange_fn, QuantitySelector = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _QuantitySelector_instances),
        __privateAdd(this, _abortController5),
        __privateAdd(this, _decreaseButton),
        __privateAdd(this, _increaseButton),
        __privateAdd(this, _inputElement)
    }
    connectedCallback() {
        __privateSet(this, _abortController5, new AbortController),
        __privateSet(this, _decreaseButton, this.querySelector("button:first-of-type")),
        __privateSet(this, _increaseButton, this.querySelector("button:last-of-type")),
        __privateSet(this, _inputElement, this.querySelector("input")),
        __privateGet(this, _decreaseButton)?.addEventListener("click", __privateMethod(this, _QuantitySelector_instances, onDecreaseQuantity_fn).bind(this), {
            signal: __privateGet(this, _abortController5).signal
        }),
        __privateGet(this, _increaseButton)?.addEventListener("click", __privateMethod(this, _QuantitySelector_instances, onIncreaseQuantity_fn).bind(this), {
            signal: __privateGet(this, _abortController5).signal
        }),
        __privateGet(this, _inputElement)?.addEventListener("input", () => __privateMethod(this, _QuantitySelector_instances, updateUI_fn).call(this), {
            signal: __privateGet(this, _abortController5).signal
        })
    }
    disconnectedCallback() {
        __privateGet(this, _abortController5).abort()
    }
    get quantity() {
        return __privateGet(this, _inputElement).value
    }
    set quantity(e) {
        __privateGet(this, _inputElement).value = e,
        __privateGet(this, _inputElement).dispatchEvent(new Event("change",{
            bubbles: !0
        })),
        __privateMethod(this, _QuantitySelector_instances, updateUI_fn).call(this)
    }
    restoreDefaultValue() {
        __privateGet(this, _inputElement).value = __privateGet(this, _inputElement).defaultValue,
        __privateMethod(this, _QuantitySelector_instances, updateUI_fn).call(this)
    }
}
;
_abortController5 = new WeakMap,
_decreaseButton = new WeakMap,
_increaseButton = new WeakMap,
_inputElement = new WeakMap,
_QuantitySelector_instances = new WeakSet,
onDecreaseQuantity_fn = function() {
    this.hasAttribute("allow-reset-to-zero") && __privateGet(this, _inputElement).value === __privateGet(this, _inputElement).min ? __privateGet(this, _inputElement).value = 0 : __privateGet(this, _inputElement).stepDown(),
    __privateGet(this, _inputElement).dispatchEvent(new Event("change",{
        bubbles: !0
    })),
    __privateMethod(this, _QuantitySelector_instances, updateUI_fn).call(this)
}
,
onIncreaseQuantity_fn = function() {
    __privateGet(this, _inputElement).stepUp(),
    __privateGet(this, _inputElement).dispatchEvent(new Event("change",{
        bubbles: !0
    })),
    __privateMethod(this, _QuantitySelector_instances, updateUI_fn).call(this)
}
,
updateUI_fn = function() {
    __privateGet(this, _decreaseButton) && (this.hasAttribute("allow-reset-to-zero") && __privateGet(this, _inputElement).value === __privateGet(this, _inputElement).min ? __privateGet(this, _decreaseButton).disabled = !1 : __privateGet(this, _decreaseButton).disabled = parseInt(__privateGet(this, _inputElement).value) <= parseInt(__privateGet(this, _inputElement).min)),
    __privateGet(this, _increaseButton) && (__privateGet(this, _increaseButton).disabled = !!__privateGet(this, _inputElement).hasAttribute("max") && parseInt(__privateGet(this, _inputElement).value) >= parseInt(__privateGet(this, _inputElement).max))
}
;
var _accessibilityInitialized, _hiddenInput, _Listbox_instances, setupAccessibility_fn, onOptionClicked_fn, onInputChanged_fn, onKeyDown_fn, QuantityInput = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _QuantityInput_instances)
    }
    connectedCallback() {
        const e = __privateGet(this, _QuantityInput_instances, inputElement_get);
        e && (e.addEventListener("input", __privateMethod(this, _QuantityInput_instances, onValueInput_fn).bind(this)),
        e.addEventListener("change", __privateMethod(this, _QuantityInput_instances, onValueChange_fn).bind(this)),
        e.addEventListener("focus", () => __privateGet(this, _QuantityInput_instances, inputElement_get)?.select()),
        this.style.setProperty("--quantity-selector-character-count", `${(e.value ?? "").length}ch`))
    }
    get quantity() {
        const e = parseInt(__privateGet(this, _QuantityInput_instances, inputElement_get)?.value ?? "0", 10);
        return Number.isNaN(e) ? 0 : e
    }
}
;
_QuantityInput_instances = new WeakSet,
inputElement_get = function() {
    return this.firstElementChild
}
,
onValueInput_fn = function() {
    const e = __privateGet(this, _QuantityInput_instances, inputElement_get);
    e && (e.value === "" && (e.value = e.min || 1),
    this.style.setProperty("--quantity-selector-character-count", `${e.value.length}ch`))
}
,
onValueChange_fn = function() {
    const e = __privateGet(this, _QuantityInput_instances, inputElement_get);
    e && (e.checkValidity() || e.stepDown())
}
,
window.customElements.get("quantity-input") || window.customElements.define("quantity-input", QuantityInput);
var _ImageParallax_instances, setupParallax_fn, Listbox = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _Listbox_instances),
        __privateAdd(this, _accessibilityInitialized, !1),
        __privateAdd(this, _hiddenInput),
        this.addEventListener("keydown", __privateMethod(this, _Listbox_instances, onKeyDown_fn))
    }
    static get observedAttributes() {
        return ["aria-activedescendant"]
    }
    connectedCallback() {
        __privateSet(this, _hiddenInput, this.querySelector('input[type="hidden"]')),
        __privateGet(this, _hiddenInput)?.addEventListener("change", __privateMethod(this, _Listbox_instances, onInputChanged_fn).bind(this)),
        __privateGet(this, _accessibilityInitialized) || requestAnimationFrame(__privateMethod(this, _Listbox_instances, setupAccessibility_fn).bind(this))
    }
    attributeChangedCallback(e, t, i) {
        e === "aria-activedescendant" && t !== null && i !== t && Array.from(this.querySelectorAll('[role="option"]')).forEach(e2 => {
            e2.id === i ? (e2.setAttribute("aria-selected", "true"),
            __privateGet(this, _hiddenInput) && __privateGet(this, _hiddenInput).value !== e2.value && (__privateGet(this, _hiddenInput).value = e2.value,
            __privateGet(this, _hiddenInput).dispatchEvent(new Event("change",{
                bubbles: !0
            }))),
            this.hasAttribute("aria-owns") && this.getAttribute("aria-owns").split(" ").forEach(t2 => {
                document.getElementById(t2).textContent = e2.getAttribute("title") || e2.innerText || e2.value
            }
            ),
            e2.dispatchEvent(new CustomEvent("listbox:change",{
                bubbles: !0,
                detail: {
                    value: e2.value
                }
            }))) : e2.setAttribute("aria-selected", "false")
        }
        )
    }
}
;
_accessibilityInitialized = new WeakMap,
_hiddenInput = new WeakMap,
_Listbox_instances = new WeakSet,
setupAccessibility_fn = function() {
    this.setAttribute("role", "listbox"),
    Array.from(this.querySelectorAll('[role="option"]')).forEach(e => {
        e.addEventListener("click", __privateMethod(this, _Listbox_instances, onOptionClicked_fn).bind(this)),
        e.id = "option-" + (crypto.randomUUID ? crypto.randomUUID() : Math.floor(1e4 * Math.random())),
        e.getAttribute("aria-selected") === "true" && this.setAttribute("aria-activedescendant", e.id)
    }
    ),
    __privateSet(this, _accessibilityInitialized, !0)
}
,
onOptionClicked_fn = function(e) {
    e.currentTarget.getAttribute("type") !== "submit" && (this.setAttribute("aria-activedescendant", e.currentTarget.id),
    e.currentTarget.dispatchEvent(new CustomEvent("listbox:select",{
        bubbles: !0,
        detail: {
            value: e.currentTarget.value
        }
    })))
}
,
onInputChanged_fn = function(e) {
    this.setAttribute("aria-activedescendant", this.querySelector(`[role="option"][value="${CSS.escape(e.target.value)}"]`).id)
}
,
onKeyDown_fn = function(e) {
    e.key === "ArrowUp" ? (e.target.previousElementSibling?.focus(),
    e.preventDefault()) : e.key === "ArrowDown" && (e.target.nextElementSibling?.focus(),
    e.preventDefault())
}
,
window.customElements.get("x-listbox") || window.customElements.define("x-listbox", Listbox);
import {scroll, animate as animate8} from "vendor";
var _recipientCheckbox, _recipientOtherProperties, _recipientSendOnProperty, _offsetProperty, _recipientFieldsContainer, _GiftCardRecipient_instances, synchronizeProperties_fn, formatDate_fn, ImageParallax = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ImageParallax_instances)
    }
    connectedCallback() {
        window.matchMedia("(prefers-reduced-motion: no-preference)").matches && __privateMethod(this, _ImageParallax_instances, setupParallax_fn).call(this)
    }
}
;
_ImageParallax_instances = new WeakSet,
setupParallax_fn = function() {
    const [e,t] = [1.3, 11.538461538461538]
      , i = this.closest(".shopify-section").matches(":first-child");
    scroll(animate8(this.querySelector("img"), {
        transform: [`scale(${e}) translateY(-${t}%)`, `scale(${e}) translateY(${t}%)`]
    }, {
        easing: "linear"
    }), {
        target: this.querySelector("img"),
        offset: [i ? "start start" : "start end", "end start"]
    })
}
,
window.customElements.get("image-parallax") || window.customElements.define("image-parallax", ImageParallax);
var _delegate3, _ProductCard_instances, onSwatchHovered_fn, onSwatchChanged_fn, createMediaImg_fn, GiftCardRecipient = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _GiftCardRecipient_instances),
        __privateAdd(this, _recipientCheckbox),
        __privateAdd(this, _recipientOtherProperties, []),
        __privateAdd(this, _recipientSendOnProperty),
        __privateAdd(this, _offsetProperty),
        __privateAdd(this, _recipientFieldsContainer)
    }
    connectedCallback() {
        const e = Array.from(this.querySelectorAll('[name*="properties"]'))
          , t = "properties[__shopify_send_gift_card_to_recipient]";
        __privateSet(this, _recipientCheckbox, e.find(e2 => e2.name === t)),
        __privateSet(this, _recipientOtherProperties, e.filter(e2 => e2.name !== t)),
        __privateSet(this, _recipientFieldsContainer, this.querySelector(".gift-card-recipient__fields")),
        __privateSet(this, _offsetProperty, this.querySelector('[name="properties[__shopify_offset]"]')),
        __privateGet(this, _offsetProperty) && (__privateGet(this, _offsetProperty).value = new Date().getTimezoneOffset().toString()),
        __privateSet(this, _recipientSendOnProperty, this.querySelector('[name="properties[Send on]"]'));
        const i = new Date
          , n = new Date;
        n.setDate(i.getDate() + 90),
        __privateGet(this, _recipientSendOnProperty)?.setAttribute("min", __privateMethod(this, _GiftCardRecipient_instances, formatDate_fn).call(this, i)),
        __privateGet(this, _recipientSendOnProperty)?.setAttribute("max", __privateMethod(this, _GiftCardRecipient_instances, formatDate_fn).call(this, n)),
        __privateGet(this, _recipientCheckbox)?.addEventListener("change", __privateMethod(this, _GiftCardRecipient_instances, synchronizeProperties_fn).bind(this)),
        __privateMethod(this, _GiftCardRecipient_instances, synchronizeProperties_fn).call(this)
    }
}
;
_recipientCheckbox = new WeakMap,
_recipientOtherProperties = new WeakMap,
_recipientSendOnProperty = new WeakMap,
_offsetProperty = new WeakMap,
_recipientFieldsContainer = new WeakMap,
_GiftCardRecipient_instances = new WeakSet,
synchronizeProperties_fn = function() {
    __privateGet(this, _recipientOtherProperties).forEach(e => e.disabled = !__privateGet(this, _recipientCheckbox).checked),
    __privateGet(this, _recipientFieldsContainer).toggleAttribute("hidden", !__privateGet(this, _recipientCheckbox).checked)
}
,
formatDate_fn = function(e) {
    const t = e.getTimezoneOffset();
    return new Date(e.getTime() - 60 * t * 1e3).toISOString().split("T")[0]
}
,
window.customElements.get("gift-card-recipient") || window.customElements.define("gift-card-recipient", GiftCardRecipient);
import {Delegate as Delegate4} from "vendor";
var _abortController6, _ProductForm_instances, form_get2, onSubmit_fn, ProductCard = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ProductCard_instances),
        __privateAdd(this, _delegate3, new Delegate4(this))
    }
    connectedCallback() {
        __privateGet(this, _delegate3).on("change", '.product-card__info [type="radio"]', __privateMethod(this, _ProductCard_instances, onSwatchChanged_fn).bind(this)),
        __privateGet(this, _delegate3).on("pointerover", '.product-card__info [type="radio"] + label', __privateMethod(this, _ProductCard_instances, onSwatchHovered_fn).bind(this), !0)
    }
    disconnectedCallback() {
        __privateGet(this, _delegate3).off()
    }
}
;
_delegate3 = new WeakMap,
_ProductCard_instances = new WeakSet,
onSwatchHovered_fn = async function(e, t) {
    const i = t.control
      , n = this.querySelector(".product-card__image--primary");
    i.hasAttribute("data-variant-media") && __privateMethod(this, _ProductCard_instances, createMediaImg_fn).call(this, JSON.parse(i.getAttribute("data-variant-media")), n.className, n.sizes)
}
,
onSwatchChanged_fn = async function(e, t) {
    if (t.hasAttribute("data-product-url") ? this.querySelectorAll(`a[href^="${Shopify.routes.root}products/"`).forEach(e2 => {
        e2.href = t.getAttribute("data-product-url")
    }
    ) : t.hasAttribute("data-variant-id") && this.querySelectorAll(`a[href^="${Shopify.routes.root}products/"`).forEach(e2 => {
        const i2 = new URL(e2.href);
        i2.searchParams.set("variant", t.getAttribute("data-variant-id")),
        e2.href = `${i2.pathname}${i2.search}${i2.hash}`
    }
    ),
    !t.hasAttribute("data-variant-media"))
        return;
    let i = JSON.parse(t.getAttribute("data-variant-media"))
      , n = this.querySelector(".product-card__image--primary")
      , a = this.querySelector(".product-card__image--secondary")
      , s = __privateMethod(this, _ProductCard_instances, createMediaImg_fn).call(this, i, n.className, n.sizes)
      , r = null;
    if (a && t.hasAttribute("data-variant-secondary-media")) {
        let e2 = JSON.parse(t.getAttribute("data-variant-secondary-media"));
        r = __privateMethod(this, _ProductCard_instances, createMediaImg_fn).call(this, e2, a.className, a.sizes)
    }
    n.src !== s.src && (a && r && a.replaceWith(r),
    await n.animate({
        opacity: [1, 0]
    }, {
        duration: 150,
        easing: "ease-in",
        fill: "forwards"
    }).finished,
    await new Promise(e2 => s.complete ? e2() : s.onload = () => e2()),
    n.replaceWith(s),
    s.animate({
        opacity: [0, 1]
    }, {
        duration: 150,
        easing: "ease-in"
    }))
}
,
createMediaImg_fn = function(e, t, i) {
    return createMediaImg(e, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800], {
        class: t,
        sizes: i
    })
}
,
window.customElements.get("product-card") || window.customElements.define("product-card", ProductCard);
var _abortController7, _BuyButtons_instances, onVariantAdded_fn, onCartError_fn, ProductForm = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ProductForm_instances),
        __privateAdd(this, _abortController6)
    }
    connectedCallback() {
        __privateSet(this, _abortController6, new AbortController),
        __privateGet(this, _ProductForm_instances, form_get2) && (__privateGet(this, _ProductForm_instances, form_get2).addEventListener("submit", __privateMethod(this, _ProductForm_instances, onSubmit_fn).bind(this), {
            signal: __privateGet(this, _abortController6).signal
        }),
        __privateGet(this, _ProductForm_instances, form_get2).id.disabled = !1)
    }
    disconnectedCallback() {
        __privateGet(this, _abortController6).abort()
    }
}
;
_abortController6 = new WeakMap,
_ProductForm_instances = new WeakSet,
form_get2 = function() {
    return this.querySelector('form[action*="/cart/add"]')
}
,
onSubmit_fn = async function(e) {
    if (e.preventDefault(),
    e.submitter?.getAttribute("aria-busy") === "true")
        return;
    if (!__privateGet(this, _ProductForm_instances, form_get2).checkValidity())
        return void __privateGet(this, _ProductForm_instances, form_get2).reportValidity();
    const t = Array.from(__privateGet(this, _ProductForm_instances, form_get2).elements).filter(e2 => e2.type === "submit");
    t.forEach(e2 => {
        e2.setAttribute("aria-busy", "true")
    }
    ),
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start",{
        bubbles: !0
    }));
    let i = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections",{
        bubbles: !0,
        detail: {
            sections: i
        }
    }));
    const n = new FormData(__privateGet(this, _ProductForm_instances, form_get2));
    n.set("sections", i.join(",")),
    n.set("sections_url", `${Shopify.routes.root}variants/${__privateGet(this, _ProductForm_instances, form_get2).id.value}`);
    const a = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: n,
        method: "POST",
        headers: {
            "X-Requested-With": "XMLHttpRequest"
        }
    });
    t.forEach(e2 => {
        e2.removeAttribute("aria-busy")
    }
    );
    const s = await a.json();
    if (document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end",{
        bubbles: !0
    })),
    a.ok) {
        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart")
            return window.location.href = `${Shopify.routes.root}cart`;
        const e2 = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        e2.sections = s.sections,
        __privateGet(this, _ProductForm_instances, form_get2).dispatchEvent(new CustomEvent("variant:add",{
            bubbles: !0,
            detail: {
                items: s.hasOwnProperty("items") ? s.items : [s],
                cart: e2,
                onSuccessDo: n.get("on_success")
            }
        })),
        document.documentElement.dispatchEvent(new CustomEvent("cart:change",{
            bubbles: !0,
            detail: {
                baseEvent: "variant:add",
                onSuccessDo: n.get("on_success"),
                cart: e2
            }
        }))
    } else
        __privateGet(this, _ProductForm_instances, form_get2).dispatchEvent(new CustomEvent("cart:error",{
            bubbles: !0,
            detail: {
                error: s.description
            }
        })),
        document.dispatchEvent(new CustomEvent("cart:refresh"))
}
,
window.customElements.get("product-form") || window.customElements.define("product-form", ProductForm);
var _abortController8, _photoSwipeInstance, _onGestureChangedListener, _settledMedia, _ProductGallery_instances, registerLightboxUi_fn, onSectionRerender_fn, onVariantChange_fn, onMediaChange_fn, onMediaSettle_fn, onCarouselClick_fn, onGestureStart_fn, onGestureChanged_fn, BuyButtons = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _BuyButtons_instances),
        __privateAdd(this, _abortController7)
    }
    connectedCallback() {
        __privateSet(this, _abortController7, new AbortController),
        document.forms[this.getAttribute("form")]?.addEventListener("cart:error", __privateMethod(this, _BuyButtons_instances, onCartError_fn).bind(this), {
            signal: __privateGet(this, _abortController7).signal
        }),
        window.themeVariables.settings.cartType === "message" && document.forms[this.getAttribute("form")]?.addEventListener("variant:add", __privateMethod(this, _BuyButtons_instances, onVariantAdded_fn).bind(this), {
            signal: __privateGet(this, _abortController7).signal
        })
    }
    disconnectedCallback() {
        __privateGet(this, _abortController7).abort()
    }
}
;
_abortController7 = new WeakMap,
_BuyButtons_instances = new WeakSet,
onVariantAdded_fn = function(e) {
    const t = document.createRange().createContextualFragment(`
      <div class="banner banner--success" role="alert">
        ${window.themeVariables.strings.addedToCart}
      </div>
    `).firstElementChild;
    this.prepend(t),
    setTimeout( () => {
        t.remove()
    }
    , 2500)
}
,
onCartError_fn = function(e) {
    const t = document.createRange().createContextualFragment(`
      <div class="banner banner--error" role="alert">
        ${e.detail.error}
      </div>
    `).firstElementChild;
    this.prepend(t),
    setTimeout( () => {
        t.remove()
    }
    , 2500)
}
,
window.customElements.get("buy-buttons") || window.customElements.define("buy-buttons", BuyButtons);
import {PhotoSwipeLightbox} from "vendor";
var _intersectionObserver, _hasProgrammaticScroll, _scrollDirection, _lastScrollPosition, _ProductGalleryNavigation_instances, onMediaObserve_fn, ProductGallery = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _ProductGallery_instances),
        __privateAdd(this, _abortController8),
        __privateAdd(this, _photoSwipeInstance),
        __privateAdd(this, _onGestureChangedListener, __privateMethod(this, _ProductGallery_instances, onGestureChanged_fn).bind(this)),
        __privateAdd(this, _settledMedia),
        this.addEventListener("lightbox:open", e => this.openLightBox(e?.detail?.index))
    }
    connectedCallback() {
        if (__privateSet(this, _abortController8, new AbortController),
        !this.carousel)
            return;
        const e = document.forms[this.getAttribute("form")];
        e.addEventListener("product:rerender", __privateMethod(this, _ProductGallery_instances, onSectionRerender_fn).bind(this), {
            signal: __privateGet(this, _abortController8).signal
        }),
        e.addEventListener("variant:change", __privateMethod(this, _ProductGallery_instances, onVariantChange_fn).bind(this), {
            signal: __privateGet(this, _abortController8).signal
        }),
        this.carousel.addEventListener("carousel:change", __privateMethod(this, _ProductGallery_instances, onMediaChange_fn).bind(this), {
            signal: __privateGet(this, _abortController8).signal
        }),
        this.carousel.addEventListener("carousel:settle", __privateMethod(this, _ProductGallery_instances, onMediaSettle_fn).bind(this), {
            signal: __privateGet(this, _abortController8).signal
        }),
        this.carousel.addEventListener("click", __privateMethod(this, _ProductGallery_instances, onCarouselClick_fn).bind(this), {
            signal: __privateGet(this, _abortController8).signal
        }),
        this.hasAttribute("allow-zoom") && this.carousel.addEventListener("gesturestart", __privateMethod(this, _ProductGallery_instances, onGestureStart_fn).bind(this), {
            capture: !1,
            signal: __privateGet(this, _abortController8).signal
        }),
        __privateMethod(this, _ProductGallery_instances, onMediaChange_fn).call(this)
    }
    disconnectedCallback() {
        __privateGet(this, _abortController8).abort()
    }
    get viewInSpaceButton() {
        return this.querySelector("[data-shopify-xr]")
    }
    get carousel() {
        return this.querySelector(".product-gallery__carousel")
    }
    get lightBox() {
        return __privateGet(this, _photoSwipeInstance) || (__privateSet(this, _photoSwipeInstance, new PhotoSwipeLightbox({
            pswpModule: () => import("photoswipe"),
            bgOpacity: 1,
            maxZoomLevel: parseInt(this.getAttribute("allow-zoom")) || 3,
            closeTitle: window.themeVariables.strings.closeGallery,
            zoomTitle: window.themeVariables.strings.zoomGallery,
            errorMsg: window.themeVariables.strings.errorGallery,
            arrowPrev: !1,
            arrowNext: !1,
            counter: !1,
            close: !1,
            zoom: !1
        })),
        __privateGet(this, _photoSwipeInstance).on("uiRegister", __privateMethod(this, _ProductGallery_instances, registerLightboxUi_fn).bind(this)),
        __privateGet(this, _photoSwipeInstance).addFilter("thumbEl", (e, t) => t.thumbnailElement),
        __privateGet(this, _photoSwipeInstance).init()),
        __privateGet(this, _photoSwipeInstance)
    }
    get filteredIndexes() {
        return JSON.parse(this.getAttribute("filtered-indexes")).map(e => parseInt(e) - 1)
    }
    openLightBox(e) {
        const t = this.carousel.cells.flatMap(e2 => Array.from(e2.querySelectorAll(":scope > img"))).map(e2 => ({
            thumbnailElement: e2,
            src: e2.src,
            srcset: e2.srcset,
            msrc: e2.currentSrc || e2.src,
            width: parseInt(e2.getAttribute("width")),
            height: parseInt(e2.getAttribute("height")),
            alt: e2.alt,
            thumbCropped: !0
        }))
          , i = this.carousel.cells.filter(e2 => e2.getAttribute("data-media-type") === "image");
        this.lightBox.loadAndOpen(e ?? i.indexOf(this.carousel.selectedCell), t)
    }
}
;
_abortController8 = new WeakMap,
_photoSwipeInstance = new WeakMap,
_onGestureChangedListener = new WeakMap,
_settledMedia = new WeakMap,
_ProductGallery_instances = new WeakSet,
registerLightboxUi_fn = function() {
    __privateGet(this, _photoSwipeInstance).pswp.ui.registerElement({
        name: "close-button",
        className: "circle-button circle-button--xl hover:animate-icon-block",
        ariaLabel: window.themeVariables.strings.closeGallery,
        order: 2,
        isButton: !0,
        html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16">
          <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"/>
        </svg>
      `,
        onClick: () => {
            __privateGet(this, _photoSwipeInstance).pswp.close()
        }
    }),
    __privateGet(this, _photoSwipeInstance).pswp.options.dataSource.length > 1 && (__privateGet(this, _photoSwipeInstance).pswp.ui.registerElement({
        name: "previous-button",
        className: "circle-button hover:animate-icon-inline",
        ariaLabel: window.themeVariables.strings.previous,
        order: 1,
        isButton: !0,
        html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">
          <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/>
        </svg>
      `,
        onClick: () => {
            __privateGet(this, _photoSwipeInstance).pswp.prev()
        }
    }),
    __privateGet(this, _photoSwipeInstance).pswp.ui.registerElement({
        name: "next-button",
        className: "circle-button hover:animate-icon-inline",
        ariaLabel: window.themeVariables.strings.next,
        order: 3,
        isButton: !0,
        html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">
          <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"/>
        </svg>
      `,
        onClick: () => {
            __privateGet(this, _photoSwipeInstance).pswp.next()
        }
    }))
}
,
onSectionRerender_fn = function(e) {
    const t = deepQuerySelector(e.detail.htmlFragment, `${this.tagName}[form="${this.getAttribute("form")}"]`);
    t && t.filteredIndex !== this.filteredIndexes && (this.carousel.filter(t.filteredIndexes),
    this.setAttribute("filtered-indexes", t.getAttribute("filtered-indexes")))
}
,
onVariantChange_fn = function(e) {
    if (e.detail.variant && e.detail.variant.featured_media && e.detail.previousVariant?.featured_media?.id !== e.detail.variant.featured_media.id) {
        const t = e.detail.variant.featured_media.position - 1
          , i = this.filteredIndexes.filter(e2 => e2 < t);
        this.carousel.isScrollable ? this.carousel.select(t - i.length, {
            instant: !0
        }) : this.querySelector(`[data-media-id="${e.detail.variant.featured_media.id}"]`)?.scrollIntoView({
            block: "start",
            behavior: "smooth"
        })
    }
}
,
onMediaChange_fn = function() {
    if (__privateGet(this, _settledMedia))
        switch (__privateGet(this, _settledMedia).getAttribute("data-media-type")) {
        case "external_video":
        case "video":
        case "model":
            __privateGet(this, _settledMedia).firstElementChild.pause()
        }
}
,
onMediaSettle_fn = function(e) {
    const t = e ? e.detail.cell : this.carousel.selectedCell
      , i = this.querySelector(".product-gallery__zoom-button");
    switch (t.getAttribute("data-media-type")) {
    case "image":
        this.viewInSpaceButton?.setAttribute("data-shopify-model3d-id", this.viewInSpaceButton?.getAttribute("data-shopify-model3d-default-id")),
        i?.classList.remove("product-gallery__zoom-button--hidden");
        break;
    case "external_video":
    case "video":
        this.viewInSpaceButton?.setAttribute("data-shopify-model3d-id", this.viewInSpaceButton?.getAttribute("data-shopify-model3d-default-id")),
        i?.classList.add("product-gallery__zoom-button--hidden"),
        this.hasAttribute("autoplay-media") && t.firstElementChild.play();
        break;
    case "model":
        matchesMediaQuery("md") && t.firstElementChild.play(),
        this.viewInSpaceButton?.setAttribute("data-shopify-model3d-id", e.detail.cell.getAttribute("data-media-id")),
        i?.classList.add("product-gallery__zoom-button--hidden")
    }
    __privateSet(this, _settledMedia, t)
}
,
onCarouselClick_fn = function(e) {
    if (!this.hasAttribute("allow-zoom") || !matchesMediaQuery("md") || e.target.tagName !== "IMG")
        return;
    const t = e.target.closest(".product-gallery__media");
    if (t.getAttribute("data-media-type") !== "image")
        return;
    const i = this.carousel.cells.filter(e2 => e2.getAttribute("data-media-type") === "image");
    this.dispatchEvent(new CustomEvent("lightbox:open",{
        bubbles: !0,
        detail: {
            index: i.indexOf(t)
        }
    }))
}
,
onGestureStart_fn = function(e) {
    e.preventDefault(),
    this.carousel.addEventListener("gesturechange", __privateGet(this, _onGestureChangedListener), {
        capture: !1,
        signal: __privateGet(this, _abortController8).signal
    })
}
,
onGestureChanged_fn = function(e) {
    e.preventDefault(),
    e.scale > 1.5 && (this.dispatchEvent(new CustomEvent("lightbox:open",{
        bubbles: !0,
        detail: {
            index: this.carousel.selectedIndex
        }
    })),
    this.removeEventListener("gesturechange", __privateGet(this, _onGestureChangedListener)))
}
;
var ProductGalleryNavigation = class extends CarouselNavigation {
    constructor() {
        super(),
        __privateAdd(this, _ProductGalleryNavigation_instances),
        __privateAdd(this, _intersectionObserver, new IntersectionObserver(__privateMethod(this, _ProductGalleryNavigation_instances, onMediaObserve_fn).bind(this),{
            threshold: [0, .5, 1]
        })),
        __privateAdd(this, _hasProgrammaticScroll, !1),
        __privateAdd(this, _scrollDirection, "bottom"),
        __privateAdd(this, _lastScrollPosition),
        window.addEventListener("scroll", () => {
            window.scrollY > __privateGet(this, _lastScrollPosition) ? __privateSet(this, _scrollDirection, "bottom") : __privateSet(this, _scrollDirection, "top"),
            __privateSet(this, _lastScrollPosition, window.scrollY)
        }
        )
    }
    connectedCallback() {
        super.connectedCallback(),
        this.carousel.allCells.forEach(e => __privateGet(this, _intersectionObserver).observe(e))
    }
    onButtonClicked(e) {
        this.carousel.isScrollable ? super.onButtonClicked(e) : (this.carousel.cells[e]?.scrollIntoView({
            block: "start",
            behavior: "smooth"
        }),
        this.onNavigationChange(e),
        __privateSet(this, _hasProgrammaticScroll, !0),
        "onscrollend" in window ? window.addEventListener("scrollend", () => {
            __privateSet(this, _hasProgrammaticScroll, !1)
        }
        , {
            once: !0
        }) : setTimeout( () => {
            __privateSet(this, _hasProgrammaticScroll, !1)
        }
        , 1e3))
    }
}
;
_intersectionObserver = new WeakMap,
_hasProgrammaticScroll = new WeakMap,
_scrollDirection = new WeakMap,
_lastScrollPosition = new WeakMap,
_ProductGalleryNavigation_instances = new WeakSet,
onMediaObserve_fn = function(e) {
    if (this.carousel.isScrollable)
        return;
    const t = e.find(e2 => e2.isIntersecting && e2.intersectionRatio >= .5);
    if (!t || __privateGet(this, _hasProgrammaticScroll))
        return;
    const i = this.items.find(e2 => e2.getAttribute("aria-current") === "true")
      , n = this.items.find(e2 => e2.getAttribute("data-media-id") === t.target.getAttribute("data-media-id"));
    i && (__privateGet(this, _scrollDirection) === "bottom" && parseInt(n.getAttribute("data-media-position")) > parseInt(i.getAttribute("data-media-position")) || __privateGet(this, _scrollDirection) === "top" && parseInt(n.getAttribute("data-media-position")) < parseInt(i.getAttribute("data-media-position"))) && (i.setAttribute("aria-current", "false"),
    n.setAttribute("aria-current", "true"))
}
;
var OpenLightBoxButton = class extends HTMLElement {
    constructor() {
        super(),
        this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("lightbox:open",{
            bubbles: !0
        })))
    }
}
;
window.customElements.get("product-gallery") || window.customElements.define("product-gallery", ProductGallery),
window.customElements.get("product-gallery-navigation") || window.customElements.define("product-gallery-navigation", ProductGalleryNavigation),
window.customElements.get("open-lightbox-button") || window.customElements.define("open-lightbox-button", OpenLightBoxButton);
import {inView as inView6, animate as animate9, stagger} from "vendor";
var ProductList = class extends HTMLElement {
    connectedCallback() {
        matchesMediaQuery("motion-safe") && this.querySelectorAll('product-card[reveal-on-scroll="true"]').length > 0 && inView6(this, this.reveal.bind(this))
    }
    reveal() {
        animate9(this.querySelectorAll('product-card[reveal-on-scroll="true"]'), {
            opacity: [0, 1],
            transform: ["translateY(20px)", "translateY(0)"]
        }, {
            duration: .2,
            easing: "ease-in-out",
            delay: stagger(.05, {
                start: .4,
                easing: "ease-out"
            })
        })
    }
}
;
window.customElements.get("product-list") || window.customElements.define("product-list", ProductList);
var _abortController9, _ProductRerender_instances, onRerender_fn, _QuickBuyModal_instances, onAfterHide_fn, loadedProducts = {}, ProductLoader = class {
    static load(e) {
        if (e)
            return loadedProducts[e] || (loadedProducts[e] = new Promise(async (t, i) => {
                const n = await fetch(`${Shopify.routes.root}products/${e}.js`);
                n.ok ? t(await n.json()) : i(`
          Attempted to load information for product with handle ${e}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `)
            }
            )),
            loadedProducts[e]
    }
}
, ProductRerender = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ProductRerender_instances),
        __privateAdd(this, _abortController9)
    }
    connectedCallback() {
        __privateSet(this, _abortController9, new AbortController),
        this.id && this.hasAttribute("observe-form") || console.warn('The <product-rerender> requires an ID to identify the element to re-render, and an "observe-form" attribute referencing to the form to monitor.'),
        document.forms[this.getAttribute("observe-form")].addEventListener("product:rerender", __privateMethod(this, _ProductRerender_instances, onRerender_fn).bind(this), {
            signal: __privateGet(this, _abortController9).signal
        })
    }
    disconnectedCallback() {
        __privateGet(this, _abortController9).abort()
    }
}
;
_abortController9 = new WeakMap,
_ProductRerender_instances = new WeakSet,
onRerender_fn = function(e) {
    const t = deepQuerySelector(e.detail.htmlFragment, `#${this.id}`);
    if (!t)
        return;
    const i = document.activeElement;
    if (!this.hasAttribute("allow-partial-rerender") || e.detail.productChange ? this.replaceWith(t) : ["sku", "badges", "quantity-selector", "volume-pricing", "price", "payment-terms", "variant-picker", "inventory", "buy-buttons", "pickup-availability", "liquid"].forEach(e2 => {
        this.querySelectorAll(`[data-block-type="${e2}"]`).forEach(i2 => {
            const n = t.querySelector(`[data-block-type="${e2}"][data-block-id="${i2.getAttribute("data-block-id")}"]`);
            if (n)
                if (e2 === "buy-buttons")
                    i2.querySelector("buy-buttons").replaceWith(n.querySelector("buy-buttons"));
                else if (e2 === "payment-terms")
                    i2.querySelector('[name="id"]').value = n.querySelector('[name="id"]').value,
                    i2.querySelector('[name="id"]').dispatchEvent(new Event("change",{
                        bubbles: !0
                    }));
                else if (e2 === "quantity-selector") {
                    const e3 = i2.querySelector("quantity-selector");
                    if (e3) {
                        const t2 = e3.quantity;
                        i2.replaceWith(n),
                        n.querySelector("quantity-selector").quantity = t2
                    }
                } else
                    i2.replaceWith(n)
        }
        )
    }
    ),
    i.id) {
        const e2 = document.getElementById(i.id);
        this.contains(e2) && e2.focus()
    }
}
,
window.customElements.get("product-rerender") || window.customElements.define("product-rerender", ProductRerender);
var QuickBuyModal = class extends Modal {
    constructor() {
        super(),
        __privateAdd(this, _QuickBuyModal_instances),
        window.themeVariables.settings.cartType === "drawer" && document.addEventListener("variant:add", this.hide.bind(this)),
        this.addEventListener("dialog:after-hide", __privateMethod(this, _QuickBuyModal_instances, onAfterHide_fn).bind(this))
    }
    async show() {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start",{
            bubbles: !0
        }));
        const e = await (await cachedFetch(`${window.Shopify.routes.root}products/${this.getAttribute("handle")}`)).text();
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end",{
            bubbles: !0
        }));
        const t = new DOMParser().parseFromString(e, "text/html").getElementById("quick-buy-content").content;
        return Array.from(t.querySelectorAll("noscript")).forEach(e2 => e2.remove()),
        this.replaceChildren(t),
        Shopify?.PaymentButton?.init(),
        super.show()
    }
}
;
_QuickBuyModal_instances = new WeakSet,
onAfterHide_fn = function() {
    this.innerHTML = ""
}
,
window.customElements.get("quick-buy-modal") || window.customElements.define("quick-buy-modal", QuickBuyModal);
import {Delegate as Delegate5} from "vendor";
var _preloadedHtml, _delegate4, _intersectionObserver2, _form, _selectedVariant, _VariantPicker_instances, getActiveOptionValues_fn, getOptionValuesFromOption_fn, onOptionChanged_fn, onOptionPreload_fn, onIntersection_fn, renderForCombination_fn, createHashKeyForHtml_fn, CACHE_EVICTION_TIME = 3e5, _VariantPicker = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _VariantPicker_instances),
        __privateAdd(this, _delegate4, new Delegate5(document.body)),
        __privateAdd(this, _intersectionObserver2, new IntersectionObserver(__privateMethod(this, _VariantPicker_instances, onIntersection_fn).bind(this))),
        __privateAdd(this, _form),
        __privateAdd(this, _selectedVariant)
    }
    async connectedCallback() {
        __privateSet(this, _selectedVariant, JSON.parse(this.querySelector("script[data-variant]")?.textContent || "{}")),
        __privateSet(this, _form, document.forms[this.getAttribute("form-id")]),
        __privateGet(this, _delegate4).on("change", `input[data-option-position][form="${this.getAttribute("form-id")}"]`, __privateMethod(this, _VariantPicker_instances, onOptionChanged_fn).bind(this)),
        __privateGet(this, _delegate4).on("pointerenter", `input[data-option-position][form="${this.getAttribute("form-id")}"]:not(:checked) + label`, __privateMethod(this, _VariantPicker_instances, onOptionPreload_fn).bind(this), !0),
        __privateGet(this, _delegate4).on("touchstart", `input[data-option-position][form="${this.getAttribute("form-id")}"]:not(:checked) + label`, __privateMethod(this, _VariantPicker_instances, onOptionPreload_fn).bind(this), !0),
        __privateGet(this, _intersectionObserver2).observe(this)
    }
    disconnectedCallback() {
        __privateGet(this, _delegate4).off(),
        __privateGet(this, _intersectionObserver2).unobserve(this)
    }
    get selectedVariant() {
        return __privateGet(this, _selectedVariant)
    }
    get productHandle() {
        return this.getAttribute("handle")
    }
    get updateUrl() {
        return this.hasAttribute("update-url")
    }
    async selectCombination({optionValues: e, productChange: t}) {
        const i = this.selectedVariant
          , n = document.createRange().createContextualFragment(await __privateMethod(this, _VariantPicker_instances, renderForCombination_fn).call(this, e));
        if (!t) {
            const e2 = deepQuerySelector(n, `${this.tagName}[form-id="${this.getAttribute("form-id")}"]`)
              , t2 = JSON.parse(e2.querySelector("script[data-variant]")?.textContent || "{}");
            if (__privateSet(this, _selectedVariant, t2),
            __privateGet(this, _form).id.value = __privateGet(this, _selectedVariant)?.id,
            __privateGet(this, _form).id.dispatchEvent(new Event("change",{
                bubbles: !0
            })),
            this.updateUrl && __privateGet(this, _selectedVariant)?.id) {
                const e3 = new URL(window.location.href);
                e3.searchParams.set("variant", __privateGet(this, _selectedVariant).id),
                window.history.replaceState({
                    path: e3.toString()
                }, "", e3.toString())
            }
        }
        __privateGet(this, _form).dispatchEvent(new CustomEvent("product:rerender",{
            detail: {
                htmlFragment: n,
                productChange: t
            }
        })),
        t || __privateGet(this, _form).dispatchEvent(new CustomEvent("variant:change",{
            bubbles: !0,
            detail: {
                formId: __privateGet(this, _form).id,
                variant: __privateGet(this, _selectedVariant),
                previousVariant: i
            }
        })),
        Shopify?.PaymentButton?.init()
    }
}
;
_preloadedHtml = new WeakMap,
_delegate4 = new WeakMap,
_intersectionObserver2 = new WeakMap,
_form = new WeakMap,
_selectedVariant = new WeakMap,
_VariantPicker_instances = new WeakSet,
getActiveOptionValues_fn = function() {
    return Array.from(__privateGet(this, _form).elements).filter(e => e.matches("input[data-option-position]:checked")).sort( (e, t) => parseInt(e.getAttribute("data-option-position")) - parseInt(t.getAttribute("data-option-position"))).map(e => e.value)
}
,
getOptionValuesFromOption_fn = function(e) {
    return [e, ...Array.from(__privateGet(this, _form).elements).filter(t => t.matches(`input[data-option-position]:not([name="${e.name}"]):checked`))].sort( (e2, t) => parseInt(e2.getAttribute("data-option-position")) - parseInt(t.getAttribute("data-option-position"))).map(e2 => e2.value)
}
,
onOptionChanged_fn = async function(e) {
    e.target.name.includes("option") && this.selectCombination({
        optionValues: __privateMethod(this, _VariantPicker_instances, getActiveOptionValues_fn).call(this),
        productChange: e.target.hasAttribute("data-product-url")
    })
}
,
onOptionPreload_fn = function(e, t) {
    __privateMethod(this, _VariantPicker_instances, renderForCombination_fn).call(this, __privateMethod(this, _VariantPicker_instances, getOptionValuesFromOption_fn).call(this, t.control))
}
,
onIntersection_fn = function(e) {
    const t = () => {
        Array.from(__privateGet(this, _form).elements).filter(e2 => e2.matches("input[data-option-position]:not(:checked)")).forEach(e2 => {
            __privateMethod(this, _VariantPicker_instances, renderForCombination_fn).call(this, __privateMethod(this, _VariantPicker_instances, getOptionValuesFromOption_fn).call(this, e2))
        }
        )
    }
    ;
    e[0].isIntersecting && (window.requestIdleCallback ? window.requestIdleCallback(t, {
        timeout: 2e3
    }) : t())
}
,
renderForCombination_fn = async function(e) {
    const t = e.join(",")
      , i = __privateMethod(this, _VariantPicker_instances, createHashKeyForHtml_fn).call(this, t);
    let n = `${Shopify.routes.root}products/${this.productHandle}`;
    for (const t2 of e) {
        const e2 = Array.from(__privateGet(this, _form).elements).find(e3 => e3.matches(`input[value="${t2}"]`));
        if (e2?.dataset.productUrl) {
            n = e2.dataset.productUrl;
            break
        }
    }
    if (!__privateGet(_VariantPicker, _preloadedHtml).has(i)) {
        const e2 = this.getAttribute("context") === "quick_buy" ? "" : `&section_id=${this.getAttribute("section-id")}`
          , a = new Promise(async i2 => {
            i2(await (await fetch(`${n}?option_values=${t}${e2}`)).text())
        }
        );
        __privateGet(_VariantPicker, _preloadedHtml).set(i, {
            htmlPromise: a,
            timestamp: Date.now()
        }),
        __privateGet(_VariantPicker, _preloadedHtml).size > 100 && __privateGet(_VariantPicker, _preloadedHtml).delete(Array.from(__privateGet(_VariantPicker, _preloadedHtml).keys())[0])
    }
    return __privateGet(_VariantPicker, _preloadedHtml).get(i).htmlPromise
}
,
createHashKeyForHtml_fn = function(e) {
    return `${e}-${this.getAttribute("section-id")}`
}
,
__privateAdd(_VariantPicker, _preloadedHtml, new Map);
var VariantPicker = _VariantPicker;
window.customElements.get("variant-picker") || window.customElements.define("variant-picker", VariantPicker);
import {inView as inView7} from "vendor";
var BaseMedia = class extends HTMLElement {
    static get observedAttributes() {
        return ["playing"]
    }
    connectedCallback() {
        this._abortController = new AbortController,
        this.hasAttribute("autoplay") && inView7(this, this.play.bind(this), {
            margin: "0px 0px 0px 0px"
        })
    }
    disconnectedCallback() {
        this._abortController.abort()
    }
    get playing() {
        return this.hasAttribute("playing")
    }
    get player() {
        return this._playerProxy = this._playerProxy || new Proxy(this._playerTarget(),{
            get: (e, t) => async () => {
                e = await e,
                this._playerHandler(e, t)
            }
        })
    }
    play() {
        this.playing || this.player.play()
    }
    pause() {
        this.playing && this.player.pause()
    }
    attributeChangedCallback(e, t, i) {
        e === "playing" && (t === null && i === "" ? (this.dispatchEvent(new CustomEvent("media:play",{
            bubbles: !0
        })),
        this.hasAttribute("group") && Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`)).filter(e2 => e2 !== this).forEach(e2 => {
            e2.pause()
        }
        )) : i === null && this.dispatchEvent(new CustomEvent("media:pause",{
            bubbles: !0
        })))
    }
}
  , ModelMedia = class extends BaseMedia {
    connectedCallback() {
        super.connectedCallback(),
        this.player
    }
    _playerTarget() {
        return new Promise(e => {
            this.setAttribute("loaded", ""),
            window.Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: this._setupShopifyXr.bind(this)
            }, {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: () => {
                    const t = this.querySelector("model-viewer");
                    t.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute("playing", "")),
                    t.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute("playing")),
                    e(new window.Shopify.ModelViewerUI(t,{
                        focusOnPlay: !0
                    }))
                }
            }])
        }
        )
    }
    _playerHandler(e, t) {
        e[t]()
    }
    async _setupShopifyXr() {
        if (window.ShopifyXR) {
            const e = (await ProductLoader.load(this.getAttribute("handle"))).media.filter(e2 => e2.media_type === "model");
            window.ShopifyXR.addModels(e),
            window.ShopifyXR.setupXRElements()
        } else
            document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this))
    }
}
;
window.customElements.get("model-media") || window.customElements.define("model-media", ModelMedia);
import {inView as inView8} from "vendor";
var _onSummaryClickedListener, _CustomDetails_instances, onSummaryClicked_fn, onYouTubePromise = new Promise(e => {
    window.onYouTubeIframeAPIReady = () => e()
}
), VideoMedia = class extends BaseMedia {
    #t = !1;
    connectedCallback() {
        super.connectedCallback(),
        this.hasAttribute("autoplay") || this.addEventListener("click", this.play, {
            once: !0,
            signal: this._abortController.signal
        }),
        this.hasAttribute("show-play-button") && !this.shadowRoot && this.attachShadow({
            mode: "open"
        }).appendChild(document.getElementById("video-media-default-template").content.cloneNode(!0)),
        this.getAttribute("type") === "video" && inView8(this, () => {
            this.querySelector("video")?.setAttribute("preload", "metadata")
        }
        , {
            margin: "800px"
        })
    }
    _playerTarget() {
        if (this.hasAttribute("host"))
            return this.setAttribute("loaded", ""),
            new Promise(async e => {
                const t = this.querySelector("template");
                t && t.replaceWith(t.content.firstElementChild.cloneNode(!0));
                const i = this.hasAttribute("autoplay") || matchesMediaQuery("md-max")
                  , n = document.createElement("script");
                if (n.type = "text/javascript",
                this.getAttribute("host") === "youtube") {
                    window.YT && window.YT.Player || (n.src = "https://www.youtube.com/iframe_api",
                    document.head.appendChild(n),
                    await new Promise(e2 => {
                        n.onload = e2
                    }
                    )),
                    await onYouTubePromise;
                    const t2 = new YT.Player(this.querySelector("iframe"),{
                        events: {
                            onReady: () => {
                                i && t2.mute(),
                                e(t2)
                            }
                            ,
                            onStateChange: e2 => {
                                e2.data === YT.PlayerState.PLAYING ? this.setAttribute("playing", "") : e2.data !== YT.PlayerState.ENDED && e2.data !== YT.PlayerState.PAUSED || this.removeAttribute("playing")
                            }
                        }
                    })
                }
                if (this.getAttribute("host") === "vimeo") {
                    window.Vimeo && window.Vimeo.Player || (n.src = "https://player.vimeo.com/api/player.js",
                    document.head.appendChild(n),
                    await new Promise(e2 => {
                        n.onload = e2
                    }
                    ));
                    const t2 = new Vimeo.Player(this.querySelector("iframe"));
                    i && t2.setMuted(!0),
                    t2.on("play", () => {
                        this.setAttribute("playing", "")
                    }
                    ),
                    t2.on("pause", () => this.removeAttribute("playing")),
                    t2.on("ended", () => this.removeAttribute("playing")),
                    e(t2)
                }
            }
            );
        {
            const e = this.querySelector("video");
            return this.setAttribute("loaded", ""),
            e.addEventListener("play", () => {
                this.setAttribute("playing", ""),
                this.removeAttribute("suspended"),
                this.#t && (e.controls = !1)
            }
            ),
            e.addEventListener("pause", () => {
                !e.seeking && e.paused && this.removeAttribute("playing")
            }
            ),
            e
        }
    }
    _playerHandler(e, t) {
        this.getAttribute("host") === "youtube" ? t === "play" ? e.playVideo() : e.pauseVideo() : t !== "play" || this.hasAttribute("host") ? e[t]() : e.play().catch(t2 => {
            t2.name === "NotAllowedError" && (this.setAttribute("suspended", ""),
            this.hasAttribute("controls") || (this.#t = !0,
            e.controls = !0))
        }
        )
    }
}
;
window.customElements.get("video-media") || window.customElements.define("video-media", VideoMedia);
import {timeline as timeline5} from "vendor";
var CustomDetails = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _CustomDetails_instances),
        __privateAdd(this, _onSummaryClickedListener, __privateMethod(this, _CustomDetails_instances, onSummaryClicked_fn).bind(this)),
        Shopify.designMode && (this.addEventListener("shopify:block:select", e => this.toggle(!0, !e.detail.load)),
        this.addEventListener("shopify:block:deselect", e => this.toggle(!1, !e.detail.load)))
    }
    static get observedAttributes() {
        return ["open", "aria-expanded"]
    }
    connectedCallback() {
        this.disclosureElement && this.disclosureElement.setAttribute("aria-expanded", this.disclosureElement.open ? "true" : "false"),
        this.summaryElement && this.summaryElement.addEventListener("click", __privateGet(this, _onSummaryClickedListener))
    }
    disconnectedCallback() {
        const summary = this.summaryElement;
        summary && summary.removeEventListener("click", __privateGet(this, _onSummaryClickedListener))
    }
    get disclosureElement() {
        return this.querySelector("details")
    }
    get summaryElement() {
        if (this.disclosureElement)
            return this.disclosureElement.firstElementChild
    }
    get contentElement() {
        return this.disclosureElement.lastElementChild
    }
    toggle(e=void 0, t=!0) {
        (typeof e == "boolean" ? e : this.disclosureElement.getAttribute("aria-expanded") !== "true") ? this.open({
            instant: !t
        }) : this.close()
    }
    async open({instant: e=!1}={}) {
        if (this.disclosureElement.getAttribute("aria-expanded") === "true")
            return;
        this.disclosureElement.open = !0,
        this.disclosureElement.setAttribute("aria-expanded", "true");
        const t = this.createShowAnimationControls();
        e && t.finish()
    }
    async close() {
        this.disclosureElement.setAttribute("aria-expanded", "false"),
        this.disclosureElement.open && this.createHideAnimationControls()?.finished.then(e => {
            e !== void 0 && this.disclosureElement.removeAttribute("open")
        }
        )
    }
    createShowAnimationControls() {}
    createHideAnimationControls() {}
}
;
_onSummaryClickedListener = new WeakMap,
_CustomDetails_instances = new WeakSet,
onSummaryClicked_fn = function(e) {
    if (e.preventDefault(),
    this.disclosureElement.open && this.summaryElement.hasAttribute("data-follow-link"))
        return window.location.href = this.summaryElement.getAttribute("data-follow-link");
    this.toggle()
}
;
var _hoverTimer, _detectClickOutsideListener, _detectEscKeyboardListener, _detectFocusOutListener, _detectHoverOutsideListener, _detectHoverListener, _MenuDisclosure_instances, detectClickOutside_fn, detectHover_fn, detectHoverOutside_fn, detectEscKeyboard_fn, detectFocusOut_fn, AccordionDisclosure = class extends CustomDetails {
    createShowAnimationControls() {
        this.disclosureElement.style.overflow = "hidden";
        const e = timeline5([[this.disclosureElement, {
            height: [`${this.summaryElement.clientHeight}px`, `${this.disclosureElement.scrollHeight}px`]
        }, {
            duration: .25,
            easing: "ease"
        }], [this.contentElement, {
            opacity: [0, 1],
            transform: ["translateY(4px)", "translateY(0)"]
        }, {
            duration: .15,
            at: "-0.1"
        }]]);
        return e.finished.then( () => {
            this.disclosureElement.style.height = null,
            this.disclosureElement.style.overflow = null
        }
        ),
        e
    }
    createHideAnimationControls() {
        const e = timeline5([[this.contentElement, {
            opacity: 0
        }, {
            duration: .15
        }], [this.disclosureElement, {
            height: [`${this.disclosureElement.clientHeight}px`, `${this.summaryElement.clientHeight}px`]
        }, {
            duration: .25,
            at: "<",
            easing: "ease"
        }]]);
        return e.finished.then( () => {
            this.disclosureElement.style.height = null
        }
        ),
        e
    }
}
;
window.customElements.get("accordion-disclosure") || window.customElements.define("accordion-disclosure", AccordionDisclosure);
var _MenuDisclosure = class extends CustomDetails {
    constructor() {
        super(),
        __privateAdd(this, _MenuDisclosure_instances),
        __privateAdd(this, _hoverTimer),
        __privateAdd(this, _detectClickOutsideListener, __privateMethod(this, _MenuDisclosure_instances, detectClickOutside_fn).bind(this)),
        __privateAdd(this, _detectEscKeyboardListener, __privateMethod(this, _MenuDisclosure_instances, detectEscKeyboard_fn).bind(this)),
        __privateAdd(this, _detectFocusOutListener, __privateMethod(this, _MenuDisclosure_instances, detectFocusOut_fn).bind(this)),
        __privateAdd(this, _detectHoverOutsideListener, __privateMethod(this, _MenuDisclosure_instances, detectHoverOutside_fn).bind(this)),
        __privateAdd(this, _detectHoverListener, __privateMethod(this, _MenuDisclosure_instances, detectHover_fn).bind(this)),
        this.disclosureElement.addEventListener("mouseover", __privateGet(this, _detectHoverListener).bind(this)),
        this.disclosureElement.addEventListener("mouseout", __privateGet(this, _detectHoverListener).bind(this))
    }
    get trigger() {
        return window.matchMedia("screen and (pointer: fine)").matches ? this.getAttribute("trigger") : "click"
    }
    get mouseOverDelayTolerance() {
        return 250
    }
    async open({instant: e=!1}={}) {
        super.open({
            instant: e
        }),
        document.addEventListener("click", __privateGet(this, _detectClickOutsideListener)),
        document.addEventListener("keydown", __privateGet(this, _detectEscKeyboardListener)),
        document.addEventListener("focusout", __privateGet(this, _detectFocusOutListener)),
        document.addEventListener("mouseover", __privateGet(this, _detectHoverOutsideListener))
    }
    async close() {
        super.close(),
        document.removeEventListener("click", __privateGet(this, _detectClickOutsideListener)),
        document.removeEventListener("keydown", __privateGet(this, _detectEscKeyboardListener)),
        document.removeEventListener("focusout", __privateGet(this, _detectFocusOutListener)),
        document.removeEventListener("mouseover", __privateGet(this, _detectHoverOutsideListener))
    }
}
;
_hoverTimer = new WeakMap,
_detectClickOutsideListener = new WeakMap,
_detectEscKeyboardListener = new WeakMap,
_detectFocusOutListener = new WeakMap,
_detectHoverOutsideListener = new WeakMap,
_detectHoverListener = new WeakMap,
_MenuDisclosure_instances = new WeakSet,
detectClickOutside_fn = function(e) {
    this.trigger === "click" && (this.contains(e.target) || e.target.closest("details") instanceof _MenuDisclosure || this.toggle(!1))
}
,
detectHover_fn = function(e) {
    this.trigger === "hover" && (e.type === "mouseover" ? (clearTimeout(__privateGet(this, _hoverTimer)),
    this.toggle(!0)) : e.type === "mouseout" && __privateSet(this, _hoverTimer, setTimeout( () => this.toggle(!1), this.mouseOverDelayTolerance)))
}
,
detectHoverOutside_fn = function(e) {
    if (this.trigger !== "hover")
        return;
    const t = e.target.closest("details");
    t instanceof _MenuDisclosure && t !== this && !t.contains(this) && !this.contains(t) && (clearTimeout(__privateGet(this, _hoverTimer)),
    this.toggle(!1))
}
,
detectEscKeyboard_fn = function(e) {
    if (e.code === "Escape") {
        const t = e.target.closest("details[open]");
        t && t instanceof _MenuDisclosure && (t.toggle(!1),
        e.stopPropagation())
    }
}
,
detectFocusOut_fn = function(e) {
    e.relatedTarget && !this.contains(e.relatedTarget) && this.toggle(!1)
}
;
var _componentID, _buttons, _panels, _delegate5, _Tabs_instances, setupComponent_fn, onButtonClicked_fn, onSlotChange_fn, handleKeyboard_fn, MenuDisclosure = _MenuDisclosure;
import {Delegate as Delegate6, animate as animate10, timeline as timeline6} from "vendor";
var _listenersAbortController2, _fetchAbortController, _searchForm, _queryInput, _PredictiveSearch_instances, onInputChanged_fn2, onFormSubmitted_fn2, doPredictiveSearch_fn, onSearchCleared_fn, Tabs = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _Tabs_instances),
        __privateAdd(this, _componentID, crypto.randomUUID ? crypto.randomUUID() : Math.floor(1e4 * Math.random())),
        __privateAdd(this, _buttons, []),
        __privateAdd(this, _panels, []),
        __privateAdd(this, _delegate5, new Delegate6(this)),
        this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild(this.querySelector("template").content.cloneNode(!0)),
        Shopify.designMode && this.addEventListener("shopify:block:select", e => this.selectedIndex = __privateGet(this, _buttons).indexOf(e.target)),
        __privateGet(this, _delegate5).on("click", 'button[role="tab"]', __privateMethod(this, _Tabs_instances, onButtonClicked_fn).bind(this)),
        this.shadowRoot.addEventListener("slotchange", __privateMethod(this, _Tabs_instances, onSlotChange_fn).bind(this)),
        this.addEventListener("keydown", __privateMethod(this, _Tabs_instances, handleKeyboard_fn))
    }
    static get observedAttributes() {
        return ["selected-index"]
    }
    connectedCallback() {
        __privateMethod(this, _Tabs_instances, setupComponent_fn).call(this),
        this.selectedIndex = this.selectedIndex
    }
    disconnectedCallback() {
        __privateGet(this, _delegate5).destroy()
    }
    get animationDuration() {
        return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : .3
    }
    get selectedIndex() {
        return parseInt(this.getAttribute("selected-index")) || 0
    }
    set selectedIndex(e) {
        this.setAttribute("selected-index", Math.min(Math.max(e, 0), Math.max(0, __privateGet(this, _buttons).length - 1)).toString()),
        this.style.setProperty("--selected-index", this.selectedIndex.toString())
    }
    attributeChangedCallback(e, t, i) {
        __privateGet(this, _buttons).forEach( (e2, t2) => e2.setAttribute("aria-selected", t2 === parseInt(i) ? "true" : "false")),
        e === "selected-index" && t !== null && t !== i && this.transition(__privateGet(this, _panels)[parseInt(t)], __privateGet(this, _panels)[parseInt(i)])
    }
    async transition(e, t) {
        const i = this.clientHeight;
        await animate10(e, {
            transform: ["translateY(0px)", "translateY(10px)"],
            opacity: [1, 0]
        }, {
            duration: this.animationDuration
        }).finished,
        e.hidden = !0,
        t.hidden = !1,
        await timeline6([[this, {
            height: [`${i}px`, `${this.clientHeight}px`],
            overflow: ["hidden", "visible"]
        }, {
            duration: .15,
            easing: [.85, 0, .15, 1]
        }], [t, {
            transform: ["translateY(10px)", "translateY(0px)"],
            opacity: [0, 1]
        }, {
            duration: this.animationDuration,
            at: "+0.1"
        }]]).finished,
        this.style.removeProperty("height")
    }
}
;
_componentID = new WeakMap,
_buttons = new WeakMap,
_panels = new WeakMap,
_delegate5 = new WeakMap,
_Tabs_instances = new WeakSet,
setupComponent_fn = function() {
    __privateSet(this, _buttons, Array.from(this.shadowRoot.querySelector('slot[name="title"]')?.assignedNodes() ?? [], e => e.matches("button") && e || e.querySelector("button"))),
    __privateSet(this, _panels, Array.from(this.shadowRoot.querySelector('slot[name="content"]')?.assignedNodes() ?? [])),
    __privateGet(this, _buttons).forEach( (e, t) => {
        e.setAttribute("role", "tab"),
        e.setAttribute("aria-controls", `tab-panel-${__privateGet(this, _componentID)}-${t}`),
        e.id = `tab-${__privateGet(this, _componentID)}-${t}`
    }
    ),
    __privateGet(this, _panels).forEach( (e, t) => {
        e.setAttribute("role", "tabpanel"),
        e.setAttribute("aria-labelledby", `tab-${__privateGet(this, _componentID)}-${t}`),
        e.id = `tab-panel-${__privateGet(this, _componentID)}-${t}`,
        e.hidden = t !== this.selectedIndex
    }
    ),
    this.style.setProperty("--item-count", __privateGet(this, _buttons).length.toString())
}
,
onButtonClicked_fn = function(e, t) {
    this.selectedIndex = __privateGet(this, _buttons).indexOf(t)
}
,
onSlotChange_fn = function() {
    __privateMethod(this, _Tabs_instances, setupComponent_fn).call(this)
}
,
handleKeyboard_fn = function(e) {
    __privateGet(this, _buttons).indexOf(document.activeElement) !== -1 && ["ArrowLeft", "ArrowRight"].includes(e.key) && (e.key === "ArrowLeft" ? this.selectedIndex = (this.selectedIndex - 1 + __privateGet(this, _buttons).length) % __privateGet(this, _buttons).length : this.selectedIndex = (this.selectedIndex + 1 + __privateGet(this, _buttons).length) % __privateGet(this, _buttons).length,
    __privateGet(this, _buttons)[this.selectedIndex].focus())
}
,
window.customElements.get("x-tabs") || window.customElements.define("x-tabs", Tabs);
var PredictiveSearch = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _PredictiveSearch_instances),
        __privateAdd(this, _listenersAbortController2),
        __privateAdd(this, _fetchAbortController),
        __privateAdd(this, _searchForm),
        __privateAdd(this, _queryInput),
        this.attachShadow({
            mode: "open"
        }),
        this.shadowRoot.appendChild(document.createRange().createContextualFragment('<slot name="results"></slot>'))
    }
    connectedCallback() {
        __privateSet(this, _listenersAbortController2, new AbortController),
        __privateSet(this, _searchForm, document.querySelector(`[aria-owns="${this.id}"]`)),
        __privateSet(this, _queryInput, __privateGet(this, _searchForm).elements.q),
        __privateGet(this, _searchForm).addEventListener("submit", __privateMethod(this, _PredictiveSearch_instances, onFormSubmitted_fn2).bind(this), {
            signal: __privateGet(this, _listenersAbortController2).signal
        }),
        __privateGet(this, _searchForm).addEventListener("reset", __privateMethod(this, _PredictiveSearch_instances, onSearchCleared_fn).bind(this), {
            signal: __privateGet(this, _listenersAbortController2).signal
        }),
        __privateGet(this, _queryInput).addEventListener("input", debounce(__privateMethod(this, _PredictiveSearch_instances, onInputChanged_fn2).bind(this), this.autoCompleteDelay, {
            signal: __privateGet(this, _listenersAbortController2).signal
        }))
    }
    disconnectedCallback() {
        __privateGet(this, _listenersAbortController2).abort()
    }
    get autoCompleteDelay() {
        return 280
    }
    supportsPredictiveApi() {
        return JSON.parse(document.getElementById("shopify-features").innerHTML).predictiveSearch
    }
}
;
_listenersAbortController2 = new WeakMap,
_fetchAbortController = new WeakMap,
_searchForm = new WeakMap,
_queryInput = new WeakMap,
_PredictiveSearch_instances = new WeakSet,
onInputChanged_fn2 = function() {
    if (__privateGet(this, _queryInput).value === "")
        return __privateMethod(this, _PredictiveSearch_instances, onSearchCleared_fn).call(this);
    __privateGet(this, _fetchAbortController)?.abort(),
    __privateSet(this, _fetchAbortController, new AbortController);
    try {
        return __privateMethod(this, _PredictiveSearch_instances, doPredictiveSearch_fn).call(this)
    } catch (e) {
        if (e.name !== "AbortError")
            throw e
    }
}
,
onFormSubmitted_fn2 = function(e) {
    if (__privateGet(this, _queryInput).value === "")
        return e.preventDefault()
}
,
doPredictiveSearch_fn = async function() {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start",{
        bubbles: !0
    }));
    const e = `${window.Shopify.routes.root}search${this.supportsPredictiveApi() ? "/suggest" : ""}`
      , t = `q=${encodeURIComponent(__privateGet(this, _queryInput).value)}&resources[type]=product,collection,page,article&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor&section_id=predictive-search`
      , i = new DOMParser().parseFromString(await (await cachedFetch(`${e}?${t}`, {
        signal: __privateGet(this, _fetchAbortController).signal
    })).text(), "text/html");
    this.querySelector('[slot="results"]').replaceChildren(...document.importNode(i.querySelector(".shopify-section"), !0).children),
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end",{
        bubbles: !0
    }))
}
,
onSearchCleared_fn = function() {
    __privateGet(this, _fetchAbortController)?.abort(),
    __privateGet(this, _queryInput).focus(),
    this.querySelector('[slot="results"]').innerHTML = ""
}
,
window.customElements.get("predictive-search") || window.customElements.define("predictive-search", PredictiveSearch);
import {animate as animate11} from "vendor";
var _onPointerMoveListener, _touchStartTimestamp, _BeforeAfter_instances, onPointerDown_fn, onPointerMove_fn, onTouchStart_fn, onPointerUp_fn, onKeyboardNavigation_fn2, calculatePosition_fn, animateInitialPosition_fn, AnnouncementBarCarousel = class extends EffectCarousel {
    createOnChangeAnimationControls(e, t) {
        return {
            leaveControls: () => animate11(e, {
                opacity: [1, 0],
                transform: ["translateY(0)", "translateY(-10px)"]
            }, {
                duration: .25,
                easing: [.55, .055, .675, .19]
            }),
            enterControls: () => animate11(t, {
                opacity: [0, 1],
                transform: ["translateY(10px)", "translateY(0px)"]
            }, {
                duration: .4,
                easing: [.215, .61, .355, 1]
            })
        }
    }
}
;
window.customElements.get("announcement-bar-carousel") || window.customElements.define("announcement-bar-carousel", AnnouncementBarCarousel);
import {animate as animate12, inView as inView9} from "vendor";
var _BlogPosts_instances, reveal_fn, BeforeAfter = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _BeforeAfter_instances),
        __privateAdd(this, _onPointerMoveListener, __privateMethod(this, _BeforeAfter_instances, onPointerMove_fn).bind(this)),
        __privateAdd(this, _touchStartTimestamp, 0),
        this.addEventListener("pointerdown", __privateMethod(this, _BeforeAfter_instances, onPointerDown_fn)),
        this.addEventListener("keydown", __privateMethod(this, _BeforeAfter_instances, onKeyboardNavigation_fn2)),
        this.addEventListener("touchstart", __privateMethod(this, _BeforeAfter_instances, onTouchStart_fn), {
            passive: !1
        })
    }
    connectedCallback() {
        inView9(this, __privateMethod(this, _BeforeAfter_instances, animateInitialPosition_fn).bind(this))
    }
}
;
_onPointerMoveListener = new WeakMap,
_touchStartTimestamp = new WeakMap,
_BeforeAfter_instances = new WeakSet,
onPointerDown_fn = function(e) {
    e.target.tagName !== "A" && (document.addEventListener("pointerup", __privateMethod(this, _BeforeAfter_instances, onPointerUp_fn).bind(this), {
        once: !0
    }),
    matchesMediaQuery("supports-hover") && (document.addEventListener("pointermove", __privateGet(this, _onPointerMoveListener)),
    __privateMethod(this, _BeforeAfter_instances, calculatePosition_fn).call(this, e)))
}
,
onPointerMove_fn = function(e) {
    __privateMethod(this, _BeforeAfter_instances, calculatePosition_fn).call(this, e)
}
,
onTouchStart_fn = function(e) {
    const t = this.querySelector(".before-after__cursor");
    e.target === t || t.contains(e.target) ? (e.preventDefault(),
    document.addEventListener("pointermove", __privateGet(this, _onPointerMoveListener))) : __privateSet(this, _touchStartTimestamp, e.timeStamp)
}
,
onPointerUp_fn = function(e) {
    document.removeEventListener("pointermove", __privateGet(this, _onPointerMoveListener)),
    matchesMediaQuery("supports-hover") || e.timeStamp - __privateGet(this, _touchStartTimestamp) <= 250 && __privateMethod(this, _BeforeAfter_instances, calculatePosition_fn).call(this, e)
}
,
onKeyboardNavigation_fn2 = function(e) {
    if (!e.target.classList.contains("before-after__cursor") || !this.hasAttribute("vertical") && e.code !== "ArrowLeft" && e.code !== "ArrowRight" || this.hasAttribute("vertical") && e.code !== "ArrowUp" && e.code !== "ArrowDown")
        return;
    e.preventDefault();
    let t, i = parseInt(this.style.getPropertyValue("--before-after-cursor-position"));
    Number.isNaN(i) && (i = parseInt(getComputedStyle(this).getPropertyValue("--before-after-initial-cursor-position"))),
    t = this.hasAttribute("vertical") ? e.code === "ArrowUp" ? i - 1 : i + 1 : e.code === "ArrowLeft" ? i - 1 : i + 1,
    this.style.setProperty("--before-after-cursor-position", `${Math.min(Math.max(t, 0), 100)}%`)
}
,
calculatePosition_fn = function(e) {
    let t, i = this.getBoundingClientRect();
    this.hasAttribute("vertical") ? t = (e.clientY - i.top) / this.clientHeight * 100 : (t = (e.clientX - i.left) / this.clientWidth * 100,
    t = document.dir === "rtl" ? 100 - t : t),
    this.style.setProperty("--before-after-cursor-position", `${Math.min(Math.max(t, 0), 100)}%`)
}
,
animateInitialPosition_fn = function() {
    animate12(e => {
        this.style.setProperty("--before-after-cursor-position", `calc(var(--before-after-initial-cursor-position) * ${e})`)
    }
    , {
        duration: .6,
        easing: [.85, 0, .15, 1]
    })
}
,
window.customElements.get("before-after") || window.customElements.define("before-after", BeforeAfter);
import {animate as animate13, stagger as stagger2, inView as inView10} from "vendor";
var _sectionId, _CartDrawer_instances, onBundleSection_fn, onCartChange_fn, onBeforeShow_fn, onPageShow_fn, refreshCart_fn, replaceContent_fn, BlogPosts = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _BlogPosts_instances),
        this.hasAttribute("reveal-on-scroll") && matchesMediaQuery("motion-safe") && inView10(this, __privateMethod(this, _BlogPosts_instances, reveal_fn).bind(this), {
            margin: "-50px 0px"
        })
    }
}
;
_BlogPosts_instances = new WeakSet,
reveal_fn = function() {
    this.style.opacity = "1",
    animate13(this.children, {
        opacity: [0, 1],
        transform: ["translateY(30px)", "translateY(0)"]
    }, {
        duration: .25,
        delay: stagger2(.1, {
            easing: "ease-out"
        }),
        easing: "ease"
    })
}
,
window.customElements.get("blog-posts") || window.customElements.define("blog-posts", BlogPosts);
import {animate as animate14, timeline as timeline7} from "vendor";
var CartDrawer = class extends Drawer {
    constructor() {
        super(...arguments),
        __privateAdd(this, _CartDrawer_instances),
        __privateAdd(this, _sectionId)
    }
    connectedCallback() {
        super.connectedCallback(),
        __privateGet(this, _sectionId) ?? __privateSet(this, _sectionId, extractSectionId(this)),
        document.addEventListener("cart:prepare-bundled-sections", __privateMethod(this, _CartDrawer_instances, onBundleSection_fn).bind(this), {
            signal: this.abortController.signal
        }),
        document.addEventListener("cart:change", __privateMethod(this, _CartDrawer_instances, onCartChange_fn).bind(this), {
            signal: this.abortController.signal
        }),
        document.addEventListener("cart:refresh", __privateMethod(this, _CartDrawer_instances, refreshCart_fn).bind(this), {
            signal: this.abortController.signal
        }),
        window.addEventListener("pageshow", __privateMethod(this, _CartDrawer_instances, onPageShow_fn).bind(this), {
            signal: this.abortController.signal
        }),
        this.addEventListener("dialog:before-show", __privateMethod(this, _CartDrawer_instances, onBeforeShow_fn))
    }
}
;
_sectionId = new WeakMap,
_CartDrawer_instances = new WeakSet,
onBundleSection_fn = function(e) {
    e.detail.sections.push(__privateGet(this, _sectionId))
}
,
onCartChange_fn = async function(e) {
    __privateMethod(this, _CartDrawer_instances, replaceContent_fn).call(this, e.detail.cart.sections[__privateGet(this, _sectionId)]),
    window.themeVariables.settings.cartType !== "drawer" && e.detail.onSuccessDo !== "force_open_drawer" || e.detail.baseEvent !== "variant:add" || this.show()
}
,
onBeforeShow_fn = async function() {
    const e = this.shadowRoot.querySelector('[part="footer"]');
    e && (e.style.opacity = "0",
    await waitForEvent(this, "dialog:after-show"),
    animate14(e, {
        opacity: [0, 1],
        transform: ["translateY(30px)", "translateY(0)"]
    }, {
        duration: .25,
        easing: [.25, .46, .45, .94]
    }))
}
,
onPageShow_fn = async function(e) {
    e.persisted && __privateMethod(this, _CartDrawer_instances, refreshCart_fn).call(this)
}
,
refreshCart_fn = async function() {
    __privateMethod(this, _CartDrawer_instances, replaceContent_fn).call(this, await (await fetch(`${Shopify.routes.root}?section_id=${__privateGet(this, _sectionId)}`)).text())
}
,
replaceContent_fn = async function(e) {
    const t = new DOMParser().parseFromString(e, "text/html")
      , i = document.createRange().createContextualFragment(t.getElementById(`shopify-section-${__privateGet(this, _sectionId)}`).querySelector("cart-drawer").innerHTML)
      , n = (await fetchCart).item_count;
    n === 0 ? (await timeline7([[this.getShadowPartByName("body"), {
        opacity: [1, 0]
    }, {
        duration: .15,
        easing: "ease-in"
    }], [this.getShadowPartByName("footer"), {
        opacity: [1, 0],
        transform: ["translateY(0)", "translateY(30px)"]
    }, {
        duration: .15,
        at: "<",
        easing: "ease-in"
    }]]).finished,
    this.replaceChildren(...i.children),
    animate14(this.getShadowPartByName("body"), {
        opacity: [0, 1],
        transform: ["translateY(30px)", "translateY(0)"]
    }, {
        duration: .25,
        easing: [.25, .46, .45, .94]
    })) : this.replaceChildren(...i.children),
    this.classList.toggle("drawer--center-body", n === 0),
    this.dispatchEvent(new CustomEvent("cart-drawer:refreshed",{
        bubbles: !0
    }))
}
;
var _CollectionBanner_instances, reveal_fn2, CartNoteDialog = class extends DialogElement {
    createEnterAnimationControls() {
        return animate14(this, {
            transform: ["translateY(100%)", "translateY(0)"]
        }, {
            duration: .2,
            easing: "ease-in"
        })
    }
    createLeaveAnimationControls() {
        return animate14(this, {
            transform: ["translateY(0)", "translateY(100%)"]
        }, {
            duration: .2,
            easing: "ease-in"
        })
    }
}
;
window.customElements.get("cart-drawer") || window.customElements.define("cart-drawer", CartDrawer),
window.customElements.get("cart-note-dialog") || window.customElements.define("cart-note-dialog", CartNoteDialog);
import {timeline as timeline8, inView as inView11, Delegate as Delegate7} from "vendor";
var _delegate6, _CollectionLayoutSwitch_instances, onLayoutSwitch_fn, setCartAttribute_fn, CollectionBanner = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _CollectionBanner_instances)
    }
    connectedCallback() {
        this.hasAttribute("reveal-on-scroll") && matchesMediaQuery("motion-safe") && inView11(this, __privateMethod(this, _CollectionBanner_instances, reveal_fn2).bind(this))
    }
}
;
_CollectionBanner_instances = new WeakSet,
reveal_fn2 = async function() {
    const e = this.querySelector(".content-over-media > picture img, .content-over-media > image-parallax img")
      , t = this.querySelector(".content-over-media image-parallax") !== null
      , i = this.querySelector(".content-over-media > .prose");
    return await imageLoaded(e),
    timeline8([[this, {
        opacity: 1
    }, {
        duration: 0,
        easing: [.25, .46, .45, .94]
    }], [e, {
        opacity: [0, 1],
        transform: t ? ["scale(1.5) translateY(-11.538461538461538%)", "scale(1.3) translateY(-11.538461538461538%)"] : ["scale(1.2)", "scale(1)"]
    }, {
        duration: .8,
        delay: .25,
        at: "<",
        easing: [.25, .46, .45, .94]
    }], [i, {
        opacity: [0, 1],
        transform: ["translateY(30px)", "translateY(0)"]
    }, {
        duration: .6,
        at: "-0.4",
        easing: [.215, .61, .355, 1]
    }]])
}
;
var _flips, _expirationDate, _interval, _isVisible, _CountdownTimer_instances, recalculateFlips_fn, CollectionLayoutSwitch = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _CollectionLayoutSwitch_instances),
        __privateAdd(this, _delegate6, new Delegate7(this))
    }
    connectedCallback() {
        __privateGet(this, _delegate6).on("click", 'button[type="button"]', __privateMethod(this, _CollectionLayoutSwitch_instances, onLayoutSwitch_fn).bind(this))
    }
    get controlledList() {
        return document.getElementById(this.getAttribute("aria-controls"))
    }
}
;
_delegate6 = new WeakMap,
_CollectionLayoutSwitch_instances = new WeakSet,
onLayoutSwitch_fn = function(e, t) {
    t.classList.contains("is-active") || (this.controlledList.setAttribute(`collection-${this.getAttribute("device")}-layout`, t.value),
    Array.from(this.querySelectorAll("button")).forEach(e2 => e2.classList.toggle("is-active", e2 === t)),
    this.controlledList.reveal(),
    __privateMethod(this, _CollectionLayoutSwitch_instances, setCartAttribute_fn).call(this, t.value))
}
,
setCartAttribute_fn = function(e) {
    const t = `products_${this.getAttribute("device")}_grid_mode`;
    fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            attributes: {
                [t]: e
            }
        }),
        keepalive: !0
    })
}
,
window.customElements.get("collection-banner") || window.customElements.define("collection-banner", CollectionBanner),
window.customElements.get("collection-layout-switch") || window.customElements.define("collection-layout-switch", CollectionLayoutSwitch);
import {animate as animate15, inView as inView12} from "vendor";
var CountdownTimer = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _CountdownTimer_instances),
        __privateAdd(this, _flips),
        __privateAdd(this, _expirationDate),
        __privateAdd(this, _interval),
        __privateAdd(this, _isVisible)
    }
    connectedCallback() {
        __privateSet(this, _flips, Array.from(this.querySelectorAll("countdown-timer-flip")));
        const e = this.getAttribute("expires-at");
        e !== "" && (__privateSet(this, _expirationDate, new Date(e)),
        __privateSet(this, _interval, setInterval(__privateMethod(this, _CountdownTimer_instances, recalculateFlips_fn).bind(this), 1e3)),
        __privateMethod(this, _CountdownTimer_instances, recalculateFlips_fn).call(this)),
        inView12(this, () => (__privateSet(this, _isVisible, !0),
        () => __privateSet(this, _isVisible, !1)), {
            margin: "500px"
        })
    }
    disconnectedCallback() {
        clearInterval(__privateGet(this, _interval))
    }
    get daysFlip() {
        return __privateGet(this, _flips).find(e => e.getAttribute("type") === "days")
    }
    get hoursFlip() {
        return __privateGet(this, _flips).find(e => e.getAttribute("type") === "hours")
    }
    get minutesFlip() {
        return __privateGet(this, _flips).find(e => e.getAttribute("type") === "minutes")
    }
    get secondsFlip() {
        return __privateGet(this, _flips).find(e => e.getAttribute("type") === "seconds")
    }
}
;
_flips = new WeakMap,
_expirationDate = new WeakMap,
_interval = new WeakMap,
_isVisible = new WeakMap,
_CountdownTimer_instances = new WeakSet,
recalculateFlips_fn = function() {
    const e = new Date;
    if (__privateGet(this, _expirationDate) < e) {
        if (this.getAttribute("expiration-behavior") !== "hide")
            return clearInterval(__privateGet(this, _interval));
        this.closest(".shopify-section").remove()
    }
    if (!__privateGet(this, _isVisible))
        return;
    let t = Math.abs(__privateGet(this, _expirationDate) - e) / 1e3;
    const i = Math.floor(t / 86400);
    t -= 86400 * i;
    const n = Math.floor(t / 3600) % 24;
    t -= 3600 * n;
    const a = Math.floor(t / 60) % 60;
    t -= 60 * a;
    const s = Math.floor(t % 60);
    this.daysFlip?.updateValue(i),
    this.hoursFlip?.updateValue(n),
    this.minutesFlip?.updateValue(a),
    this.secondsFlip?.updateValue(s)
}
;
var _AccountLogin_instances, loginForm_get, recoverForm_get, switchForm_fn, CountdownTimerFlip = class extends HTMLElement {
    constructor() {
        super(),
        this.attachShadow({
            mode: "open"
        });
        let e = [...this.textContent].map( () => `<countdown-timer-flip-digit part="digit" ${this.hasAttribute("animate") ? "animate" : ""} style="display: inline-block">0</countdown-timer-flip-digit>`);
        this.shadowRoot.appendChild(document.createRange().createContextualFragment(e.join("")))
    }
    updateValue(e) {
        [...Math.min(99, e).toString().padStart(2, "0")].forEach( (e2, t) => {
            this.shadowRoot.children[t].setAttribute("number", e2)
        }
        )
    }
}
, CountdownTimerFlipDigit = class extends HTMLElement {
    static observedAttributes = ["number"];
    constructor() {
        super(),
        this.attachShadow({
            mode: "open"
        }).appendChild(document.createRange().createContextualFragment("<div><slot></slot></div>"))
    }
    async attributeChangedCallback(e, t, i) {
        if (t === null || t === i || !this.hasAttribute("animate"))
            return this.textContent = i;
        await animate15(this.shadowRoot.firstElementChild, {
            opacity: [1, 0],
            transform: ["translateY(0)", "translateY(-8px)"]
        }, {
            duration: .3,
            easing: [.64, 0, .78, 0]
        }).finished,
        this.textContent = i,
        animate15(this.shadowRoot.firstElementChild, {
            opacity: [0, 1],
            transform: ["translateY(8px)", "translateY(0px)"]
        }, {
            duration: .3,
            easing: [.22, 1, .36, 1]
        })
    }
}
;
window.customElements.get("countdown-timer") || window.customElements.define("countdown-timer", CountdownTimer),
window.customElements.get("countdown-timer-flip") || window.customElements.define("countdown-timer-flip", CountdownTimerFlip),
window.customElements.get("countdown-timer-flip-digit") || window.customElements.define("countdown-timer-flip-digit", CountdownTimerFlipDigit);
import {animate as animate16} from "vendor";
var _observer, _FaqToc_instances, onObserve_fn, AccountLogin = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _AccountLogin_instances),
        window.addEventListener("hashchange", __privateMethod(this, _AccountLogin_instances, switchForm_fn).bind(this)),
        window.location.hash === "#recover" && (__privateGet(this, _AccountLogin_instances, loginForm_get).hidden = !0,
        __privateGet(this, _AccountLogin_instances, recoverForm_get).hidden = !1)
    }
}
;
_AccountLogin_instances = new WeakSet,
loginForm_get = function() {
    return this.querySelector("#login")
}
,
recoverForm_get = function() {
    return this.querySelector("#recover")
}
,
switchForm_fn = async function() {
    const e = window.location.hash === "#recover" ? __privateGet(this, _AccountLogin_instances, loginForm_get) : __privateGet(this, _AccountLogin_instances, recoverForm_get)
      , t = window.location.hash === "#recover" ? __privateGet(this, _AccountLogin_instances, recoverForm_get) : __privateGet(this, _AccountLogin_instances, loginForm_get);
    await animate16(e, {
        transform: ["translateY(0)", "translateY(30px)"],
        opacity: [1, 0]
    }, {
        duration: .6,
        easing: "ease"
    }).finished,
    e.hidden = !0,
    t.hidden = !1,
    await animate16(t, {
        transform: ["translateY(30px)", "translateY(0)"],
        opacity: [0, 1]
    }, {
        duration: .6,
        easing: "ease"
    })
}
,
window.customElements.get("account-login") || window.customElements.define("account-login", AccountLogin);
var FaqToc = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _FaqToc_instances),
        __privateAdd(this, _observer, new IntersectionObserver(__privateMethod(this, _FaqToc_instances, onObserve_fn).bind(this),{
            rootMargin: "0px 0px -70% 0px"
        }))
    }
    connectedCallback() {
        this.anchoredElements.forEach(e => __privateGet(this, _observer).observe(e))
    }
    disconnectedCallback() {
        __privateGet(this, _observer).disconnect()
    }
    get anchorLinks() {
        return Array.from(this.querySelectorAll('a[href^="#"]'))
    }
    get anchoredElements() {
        return this.anchorLinks.map(e => document.querySelector(e.getAttribute("href")))
    }
}
;
_observer = new WeakMap,
_FaqToc_instances = new WeakSet,
onObserve_fn = function(e) {
    for (const t of e) {
        const e2 = this.anchorLinks.find(e3 => e3.getAttribute("href") === `#${t.target.id}`);
        !t.isIntersecting && e2.classList.contains("is-active") || t.isIntersecting && this.anchorLinks.forEach(t2 => t2.classList.toggle("is-active", t2 === e2))
    }
}
,
window.customElements.get("faq-toc") || window.customElements.define("faq-toc", FaqToc);
import {animate as animate17} from "vendor";
var _headerTrackerIntersectionObserver, _abortController10, _scrollYTrackingPosition, _isVisible2, _Header_instances, onHeaderTrackerIntersection_fn, detectMousePosition_fn, detectScrollDirection_fn, setVisibility_fn, FeaturedCollectionsCarousel = class extends EffectCarousel {
    createOnChangeAnimationControls(e, t) {
        return {
            leaveControls: () => animate17(e, {
                opacity: [1, 0],
                transform: ["translateY(0)", "translateY(15px)"]
            }, {
                duration: .3,
                easing: "ease-in"
            }),
            enterControls: () => animate17(t, {
                opacity: [0, 1],
                transform: ["translateY(15px)", "translateY(0)"]
            }, {
                duration: .2,
                delay: .2,
                easing: "ease-out"
            })
        }
    }
}
;
window.customElements.get("featured-collections-carousel") || window.customElements.define("featured-collections-carousel", FeaturedCollectionsCarousel);
import {animate as animate18, timeline as timeline9, stagger as stagger3, Delegate as Delegate8} from "vendor";
var Header = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _Header_instances),
        __privateAdd(this, _headerTrackerIntersectionObserver, new IntersectionObserver(__privateMethod(this, _Header_instances, onHeaderTrackerIntersection_fn).bind(this))),
        __privateAdd(this, _abortController10),
        __privateAdd(this, _scrollYTrackingPosition, 0),
        __privateAdd(this, _isVisible2, !0)
    }
    connectedCallback() {
        __privateSet(this, _abortController10, new AbortController),
        __privateGet(this, _headerTrackerIntersectionObserver).observe(document.getElementById("header-scroll-tracker")),
        this.hasAttribute("hide-on-scroll") && (window.addEventListener("scroll", __privateMethod(this, _Header_instances, detectScrollDirection_fn).bind(this), {
            signal: __privateGet(this, _abortController10).signal
        }),
        window.addEventListener("pointermove", __privateMethod(this, _Header_instances, detectMousePosition_fn).bind(this), {
            signal: __privateGet(this, _abortController10).signal
        }))
    }
    disconnectedCallback() {
        __privateGet(this, _abortController10).abort()
    }
}
;
_headerTrackerIntersectionObserver = new WeakMap,
_abortController10 = new WeakMap,
_scrollYTrackingPosition = new WeakMap,
_isVisible2 = new WeakMap,
_Header_instances = new WeakSet,
onHeaderTrackerIntersection_fn = function(e) {
    this.classList.toggle("is-solid", !e[0].isIntersecting)
}
,
detectMousePosition_fn = function(e) {
    e.clientY < 100 && window.matchMedia("screen and (pointer: fine)").matches && (__privateMethod(this, _Header_instances, setVisibility_fn).call(this, !0),
    __privateSet(this, _scrollYTrackingPosition, 0))
}
,
detectScrollDirection_fn = function() {
    let e;
    const t = Math.max(0, window.scrollY);
    t > __privateGet(this, _scrollYTrackingPosition) && t - __privateGet(this, _scrollYTrackingPosition) > 100 ? (e = !1,
    __privateSet(this, _scrollYTrackingPosition, t)) : window.scrollY < __privateGet(this, _scrollYTrackingPosition) && (__privateSet(this, _scrollYTrackingPosition, t),
    e = !0),
    e !== void 0 && __privateMethod(this, _Header_instances, setVisibility_fn).call(this, e)
}
,
setVisibility_fn = function(e) {
    if (e !== __privateGet(this, _isVisible2)) {
        if (!e && this.querySelectorAll("[open]").length > 0)
            return;
        __privateSet(this, _isVisible2, e),
        document.documentElement.style.setProperty("--header-is-visible", e ? "1" : "0"),
        this.classList.toggle("is-hidden", !e)
    }
}
;
var _HeaderSearch_instances, calculateMaxHeight_fn, _collapsiblePanel, _buttonElements, _HeaderSidebar_instances, openCollapsiblePanel_fn, onSidebarBeforeShow_fn, onSidebarAfterShow_fn, onSidebarBeforeHide_fn, onSidebarAfterHide_fn, DropdownMenuDisclosure = class extends MenuDisclosure {
    createShowAnimationControls() {
        let e = [];
        return window.themeVariables.settings.staggerMenuApparition && (e = [this.contentElement.querySelectorAll(":scope > li"), {
            opacity: [0, 1],
            transform: ["translateY(8px)", "translateY(0)"]
        }, {
            duration: .15,
            at: "-0.15",
            delay: stagger3(.1)
        }]),
        timeline9([[this.contentElement, {
            opacity: [0, 1]
        }, {
            duration: .25
        }], e])
    }
    createHideAnimationControls() {
        return timeline9([[this.contentElement, {
            opacity: [1, 0]
        }, {
            duration: .4
        }]])
    }
}
, MegaMenuDisclosure = class extends MenuDisclosure {
    createShowAnimationControls() {
        const e = Array.from(this.contentElement.querySelectorAll(".mega-menu__linklist > li"));
        let t = [];
        return window.themeVariables.settings.staggerMenuApparition && (t = [{
            name: "content",
            at: "-0.5"
        }, [e, {
            opacity: [0, 1],
            transform: ["translateY(8px)", "translateY(0)"]
        }, {
            duration: .3,
            at: "content",
            delay: stagger3(.1)
        }], [this.contentElement.querySelector(".mega-menu__promo"), {
            opacity: [0, 1]
        }, {
            duration: .3,
            at: "-0.15"
        }]]),
        timeline9([[this.contentElement, {
            opacity: [0, 1]
        }, {
            duration: .25
        }], ...t])
    }
    createHideAnimationControls() {
        return timeline9([[this.contentElement, {
            opacity: [1, 0]
        }, {
            duration: .4
        }]])
    }
}
, HeaderSearch = class extends DialogElement {
    constructor() {
        super(),
        __privateAdd(this, _HeaderSearch_instances),
        this.addEventListener("dialog:before-show", __privateMethod(this, _HeaderSearch_instances, calculateMaxHeight_fn).bind(this))
    }
    get shadowDomTemplate() {
        return "header-search-default-template"
    }
    get shouldLock() {
        return !0
    }
    createEnterAnimationControls() {
        return timeline9([[this.getShadowPartByName("overlay"), {
            opacity: [0, 1]
        }, {
            duration: .2,
            easing: [.645, .045, .355, 1]
        }], [this.getShadowPartByName("content"), {
            opacity: [0, 1],
            transform: ["translateY(calc(-1 * var(--header-height)))", "translateY(0)"]
        }, {
            duration: .2,
            at: "<",
            easing: [.645, .045, .355, 1]
        }]])
    }
    createLeaveAnimationControls() {
        return timeline9([[this.getShadowPartByName("overlay"), {
            opacity: [1, 0]
        }, {
            duration: .2,
            easing: [.645, .045, .355, 1]
        }], [this.getShadowPartByName("content"), {
            opacity: [1, 0],
            transform: ["translateY(0)", "translateY(calc(-1 * var(--header-height)))"]
        }, {
            duration: .2,
            at: "<",
            easing: [.645, .045, .355, 1]
        }]])
    }
}
;
_HeaderSearch_instances = new WeakSet,
calculateMaxHeight_fn = function() {
    const e = this.getBoundingClientRect()
      , t = window.innerHeight - e.top;
    this.style.setProperty("--header-search-max-height", `${t}px`)
}
;
var _sidebarDelegate, _HeaderSidebarCollapsiblePanel_instances, closePanel_fn, switchPanel_fn, HeaderSidebar = class extends Drawer {
    constructor() {
        super(),
        __privateAdd(this, _HeaderSidebar_instances),
        __privateAdd(this, _collapsiblePanel),
        __privateAdd(this, _buttonElements),
        this.addEventListener("dialog:before-show", __privateMethod(this, _HeaderSidebar_instances, onSidebarBeforeShow_fn)),
        this.addEventListener("dialog:after-show", __privateMethod(this, _HeaderSidebar_instances, onSidebarAfterShow_fn)),
        this.addEventListener("dialog:before-hide", __privateMethod(this, _HeaderSidebar_instances, onSidebarBeforeHide_fn)),
        this.addEventListener("dialog:after-hide", __privateMethod(this, _HeaderSidebar_instances, onSidebarAfterHide_fn))
    }
    connectedCallback() {
        super.connectedCallback(),
        __privateSet(this, _collapsiblePanel, this.querySelector('[slot="collapsible-panel"]')),
        __privateSet(this, _buttonElements, Array.from(this.querySelectorAll(".header-sidebar__main-panel .header-sidebar__linklist [aria-controls]"))),
        __privateGet(this, _buttonElements).forEach(e => e.addEventListener("click", __privateMethod(this, _HeaderSidebar_instances, openCollapsiblePanel_fn).bind(this), {
            signal: this.abortController.signal
        }))
    }
    revealItems(e=!1) {
        return timeline9([[this.querySelector(".header-sidebar__main-panel"), {
            opacity: 1,
            transform: "translateX(0)"
        }, {
            duration: 0,
            delay: e ? .5 : 0
        }], [this.querySelectorAll(".header-sidebar__main-panel .header-sidebar__linklist li"), {
            opacity: [0, 1],
            transform: ["translateY(8px)", "translateY(0)"]
        }, {
            duration: .15,
            at: "-0.15",
            delay: window.themeVariables.settings.staggerMenuApparition ? stagger3(.1) : 0
        }], [this.querySelector(".header-sidebar__footer"), {
            opacity: [0, 1],
            transform: ["translateY(10px)", "translateY(0)"]
        }, {
            duration: .3
        }]])
    }
}
;
_collapsiblePanel = new WeakMap,
_buttonElements = new WeakMap,
_HeaderSidebar_instances = new WeakSet,
openCollapsiblePanel_fn = function(e) {
    __privateGet(this, _buttonElements).forEach(t => t.setAttribute("aria-expanded", t === e.currentTarget ? "true" : "false")),
    __privateGet(this, _collapsiblePanel)?.setAttribute("aria-activedescendant", e.currentTarget.getAttribute("aria-controls")),
    matchesMediaQuery("md-max") && animate18(this.querySelector(".header-sidebar__main-panel"), {
        opacity: [1, 0],
        transform: ["translateX(0)", "translateX(-10px)"]
    }, {
        duration: .25
    })
}
,
onSidebarBeforeShow_fn = function() {
    animate18(this.querySelector(".header-sidebar__main-panel"), {
        opacity: 0,
        transform: "translateX(0)"
    }, {
        duration: 0
    })
}
,
onSidebarAfterShow_fn = function() {
    this.revealItems()
}
,
onSidebarBeforeHide_fn = function() {
    matchesMediaQuery("md") && (__privateGet(this, _collapsiblePanel)?.removeAttribute("aria-activedescendant"),
    __privateGet(this, _buttonElements).forEach(e => e.setAttribute("aria-expanded", "false")))
}
,
onSidebarAfterHide_fn = function() {
    matchesMediaQuery("md-max") && (__privateGet(this, _collapsiblePanel)?.removeAttribute("aria-activedescendant"),
    __privateGet(this, _buttonElements).forEach(e => e.setAttribute("aria-expanded", "false"))),
    Array.from(this.querySelectorAll("details")).forEach(e => e.open = !1)
}
;
var _ImageWithText_instances, onBecameVisible_fn, HeaderSidebarCollapsiblePanel = class extends DialogElement {
    constructor() {
        super(),
        __privateAdd(this, _HeaderSidebarCollapsiblePanel_instances),
        __privateAdd(this, _sidebarDelegate, new Delegate8(this)),
        __privateGet(this, _sidebarDelegate).on("click", '[data-action="close-panel"]', __privateMethod(this, _HeaderSidebarCollapsiblePanel_instances, closePanel_fn).bind(this))
    }
    static get observedAttributes() {
        return [...super.observedAttributes, "aria-activedescendant"]
    }
    hideForOutsideClickTarget(e) {
        return !1
    }
    allowOutsideClickForTarget(e) {
        return e.closest(".header-sidebar") !== void 0
    }
    createEnterAnimationControls() {
        return matchesMediaQuery("md-max") ? timeline9([[this, {
            opacity: [0, 1],
            transform: "translateX(0)"
        }, {
            duration: .3
        }]]) : timeline9([[this, {
            opacity: [0, 1],
            transform: ["translateX(0)", "translateX(calc(var(--transform-logical-flip) * 100%)"]
        }, {
            duration: .3
        }]])
    }
    createLeaveAnimationControls() {
        return matchesMediaQuery("md-max") ? timeline9([[this, {
            opacity: [1, 0],
            transform: ["translateX(0)", "translateX(10px)"]
        }, {
            duration: .3
        }]]) : timeline9([[this, {
            opacity: [1, 0],
            transform: ["translateX(calc(var(--transform-logical-flip) * 100%))", "translateX(0)"]
        }, {
            duration: .3
        }]])
    }
    async attributeChangedCallback(e, t, i) {
        if (super.attributeChangedCallback(e, t, i),
        e === "aria-activedescendant") {
            if (t === i)
                return;
            i !== null ? __privateMethod(this, _HeaderSidebarCollapsiblePanel_instances, switchPanel_fn).call(this, this.querySelector(`#${t}`), this.querySelector(`#${i}`)) : (await this.hide(),
            Array.from(this.querySelectorAll(".header-sidebar__sub-panel")).forEach(e2 => e2.hidden = !0))
        }
    }
}
;
_sidebarDelegate = new WeakMap,
_HeaderSidebarCollapsiblePanel_instances = new WeakSet,
closePanel_fn = function() {
    this.removeAttribute("aria-activedescendant"),
    this.closest("header-sidebar").revealItems(!0)
}
,
switchPanel_fn = async function(e, t) {
    this.open || await this.show(),
    e && (await animate18(e, {
        opacity: [1, 0]
    }, {
        duration: .15
    }).finished,
    e.hidden = !0),
    t.hidden = !1;
    const i = matchesMediaQuery("md-max") ? ".header-sidebar__back-button, .header-sidebar__linklist li" : ".header-sidebar__linklist li";
    timeline9([[t, {
        opacity: 1
    }, {
        duration: 0
    }], [t.querySelectorAll(i), {
        opacity: [0, 1],
        transform: ["translateY(8px)", "translateY(0)"]
    }, {
        duration: .15,
        at: "-0.15",
        delay: window.themeVariables.settings.staggerMenuApparition ? stagger3(.1) : 0
    }], [t.querySelector(".header-sidebar__promo"), {
        opacity: [0, 1]
    }, {
        duration: .45
    }]])
}
,
window.customElements.get("x-header") || window.customElements.define("x-header", Header),
window.customElements.get("dropdown-menu-disclosure") || window.customElements.define("dropdown-menu-disclosure", DropdownMenuDisclosure),
window.customElements.get("mega-menu-disclosure") || window.customElements.define("mega-menu-disclosure", MegaMenuDisclosure),
window.customElements.get("header-search") || window.customElements.define("header-search", HeaderSearch),
window.customElements.get("header-sidebar") || window.customElements.define("header-sidebar", HeaderSidebar),
window.customElements.get("header-sidebar-collapsible-panel") || window.customElements.define("header-sidebar-collapsible-panel", HeaderSidebarCollapsiblePanel);
import {animate as animate19, inView as inView13} from "vendor";
var _preventInitialTransition2, _ImageWithTextOverlay_instances, onBecameVisible_fn2, ImageWithText = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ImageWithText_instances)
    }
    connectedCallback() {
        matchesMediaQuery("motion-safe") && inView13(this.querySelector('[reveal-on-scroll="true"]'), ({target: e}) => __privateMethod(this, _ImageWithText_instances, onBecameVisible_fn).call(this, e), {
            margin: "-200px 0px 0px 0px"
        })
    }
}
;
_ImageWithText_instances = new WeakSet,
onBecameVisible_fn = async function(e) {
    await imageLoaded(e);
    const t = (window.direction === "rtl" ? -1 : 1) * (matchesMediaQuery("md-max") ? .6 : 1) * (this.classList.contains("image-with-text--reverse") ? 25 : -25);
    animate19(e, {
        opacity: 1,
        transform: [`translateX(${t}px)`, "translateX(0)"]
    }, {
        easing: [.215, .61, .355, 1]
    }, {
        duration: .8
    })
}
,
window.customElements.get("image-with-text") || window.customElements.define("image-with-text", ImageWithText);
import {timeline as timeline10, inView as inView14} from "vendor";
var _itemElements, _imageElements, _textElements, _visibleImageElement, _ImagesWithTextScroll_instances, setupScrollObservers_fn, onBreakpointChanged_fn, ImageWithTextOverlay = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _ImageWithTextOverlay_instances),
        __privateAdd(this, _preventInitialTransition2, !1),
        Shopify.designMode && this.closest(".shopify-section").addEventListener("shopify:section:select", e => __privateSet(this, _preventInitialTransition2, e.detail.load))
    }
    connectedCallback() {
        matchesMediaQuery("motion-safe") && this.getAttribute("reveal-on-scroll") === "true" && inView14(this, ({target: e}) => __privateMethod(this, _ImageWithTextOverlay_instances, onBecameVisible_fn2).call(this, e), {
            amount: .05
        })
    }
}
;
_preventInitialTransition2 = new WeakMap,
_ImageWithTextOverlay_instances = new WeakSet,
onBecameVisible_fn2 = async function(e) {
    const t = e.querySelector(".content-over-media > picture img, .content-over-media > svg")
      , i = e.querySelector(".content-over-media > :not(picture, svg)");
    await imageLoaded(t);
    const n = timeline10([[e, {
        opacity: 1
    }], [t, {
        opacity: [0, 1],
        scale: [1.1, 1],
        easing: [.215, .61, .355, 1],
        duration: .8
    }], [i, {
        opacity: [0, 1],
        duration: .8
    }]]);
    __privateGet(this, _preventInitialTransition2) && n.finish()
}
,
window.customElements.get("image-with-text-overlay") || window.customElements.define("image-with-text-overlay", ImageWithTextOverlay);
import {timeline as timeline11, animate as animate20, inView as inView15, scroll as scroll2, ScrollOffset} from "vendor";
var ImagesWithTextScroll = class extends EffectCarousel {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ImagesWithTextScroll_instances),
        __privateAdd(this, _itemElements),
        __privateAdd(this, _imageElements),
        __privateAdd(this, _textElements),
        __privateAdd(this, _visibleImageElement)
    }
    connectedCallback() {
        super.connectedCallback(),
        __privateSet(this, _itemElements, Array.from(this.querySelectorAll(".images-with-text-scroll__item"))),
        __privateSet(this, _imageElements, Array.from(this.querySelectorAll(".images-with-text-scroll__image"))),
        __privateSet(this, _textElements, Array.from(this.querySelectorAll(".images-with-text-scroll__text"))),
        __privateSet(this, _visibleImageElement, __privateGet(this, _imageElements)[0]),
        inView15(this, () => {
            __privateGet(this, _imageElements).forEach(e => e.removeAttribute("loading"))
        }
        ),
        matchesMediaQuery("md") && __privateMethod(this, _ImagesWithTextScroll_instances, setupScrollObservers_fn).call(this),
        mediaQueryListener("md", __privateMethod(this, _ImagesWithTextScroll_instances, onBreakpointChanged_fn).bind(this))
    }
    get cellSelector() {
        return ".images-with-text-scroll__item"
    }
    get allowSwipe() {
        return matchesMediaQuery("md-max")
    }
    createOnChangeAnimationControls(e, t, {direction: i}={}) {
        let n = []
          , a = t.querySelector(".images-with-text-scroll__image");
        return a && a !== __privateGet(this, _visibleImageElement) && (n.push([__privateGet(this, _visibleImageElement), {
            opacity: [1, 0]
        }, {
            duration: .8,
            delay: .4
        }], [a, {
            opacity: [0, 1]
        }, {
            duration: .8,
            at: "<",
            delay: .4
        }]),
        __privateSet(this, _visibleImageElement, a)),
        timeline11([...n, [e.querySelector(".images-with-text-scroll__text"), {
            opacity: [1, 0],
            transform: ["translateY(0)", "translateY(-15px)"]
        }, {
            duration: .4,
            at: "<",
            easing: [.55, .055, .675, .19]
        }], [t.querySelector(".images-with-text-scroll__text"), {
            opacity: [0, 1],
            transform: ["translateY(15px)", "translateY(0)"]
        }, {
            duration: .4,
            at: "+0.4",
            easing: [.25, .46, .45, .94]
        }]])
    }
}
;
_itemElements = new WeakMap,
_imageElements = new WeakMap,
_textElements = new WeakMap,
_visibleImageElement = new WeakMap,
_ImagesWithTextScroll_instances = new WeakSet,
setupScrollObservers_fn = function() {
    __privateGet(this, _textElements).forEach(e => {
        scroll2(animate20(e, {
            opacity: [0, .25, 1, .25, 0]
        }), {
            target: e,
            offset: ScrollOffset.Any
        })
    }
    ),
    scroll2(e => {
        const t = Math.min(Math.floor(e.y.progress / (1 / __privateGet(this, _itemElements).length)), __privateGet(this, _itemElements).length - 1)
          , i = __privateGet(this, _itemElements)[t].querySelector(".images-with-text-scroll__image");
        i && i !== __privateGet(this, _visibleImageElement) && (timeline11([[__privateGet(this, _visibleImageElement), {
            opacity: [1, 0]
        }, {
            duration: .25
        }], [i, {
            opacity: [0, 1]
        }, {
            duration: .25,
            at: "<"
        }]]),
        __privateSet(this, _visibleImageElement, i))
    }
    , {
        target: this,
        offset: ["start center", "end center"]
    })
}
,
onBreakpointChanged_fn = function(e) {
    e.matches ? (__privateGet(this, _imageElements).forEach(e2 => e2.style = null),
    __privateGet(this, _textElements).forEach(e2 => e2.style = null),
    __privateMethod(this, _ImagesWithTextScroll_instances, setupScrollObservers_fn).call(this)) : this.getAnimations({
        subtree: !0
    }).forEach(e2 => e2.cancel())
}
,
window.customElements.get("images-with-text-scroll") || window.customElements.define("images-with-text-scroll", ImagesWithTextScroll);
import {scroll as scroll3} from "vendor";
var _MediaGrid_instances, onReveal_fn, ArticleToolbar = class extends HTMLElement {
    connectedCallback() {
        window.matchMedia("(prefers-reduced-motion: no-preference)").matches && scroll3(e => {
            this.classList.toggle("is-visible", e.y.progress > 0 && e.y.progress < 1)
        }
        , {
            target: this.closest(".shopify-section"),
            offset: ["100px start", "end start"]
        })
    }
}
;
window.customElements.get("article-toolbar") || window.customElements.define("article-toolbar", ArticleToolbar);
import {animate as animate21, inView as inView16} from "vendor";
var MediaGrid = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _MediaGrid_instances)
    }
    connectedCallback() {
        matchesMediaQuery("motion-safe") && inView16(this.querySelectorAll('[reveal-on-scroll="true"]'), __privateMethod(this, _MediaGrid_instances, onReveal_fn).bind(this), {
            margin: "-200px 0px 0px 0px"
        })
    }
}
;
_MediaGrid_instances = new WeakSet,
onReveal_fn = async function(e) {
    await imageLoaded(e.target.querySelector(":scope > img")),
    animate21(e.target, {
        opacity: [0, 1]
    }, {
        duration: .35,
        easing: "ease"
    })
}
,
window.customElements.get("media-grid") || window.customElements.define("media-grid", MediaGrid);
var _preventInitialTransition3, _MultipleMediaWithText_instances, onBecameVisible_fn3, MultiColumn = class extends HTMLElement {
    constructor() {
        super(),
        Shopify.designMode && this.addEventListener("shopify:block:select", e => {
            e.target.scrollIntoView({
                inline: "center",
                block: "nearest",
                behavior: e.detail.load ? "auto" : "smooth"
            })
        }
        )
    }
}
;
window.customElements.get("multi-column") || window.customElements.define("multi-column", MultiColumn);
import {timeline as timeline12, inView as inView17} from "vendor";
var MultipleMediaWithText = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _MultipleMediaWithText_instances),
        __privateAdd(this, _preventInitialTransition3, !1),
        Shopify.designMode && this.closest(".shopify-section").addEventListener("shopify:section:select", e => __privateSet(this, _preventInitialTransition3, e.detail.load))
    }
    connectedCallback() {
        matchesMediaQuery("motion-safe") && this.hasAttribute("reveal-on-scroll") && inView17(this, __privateMethod(this, _MultipleMediaWithText_instances, onBecameVisible_fn3).bind(this), {
            margin: "-10% 0px"
        })
    }
}
;
_preventInitialTransition3 = new WeakMap,
_MultipleMediaWithText_instances = new WeakSet,
onBecameVisible_fn3 = function() {
    const e = timeline12([[this, {
        opacity: 1
    }, {
        duration: 0
    }], "media", ...Array.from(this.querySelectorAll(".multiple-media-with-text__media-wrapper > *"), e2 => [e2, {
        opacity: [0, 1],
        transform: ["rotate(0deg)", `rotate(${e2.style.getPropertyValue("--media-rotate")})`]
    }, {
        duration: .5,
        at: "media"
    }]), [this.querySelector(".multiple-media-with-text__content-wrapper"), {
        opacity: [0, 1],
        transform: ["translateY(10px)", "translateY(0)"]
    }, {
        duration: .5
    }]]);
    __privateGet(this, _preventInitialTransition3) && e.finish()
}
,
window.customElements.get("multiple-media-with-text") || window.customElements.define("multiple-media-with-text", MultipleMediaWithText);
var _delegate7, _PrivacyBanner_instances, onConsentLibraryLoaded_fn, acceptPolicy_fn, declinePolicy_fn, NewsletterPopup = class extends PopIn {
    connectedCallback() {
        super.connectedCallback(),
        this.shouldAppearAutomatically && setTimeout( () => this.show(), this.apparitionDelay)
    }
    get apparitionDelay() {
        return 1e3 * parseInt(this.getAttribute("apparition-delay") || 0)
    }
    get shouldAppearAutomatically() {
        return !(localStorage.getItem("theme:popup-filled") === "true" || this.hasAttribute("only-once") && localStorage.getItem("theme:popup-appeared") === "true")
    }
    attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i),
        e === "open" && this.open && localStorage.setItem("theme:popup-appeared", "true")
    }
}
;
window.customElements.get("newsletter-popup") || window.customElements.define("newsletter-popup", NewsletterPopup);
import {Delegate as Delegate9} from "vendor";
var _intersectionObserver3, _formElement, _footerElement, _latestFooterCondition, _latestFormCondition, _ProductStickyBar_instances, onFormVisibilityChange_fn, PrivacyBanner = class extends PopIn {
    constructor() {
        super(),
        __privateAdd(this, _PrivacyBanner_instances),
        __privateAdd(this, _delegate7, new Delegate9(this)),
        window.Shopify.loadFeatures([{
            name: "consent-tracking-api",
            version: "0.1",
            onLoad: __privateMethod(this, _PrivacyBanner_instances, onConsentLibraryLoaded_fn).bind(this)
        }])
    }
    connectedCallback() {
        super.connectedCallback(),
        __privateGet(this, _delegate7).on("click", '[data-action="accept"]', __privateMethod(this, _PrivacyBanner_instances, acceptPolicy_fn).bind(this)),
        __privateGet(this, _delegate7).on("click", '[data-action="decline"]', __privateMethod(this, _PrivacyBanner_instances, declinePolicy_fn).bind(this))
    }
    disconnectedCallback() {
        __privateGet(this, _delegate7).off()
    }
}
;
_delegate7 = new WeakMap,
_PrivacyBanner_instances = new WeakSet,
onConsentLibraryLoaded_fn = function() {
    window.Shopify.customerPrivacy?.shouldShowBanner() && this.show()
}
,
acceptPolicy_fn = function() {
    window.Shopify.customerPrivacy?.setTrackingConsent(!0, this.hide.bind(this))
}
,
declinePolicy_fn = function() {
    window.Shopify.customerPrivacy?.setTrackingConsent(!1, this.hide.bind(this))
}
,
window.customElements.get("privacy-banner") || window.customElements.define("privacy-banner", PrivacyBanner);
var _isLoaded, _ProductRecommendations_instances, loadRecommendations_fn, ProductStickyBar = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ProductStickyBar_instances),
        __privateAdd(this, _intersectionObserver3, new IntersectionObserver(__privateMethod(this, _ProductStickyBar_instances, onFormVisibilityChange_fn).bind(this))),
        __privateAdd(this, _formElement),
        __privateAdd(this, _footerElement),
        __privateAdd(this, _latestFooterCondition, !1),
        __privateAdd(this, _latestFormCondition, !1)
    }
    connectedCallback() {
        __privateSet(this, _formElement, document.forms[this.getAttribute("form")]),
        __privateSet(this, _footerElement, document.querySelector(".shopify-section--footer")),
        __privateGet(this, _formElement) && (__privateGet(this, _intersectionObserver3).observe(__privateGet(this, _formElement)),
        __privateGet(this, _intersectionObserver3).observe(__privateGet(this, _footerElement)))
    }
    disconnectedCallback() {
        __privateGet(this, _intersectionObserver3).disconnect()
    }
}
;
_intersectionObserver3 = new WeakMap,
_formElement = new WeakMap,
_footerElement = new WeakMap,
_latestFooterCondition = new WeakMap,
_latestFormCondition = new WeakMap,
_ProductStickyBar_instances = new WeakSet,
onFormVisibilityChange_fn = function(e) {
    const [t,i] = [e.find(e2 => e2.target === __privateGet(this, _formElement)), e.find(e2 => e2.target === __privateGet(this, _footerElement))];
    t && __privateSet(this, _latestFormCondition, !t.isIntersecting && t.boundingClientRect.bottom < 0),
    i && __privateSet(this, _latestFooterCondition, !i.isIntersecting),
    this.classList.toggle("is-visible", __privateGet(this, _latestFooterCondition) && __privateGet(this, _latestFormCondition))
}
,
window.customElements.get("product-sticky-bar") || window.customElements.define("product-sticky-bar", ProductStickyBar);
var _abortController11, _QuickOrderList_instances, onQuantityChange_fn, onUpdate_fn, onQuantityUpdated_fn, ProductRecommendations = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _ProductRecommendations_instances),
        __privateAdd(this, _isLoaded, !1)
    }
    connectedCallback() {
        __privateMethod(this, _ProductRecommendations_instances, loadRecommendations_fn).call(this)
    }
}
;
_isLoaded = new WeakMap,
_ProductRecommendations_instances = new WeakSet,
loadRecommendations_fn = async function() {
    if (__privateGet(this, _isLoaded))
        return;
    __privateSet(this, _isLoaded, !0);
    const e = this.closest(".shopify-section")
      , t = this.getAttribute("intent") || "related"
      , i = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${extractSectionId(e)}&intent=${t}`
      , n = await fetch(i, {
        priority: t === "related" ? "low" : "auto"
    })
      , a = new DOMParser().parseFromString(await n.text(), "text/html").querySelector("product-recommendations");
    a.childElementCount > 0 ? (this.replaceChildren(...document.importNode(a, !0).childNodes),
    this.hidden = !1) : this.remove()
}
,
window.customElements.get("product-recommendations") || window.customElements.define("product-recommendations", ProductRecommendations);
var _QuickOrderListQuantitySelector_instances, onQuantityChange_fn2, onCartError_fn2, QuickOrderList = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _QuickOrderList_instances),
        __privateAdd(this, _abortController11),
        this.addEventListener("quick-order-list:update", __privateMethod(this, _QuickOrderList_instances, onUpdate_fn).bind(this)),
        this.addEventListener("change", __privateMethod(this, _QuickOrderList_instances, onQuantityChange_fn).bind(this))
    }
}
;
_abortController11 = new WeakMap,
_QuickOrderList_instances = new WeakSet,
onQuantityChange_fn = async function() {
    __privateGet(this, _abortController11)?.abort()
}
,
onUpdate_fn = async function(e) {
    let t = [extractSectionId(this)];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections",{
        bubbles: !0,
        detail: {
            sections: t
        }
    })),
    __privateSet(this, _abortController11, new AbortController);
    const i = e.target.closest(".quick-order-list__quantity-actions")?.querySelector(".quantity-selector__input-wrapper");
    i?.setAttribute("aria-busy", "true");
    try {
        const n = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: "POST",
            signal: __privateGet(this, _abortController11).signal,
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                updates: e.detail.updates,
                sections: t.join(",")
            })
        });
        if (i?.removeAttribute("aria-busy"),
        n.ok)
            setTimeout( () => {
                __privateMethod(this, _QuickOrderList_instances, onQuantityUpdated_fn).call(this, n)
            }
            , 250);
        else {
            const {message: t2} = await n.json();
            e.target.dispatchEvent(new CustomEvent("cart:error",{
                bubbles: !0,
                detail: {
                    message: t2
                }
            }))
        }
    } catch {}
}
,
onQuantityUpdated_fn = async function(e) {
    const t = await e.json()
      , i = extractSectionId(this);
    document.documentElement.dispatchEvent(new CustomEvent("cart:change",{
        bubbles: !0,
        detail: {
            baseEvent: "quick-order-list:add",
            cart: t
        }
    })),
    this.closest(".shopify-section").outerHTML = t.sections[i]
}
;
var _QuickOrderListRemoveVariant_instances, onClick_fn, QuickOrderListQuantitySelector = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _QuickOrderListQuantitySelector_instances),
        this.addEventListener("change", debounce(__privateMethod(this, _QuickOrderListQuantitySelector_instances, onQuantityChange_fn2).bind(this), 300)),
        this.addEventListener("cart:error", __privateMethod(this, _QuickOrderListQuantitySelector_instances, onCartError_fn2).bind(this))
    }
}
;
_QuickOrderListQuantitySelector_instances = new WeakSet,
onQuantityChange_fn2 = function(e) {
    this.dispatchEvent(new CustomEvent("quick-order-list:update",{
        bubbles: !0,
        detail: {
            updates: {
                [this.getAttribute("variant-id")]: parseInt(e.target.value)
            }
        }
    }))
}
,
onCartError_fn2 = function(e) {
    this.insertAdjacentHTML("afterend", `<p class="h-stack gap-2 justify-center text-xs" role="alert"><svg width="13" height="13" fill="none" viewBox="0 0 13 13">
        <circle cx="6.5" cy="6.5" r="6.5" fill="#BF1515"/>
        <path fill="#fff" d="M6.75 7.97a.387.387 0 0 1-.3-.12.606.606 0 0 1-.12-.34l-.3-3.82c-.02-.247.033-.443.16-.59.127-.153.313-.23.56-.23.24 0 .42.077.54.23.127.147.18.343.16.59l-.3 3.82a.522.522 0 0 1-.12.34.344.344 0 0 1-.28.12Zm0 2.08a.744.744 0 0 1-.55-.21.751.751 0 0 1-.2-.54c0-.213.067-.387.2-.52.14-.14.323-.21.55-.21.233 0 .413.07.54.21.133.133.2.307.2.52 0 .22-.067.4-.2.54-.127.14-.307.21-.54.21Z"/>
      </svg> ${e.detail.message}</p>`),
    this.querySelector("quantity-selector")?.restoreDefaultValue()
}
;
var _QuickOrderListRemoveAll_instances, onClick_fn2, QuickOrderListRemoveVariant = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _QuickOrderListRemoveVariant_instances),
        this.addEventListener("click", __privateMethod(this, _QuickOrderListRemoveVariant_instances, onClick_fn))
    }
}
;
_QuickOrderListRemoveVariant_instances = new WeakSet,
onClick_fn = function() {
    this.dispatchEvent(new CustomEvent("quick-order-list:update",{
        bubbles: !0,
        detail: {
            updates: {
                [this.getAttribute("variant-id")]: 0
            }
        }
    }))
}
;
var _isLoaded2, _RecentlyViewedProducts_instances, searchQueryString_get, loadProducts_fn, QuickOrderListRemoveAll = class extends HTMLElement {
    constructor() {
        super(),
        __privateAdd(this, _QuickOrderListRemoveAll_instances),
        this.addEventListener("click", __privateMethod(this, _QuickOrderListRemoveAll_instances, onClick_fn2))
    }
}
;
_QuickOrderListRemoveAll_instances = new WeakSet,
onClick_fn2 = function() {
    const e = JSON.parse(this.getAttribute("variant-ids")).reduce( (e2, t) => (e2[t] = 0,
    e2), {});
    this.dispatchEvent(new CustomEvent("quick-order-list:update",{
        bubbles: !0,
        detail: {
            updates: e
        }
    }))
}
,
window.customElements.get("quick-order-list") || window.customElements.define("quick-order-list", QuickOrderList),
window.customElements.get("quick-order-list-quantity-selector") || window.customElements.define("quick-order-list-quantity-selector", QuickOrderListQuantitySelector),
window.customElements.get("quick-order-list-remove-variant") || window.customElements.define("quick-order-list-remove-variant", QuickOrderListRemoveVariant),
window.customElements.get("quick-order-list-remove-all") || window.customElements.define("quick-order-list-remove-all", QuickOrderListRemoveAll);
var _controlledPopover, _selectedHotSpot, _ShopTheLookMobileCarousel_instances, setInitialPosition_fn, onSpotSelected_fn, onUpdateHotSpotPosition_fn, onLookChanged_fn, changeLookFocalPoint_fn, restorePosition_fn, RecentlyViewedProducts = class extends HTMLElement {
    constructor() {
        super(...arguments),
        __privateAdd(this, _RecentlyViewedProducts_instances),
        __privateAdd(this, _isLoaded2, !1)
    }
    connectedCallback() {
        __privateMethod(this, _RecentlyViewedProducts_instances, loadProducts_fn).call(this)
    }
}
;
_isLoaded2 = new WeakMap,
_RecentlyViewedProducts_instances = new WeakSet,
searchQueryString_get = function() {
    const e = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
    return this.hasAttribute("exclude-id") && e.delete(parseInt(this.getAttribute("exclude-id"))),
    Array.from(e.values(), e2 => `id:${e2}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ")
}
,
loadProducts_fn = async function() {
    if (__privateGet(this, _isLoaded2))
        return;
    __privateSet(this, _isLoaded2, !0);
    const e = this.closest(".shopify-section")
      , t = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _RecentlyViewedProducts_instances, searchQueryString_get)}&section_id=${extractSectionId(e)}`
      , i = await fetch(t, {
        priority: "low"
    })
      , n = new DOMParser().parseFromString(await i.text(), "text/html").querySelector("recently-viewed-products");
    n.childElementCount > 0 ? this.replaceChildren(...document.importNode(n, !0).childNodes) : e.remove()
}
,
window.customElements.get("recently-viewed-products") || window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
import {animate as animate22, timeline as timeline13} from "vendor";
var _ShopTheLookProductListCarousel_instances, updateButtonLink_fn, ShopTheLookMobileCarousel = class extends ScrollCarousel {
    constructor() {
        super(),
        __privateAdd(this, _ShopTheLookMobileCarousel_instances),
        __privateAdd(this, _controlledPopover),
        __privateAdd(this, _selectedHotSpot),
        this.addEventListener("carousel:change", __privateMethod(this, _ShopTheLookMobileCarousel_instances, onLookChanged_fn)),
        Array.from(this.querySelectorAll(".shop-the-look__hot-spot-list")).forEach(e => {
            e.carousel.addEventListener("carousel:select", __privateMethod(this, _ShopTheLookMobileCarousel_instances, onSpotSelected_fn).bind(this)),
            e.carousel.addEventListener("carousel:change", () => __privateMethod(this, _ShopTheLookMobileCarousel_instances, onUpdateHotSpotPosition_fn).call(this, e))
        }
        ),
        Array.from(this.querySelectorAll(".shop-the-look__popover")).forEach(e => {
            e.addEventListener("dialog:before-show", __privateMethod(this, _ShopTheLookMobileCarousel_instances, changeLookFocalPoint_fn).bind(this)),
            e.addEventListener("dialog:before-hide", __privateMethod(this, _ShopTheLookMobileCarousel_instances, restorePosition_fn).bind(this))
        }
        )
    }
    connectedCallback() {
        super.connectedCallback(),
        __privateMethod(this, _ShopTheLookMobileCarousel_instances, setInitialPosition_fn).call(this)
    }
    get isExpanded() {
        return this.classList.contains("is-expanded")
    }
}
;
_controlledPopover = new WeakMap,
_selectedHotSpot = new WeakMap,
_ShopTheLookMobileCarousel_instances = new WeakSet,
setInitialPosition_fn = function() {
    __privateSet(this, _selectedHotSpot, this.selectedCell.querySelector('.shop-the-look__hot-spot[aria-current="true"]')),
    __privateMethod(this, _ShopTheLookMobileCarousel_instances, onLookChanged_fn).call(this)
}
,
onSpotSelected_fn = function() {
    this.isExpanded || document.getElementById(this.selectedCell.getAttribute("data-popover-id")).show()
}
,
onUpdateHotSpotPosition_fn = function(e) {
    __privateSet(this, _selectedHotSpot, e.querySelector('.shop-the-look__hot-spot[aria-current="true"]')),
    this.isExpanded && __privateMethod(this, _ShopTheLookMobileCarousel_instances, changeLookFocalPoint_fn).call(this)
}
,
onLookChanged_fn = function() {
    const e = this.selectedCell.getAttribute("data-popover-id");
    __privateSet(this, _controlledPopover, document.getElementById(e)),
    this.nextElementSibling.setAttribute("aria-controls", e)
}
,
changeLookFocalPoint_fn = function() {
    const e = window.innerWidth / this.selectedCell.clientWidth
      , t = window.innerHeight - __privateGet(this, _controlledPopover).shadowRoot.querySelector('[part="base"]').clientHeight
      , i = Math.round(this.selectedCell.querySelector(".shop-the-look__image-wrapper").clientHeight * e)
      , n = Math.max(i - t, 0)
      , a = i - n
      , s = Math.round((__privateGet(this, _selectedHotSpot).offsetTop + __privateGet(this, _selectedHotSpot).clientHeight / 2) * e)
      , r = Math.round(s - a / 2)
      , o = Math.round(-(this.parentElement.getBoundingClientRect().top - (i - this.selectedCell.offsetHeight) / 2))
      , l = Math.round(o - n)
      , c = Math.min(Math.max(o - r, l), o);
    this.isExpanded ? animate22(this, {
        transform: `translateY(${c}px) scale(${e})`
    }, {
        duration: .4,
        easing: "ease-in-out"
    }) : (animate22(this, {
        transform: ["translateY(0) scale(1)", `translateY(${c}px) scale(${e})`]
    }, {
        duration: .4,
        easing: [.645, .045, .355, 1]
    }),
    document.documentElement.style.setProperty("--hide-header-group", "1")),
    this.classList.add("is-expanded")
}
,
restorePosition_fn = function() {
    animate22(this, {
        transform: "translateY(0) scale(1)"
    }, {
        duration: .4,
        easing: [.645, .045, .355, 1]
    }).finished.then( () => {
        this.style.transform = null
    }
    ),
    this.classList.remove("is-expanded"),
    document.documentElement.style.removeProperty("--hide-header-group")
}
;
var ShopTheLookProductListCarousel = class extends EffectCarousel {
    constructor() {
        super(),
        __privateAdd(this, _ShopTheLookProductListCarousel_instances),
        this.addEventListener("carousel:change", __privateMethod(this, _ShopTheLookProductListCarousel_instances, updateButtonLink_fn).bind(this))
    }
}
;
_ShopTheLookProductListCarousel_instances = new WeakSet,
updateButtonLink_fn = function(e) {
    const t = e.detail.cell.querySelector(".product-card");
    t.hasAttribute("handle") && (this.nextElementSibling.href = `${Shopify.routes.root}products/${t.getAttribute("handle")}`)
}
;
var _delegate8, _onVideoEndedListener, _SlideshowCarousel_instances, autoplayPauseOnVideo_get, getSlideEnteringSequence_fn, getSlideLeavingSequence_fn, muteVideo_fn, unmuteVideo_fn, onVolumeChange_fn, onSlideSettle_fn, onVideoEnded_fn, onNextButtonClicked_fn, handleAutoplayProgress_fn, ShopTheLookDesktopCarousel = class extends EffectCarousel {
    createOnBecameVisibleAnimationControls(e) {
        return animate22(e.querySelectorAll(".shop-the-look__item-content"), {
            opacity: [0, 1],
            transform: ["translateY(10px)", "translateY(0)"]
        }, {
            duration: .5
        })
    }
    createOnChangeAnimationControls(e, t) {
        return timeline13([[e.querySelectorAll(".shop-the-look__item-content"), {
            opacity: [1, 0]
        }, {
            duration: .3
        }], [e.querySelectorAll(".shop-the-look__image-wrapper > *"), {
            opacity: [1, 0],
            transform: ["translateX(0)", "translateX(-15px)"]
        }, {
            duration: .5,
            at: "<",
            easing: [.645, .045, .355, 1]
        }], [t.querySelectorAll(".shop-the-look__image-wrapper > *"), {
            opacity: [0, 1],
            transform: ["translateX(-15px)", "translateX(0)"]
        }, {
            duration: .5,
            at: "<"
        }], [t.querySelectorAll(".shop-the-look__item-content"), {
            opacity: [0, 1],
            transform: ["translateY(10px)", "translateY(0)"]
        }, {
            duration: .5,
            at: "-0.1"
        }]])
    }
}
, ShopTheLookPopover = class extends Popover {
    hideForOutsideClickTarget(e) {
        return !1
    }
    allowOutsideClickForTarget(e) {
        return e.classList.contains("shop-the-look__hot-spot")
    }
}
;
window.customElements.get("shop-the-look-mobile-carousel") || window.customElements.define("shop-the-look-mobile-carousel", ShopTheLookMobileCarousel),
window.customElements.get("shop-the-look-product-list-carousel") || window.customElements.define("shop-the-look-product-list-carousel", ShopTheLookProductListCarousel),
window.customElements.get("shop-the-look-desktop-carousel") || window.customElements.define("shop-the-look-desktop-carousel", ShopTheLookDesktopCarousel),
window.customElements.get("shop-the-look-popover") || window.customElements.define("shop-the-look-popover", ShopTheLookPopover);
import {timeline as timeline14, Delegate as Delegate10} from "vendor";
var SlideshowCarousel = class extends EffectCarousel {
    constructor() {
        super(),
        __privateAdd(this, _SlideshowCarousel_instances),
        __privateAdd(this, _delegate8, new Delegate10(this)),
        __privateAdd(this, _onVideoEndedListener, __privateMethod(this, _SlideshowCarousel_instances, onVideoEnded_fn).bind(this)),
        __privateGet(this, _delegate8).on("click", '[data-action="navigate-next"]', __privateMethod(this, _SlideshowCarousel_instances, onNextButtonClicked_fn).bind(this)),
        __privateGet(this, _delegate8).on("click", '[data-action="unmute"]', __privateMethod(this, _SlideshowCarousel_instances, unmuteVideo_fn).bind(this)),
        __privateGet(this, _delegate8).on("click", '[data-action="mute"]', __privateMethod(this, _SlideshowCarousel_instances, muteVideo_fn).bind(this)),
        this.addEventListener("volumechange", __privateMethod(this, _SlideshowCarousel_instances, onVolumeChange_fn), {
            capture: !0
        }),
        this.addEventListener("carousel:settle", __privateMethod(this, _SlideshowCarousel_instances, onSlideSettle_fn)),
        this.hasAttribute("autoplay") && this.player && (this.player.addEventListener("player:start", __privateMethod(this, _SlideshowCarousel_instances, handleAutoplayProgress_fn).bind(this)),
        this.player.addEventListener("player:stop", __privateMethod(this, _SlideshowCarousel_instances, handleAutoplayProgress_fn).bind(this)),
        this.player.addEventListener("player:visibility-pause", __privateMethod(this, _SlideshowCarousel_instances, handleAutoplayProgress_fn).bind(this)),
        this.player.addEventListener("player:visibility-resume", __privateMethod(this, _SlideshowCarousel_instances, handleAutoplayProgress_fn).bind(this)))
    }
    disconnectedCallback() {
        __privateGet(this, _delegate8).destroy()
    }
    async createOnBecameVisibleAnimationControls(e) {
        return e.getAttribute("media-type") === "image" ? await imageLoaded(e.querySelectorAll("img")) : await videoLoaded(e.querySelectorAll("video")),
        e.hasAttribute("reveal-on-scroll") ? timeline14([...__privateMethod(this, _SlideshowCarousel_instances, getSlideEnteringSequence_fn).call(this, e)]) : {
            finished: Promise.resolve()
        }
    }
    createOnChangeAnimationControls(e, t, {direction: i}={}) {
        const n = Array.from(e.querySelectorAll("video"))
          , a = Array.from(t.querySelectorAll("video")).filter(e2 => e2.offsetParent);
        return e.removeEventListener("ended", __privateGet(this, _onVideoEndedListener), {
            capture: !0
        }),
        n.forEach(e2 => {
            e2.muted = !0,
            e2.pause()
        }
        ),
        a.forEach(e2 => {
            e2.muted = !0,
            e2.currentTime = 0,
            e2.play()
        }
        ),
        {
            leaveControls: () => timeline14(__privateMethod(this, _SlideshowCarousel_instances, getSlideLeavingSequence_fn).call(this, e)),
            enterControls: () => timeline14(__privateMethod(this, _SlideshowCarousel_instances, getSlideEnteringSequence_fn).call(this, t))
        }
    }
}
;
_delegate8 = new WeakMap,
_onVideoEndedListener = new WeakMap,
_SlideshowCarousel_instances = new WeakSet,
autoplayPauseOnVideo_get = function() {
    return this.hasAttribute("autoplay-pause-on-video")
}
,
getSlideEnteringSequence_fn = function(e) {
    const t = e.querySelector(".slideshow__slide-content");
    return t.classList.contains("slideshow__slide-content--boxed") ? [[e, {
        opacity: [0, 1]
    }, {
        duration: .8,
        easing: [.25, .46, .45, .94]
    }], [e.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), {
        opacity: [0, 1],
        transform: ["scale(1.2)", "scale(1)"]
    }, {
        duration: .8,
        at: "<",
        easing: [.25, .46, .45, .94]
    }], [t, {
        opacity: [0, 1],
        transform: ["translateY(30px)", "translateY(0)"]
    }, {
        duration: .6,
        at: "-0.4",
        easing: [.215, .61, .355, 1]
    }]] : [[e, {
        opacity: [0, 1]
    }, {
        duration: .8,
        easing: [.25, .46, .45, .94]
    }], [e.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), {
        opacity: [0, 1],
        transform: ["scale(1.2)", "scale(1)"]
    }, {
        duration: .8,
        at: "<",
        easing: [.25, .46, .45, .94]
    }], [t.querySelector(".prose"), {
        opacity: [0, 1],
        transform: ["translateY(30px)", "translateY(0)"]
    }, {
        duration: .6,
        at: "-0.4",
        easing: [.215, .61, .355, 1]
    }], [t.querySelector(".button-group"), {
        opacity: [0, 1],
        transform: ["translateY(20px)", "translateY(0)"]
    }, {
        duration: .6,
        at: "-0.4",
        easing: [.215, .61, .355, 1]
    }]]
}
,
getSlideLeavingSequence_fn = function(e) {
    const t = e.querySelector(".slideshow__slide-content");
    return t.classList.contains("slideshow__slide-content--boxed") ? [[t, {
        opacity: [1, 0],
        transform: ["translateY(0)", "translateY(20px)"]
    }, {
        duration: .25,
        at: "leaving",
        easing: [.55, .055, .675, .19]
    }], [e.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), {
        opacity: [1, 0]
    }, {
        duration: .2,
        at: "-0.1",
        easing: [.55, .055, .675, .19]
    }]] : [[t.querySelector(".prose"), {
        opacity: [1, 0],
        transform: ["translateY(0)", "translateY(10px)"]
    }, {
        duration: .25,
        at: "leaving",
        easing: [.55, .055, .675, .19]
    }], [t.querySelector(".button-group"), {
        opacity: [1, 0],
        transform: ["translateY(0)", "translateY(20px)"]
    }, {
        duration: .25,
        at: "<",
        easing: [.55, .055, .675, .19]
    }], [e.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), {
        opacity: [1, 0]
    }, {
        duration: .2,
        at: "-0.1",
        easing: [.55, .055, .675, .19]
    }]]
}
,
muteVideo_fn = function(e) {
    e.preventDefault(),
    Array.from(this.selectedCell.querySelectorAll("video")).filter(e2 => e2.offsetParent).forEach(e2 => e2.muted = !0)
}
,
unmuteVideo_fn = function(e) {
    e.preventDefault(),
    Array.from(this.selectedCell.querySelectorAll("video")).filter(e2 => e2.offsetParent).forEach(e2 => e2.muted = !1)
}
,
onVolumeChange_fn = function(e) {
    const t = e.target.closest(".slideshow__slide").querySelector(".slideshow__volume-control");
    t && (t.querySelector('[data-action="unmute"]').hidden = !e.target.muted,
    t.querySelector('[data-action="mute"]').hidden = e.target.muted)
}
,
onSlideSettle_fn = function(e) {
    const t = Array.from(e.detail.cell.querySelectorAll("video"));
    __privateGet(this, _SlideshowCarousel_instances, autoplayPauseOnVideo_get) && this.cells.length > 1 && t.length > 0 && (this.player?.pause(),
    e.detail.cell.addEventListener("ended", __privateGet(this, _onVideoEndedListener), {
        capture: !0,
        once: !0
    }))
}
,
onVideoEnded_fn = function() {
    this.next()
}
,
onNextButtonClicked_fn = function() {
    this.closest(".shopify-section").nextElementSibling?.scrollIntoView({
        block: "start",
        behavior: "smooth"
    })
}
,
handleAutoplayProgress_fn = async function(e) {
    switch (e.type) {
    case "player:start":
        let e2 = this.getAttribute("autoplay");
        if (__privateGet(this, _SlideshowCarousel_instances, autoplayPauseOnVideo_get) && this.selectedCell.getAttribute("media-type") === "video") {
            const t = Array.from(this.selectedCell.querySelectorAll("video")).filter(e3 => e3.offsetParent).pop();
            isNaN(t.duration) && await new Promise(e3 => {
                t.onloadedmetadata = () => e3()
            }
            ),
            e2 = t.duration
        }
        this.style.setProperty("--slideshow-progress-duration", `${e2}s`),
        this.style.setProperty("--slideshow-progress-play-state", "running");
        break;
    case "player:stop":
        this.style.setProperty("--slideshow-progress-duration", "0s"),
        this.style.setProperty("--slideshow-progress-play-state", "paused");
        break;
    case "player:visibility-pause":
        this.style.setProperty("--slideshow-progress-play-state", "paused");
        break;
    case "player:visibility-resume":
        this.style.setProperty("--slideshow-progress-play-state", "running")
    }
}
,
window.customElements.get("slideshow-carousel") || window.customElements.define("slideshow-carousel", SlideshowCarousel);
import {animate as animate23} from "vendor";
var TestimonialCarousel = class extends EffectCarousel {
    createOnChangeAnimationControls(e, t, {direction: i}) {
        return {
            leaveControls: () => animate23(e, {
                opacity: [1, 0],
                transform: ["translateY(0)", "translateY(-15px)"]
            }, {
                duration: .4,
                easing: [.55, .055, .675, .19]
            }),
            enterControls: () => animate23(t, {
                opacity: [0, 1],
                transform: ["translateY(15px)", "translateY(0)"]
            }, {
                duration: .4,
                delay: 0,
                easing: [.25, .46, .45, .94]
            })
        }
    }
}
;
window.customElements.get("testimonial-carousel") || window.customElements.define("testimonial-carousel", TestimonialCarousel);
import {animate as animate24} from "vendor";
var TextWithIconsCarousel = class extends EffectCarousel {
    createOnChangeAnimationControls(e, t) {
        return {
            leaveControls: () => animate24(e, {
                opacity: [1, 0],
                transform: ["translateY(0)", "translateY(-10px)"]
            }, {
                duration: .3,
                easing: "ease-in"
            }),
            enterControls: () => animate24(t, {
                opacity: [0, 1],
                transform: ["translateY(10px)", "translateY(0px)"]
            }, {
                duration: .3,
                delay: .2,
                easing: "ease-out"
            })
        }
    }
}
;
window.customElements.get("text-with-icons-carousel") || window.customElements.define("text-with-icons-carousel", TextWithIconsCarousel);
import {animate as animate25, timeline as timeline15} from "vendor";
var TimelineCarousel = class extends EffectCarousel {
    createOnBecameVisibleAnimationControls(e) {
        return animate25(e.querySelectorAll(".timeline__item-content"), {
            opacity: [0, 1],
            transform: ["translateY(10px)", "translateY(0)"]
        }, {
            duration: .5
        })
    }
    createOnChangeAnimationControls(e, t) {
        return timeline15([[e.querySelectorAll(".timeline__item-content"), {
            opacity: [1, 0]
        }, {
            duration: .3
        }], [e.querySelector(".timeline__item-image-wrapper :is(img, svg)"), {
            opacity: [1, 0],
            transform: ["translateX(0)", "translateX(-15px)"]
        }, {
            duration: .5,
            at: "<",
            easing: [.645, .045, .355, 1]
        }], [t.querySelector(".timeline__item-image-wrapper :is(img, svg)"), {
            opacity: [0, 1],
            transform: ["translateX(-15px)", "translateX(0)"]
        }, {
            duration: .5,
            at: "<"
        }], [t.querySelectorAll(".timeline__item-content"), {
            opacity: [0, 1],
            transform: ["translateY(10px)", "translateY(0)"]
        }, {
            duration: .5,
            at: "-0.1"
        }]])
    }
}
;
window.customElements.get("timeline-carousel") || window.customElements.define("timeline-carousel", TimelineCarousel);
import {Delegate as Delegate11} from "vendor";
new Delegate11(document.documentElement).on("click", 'a[href*="#"]', (e, t) => {
    if (e.defaultPrevented || t.matches("[allow-hash-change]") || t.pathname !== window.location.pathname || t.search !== window.location.search)
        return;
    const i = new URL(t.href);
    if (i.hash === "")
        return;
    const n = document.querySelector(i.hash);
    n && (e.preventDefault(),
    n.scrollIntoView({
        block: "start",
        behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto"
    }),
    document.documentElement.dispatchEvent(new CustomEvent("hashchange:simulate",{
        bubbles: !0,
        detail: {
            hash: i.hash
        }
    })))
}
),
navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && (document.head.querySelector('meta[name="viewport"]').content = "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0"),
Array.from(document.querySelectorAll(".prose table")).forEach(e => {
    e.outerHTML = '<div class="table-scroller">' + e.outerHTML + "</div>"
}
);
export {AccordionDisclosure, AccountLogin, AnnouncementBarCarousel, ArticleToolbar, BeforeAfter, BlogPosts, BuyButtons, CarouselNavigation, CarouselNextButton, CarouselPrevButton, CartCount, CartDot, CartDrawer, CartNote, CollectionBanner, CollectionLayoutSwitch, ConfirmButton, CopyButton, CountdownTimer, CountdownTimerFlip, CountdownTimerFlipDigit, CountrySelector, CustomDetails, DialogCloseButton, DialogElement, Drawer, EffectCarousel, FacetLink, FacetsDrawer, FacetsForm, FacetsSortPopover, FaqToc, FeaturedCollectionsCarousel, FreeShippingBar, GestureArea, GiftCardRecipient, Header, HeightObserver, ImageParallax, ImageWithText, ImageWithTextOverlay, ImagesWithTextScroll, LineItemQuantity, Listbox, LoadingBar, MarqueeText, MediaGrid, MenuDisclosure, Modal, ModelMedia, MultiColumn, MultipleMediaWithText, NewsletterPopup, OpenLightBoxButton, Player, PopIn, Popover, PredictiveSearch, PriceRange, PrivacyBanner, ProductCard, ProductForm, ProductGallery, ProductGalleryNavigation, ProductList, ProductLoader, ProductRecommendations, ProductRerender, ProductStickyBar, ProgressBar, QrCode, QuantityInput, QuantitySelector, QuickBuyModal, QuickOrderList, RecentlyViewedProducts, SafeSticky, ScrollCarousel, ShareButton, ShippingEstimator, ShopTheLookDesktopCarousel, ShopTheLookMobileCarousel, ShopTheLookPopover, ShopTheLookProductListCarousel, SlideshowCarousel, Tabs, TestimonialCarousel, TextWithIconsCarousel, TimelineCarousel, VariantPicker, VideoMedia, cachedFetch, createMediaImg, debounce, deepQuerySelector, extractSectionId, fetchCart, generateSrcset, imageLoaded, matchesMediaQuery, mediaQueryListener, throttle, videoLoaded, waitForEvent};
